export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Arbitrary JSON value */
  JSON: { input: any; output: any };
  Long: { input: any; output: any };
};

/** Result of a club activation attempt */
export type ActivateClubResult = {
  __typename: "ActivateClubResult";
  clubShortName?: Maybe<Scalars["String"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

/** Member activity level based on recency of attendance or participation */
export enum ActivityLevel {
  /** No activity in 6+ months */
  Dormant = "DORMANT",
  /** Active within last 3 months */
  Frequent = "FREQUENT",
  /** Active 3-6 months ago */
  Infrequent = "INFREQUENT",
}

/** A paginated list of club activity entries */
export type ActivityLogConnection = {
  __typename: "ActivityLogConnection";
  /** The activity entries on this page */
  entries: Array<ClubActivityEntry>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Total number of activity entries */
  totalCount: Scalars["Int"]["output"];
};

/** Canonical voting candidate returned by addCandidate */
export type AddCandidateData = {
  __typename: "AddCandidateData";
  /** The canonical voting candidate */
  candidate: VoteCandidate;
};

/** Result of a AddCandidate mutation */
export type AddCandidateResult = {
  __typename: "AddCandidateResult";
  /** The AddCandidate data if successful */
  data?: Maybe<AddCandidateData>;
  /** Machine-readable code identifying the failure outcome */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable result message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Whether the mutation succeeded */
  success: Scalars["Boolean"]["output"];
};

/** Canonical feedback subject returned by addFeedbackSubject */
export type AddFeedbackSubjectData = {
  __typename: "AddFeedbackSubjectData";
  /** Whether a new feedback subject was created */
  created: Scalars["Boolean"]["output"];
  /** The canonical feedback subject */
  subject: FeedbackSubject;
};

/** Result of a AddFeedbackSubject mutation */
export type AddFeedbackSubjectResult = {
  __typename: "AddFeedbackSubjectResult";
  /** The AddFeedbackSubject data if successful */
  data?: Maybe<AddFeedbackSubjectData>;
  /** Machine-readable code identifying the failure outcome */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable result message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Whether the mutation succeeded */
  success: Scalars["Boolean"]["output"];
};

/** Result of an admin action */
export type AdminActionResult = {
  __typename: "AdminActionResult";
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

/** Agent GraphQL token panel state (retired: always disabled and empty) */
export type AdminAgentTokenSettings = {
  __typename: "AdminAgentTokenSettings";
  enabled: Scalars["Boolean"]["output"];
  tokens: Array<AdminAgentTokenSummary>;
  ttlSeconds: Scalars["Long"]["output"];
};

/** A minted agent GraphQL token (retired, never returned) */
export type AdminAgentTokenSummary = {
  __typename: "AdminAgentTokenSummary";
  createdAt: Scalars["String"]["output"];
  createdByEmail: Scalars["String"]["output"];
  expiresAt: Scalars["String"]["output"];
  id: Scalars["Long"]["output"];
  label: Scalars["String"]["output"];
  live: Scalars["Boolean"]["output"];
  revokedAt?: Maybe<Scalars["String"]["output"]>;
};

/** One EasySpeak archive import job, running or finished */
export type AdminArchiveImportJob = {
  __typename: "AdminArchiveImportJob";
  clubId: Scalars["Int"]["output"];
  dryRun: Scalars["Boolean"]["output"];
  durationMillis?: Maybe<Scalars["Long"]["output"]>;
  easySpeakClubId: Scalars["Int"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
  instance: Scalars["String"]["output"];
  jobId: Scalars["String"]["output"];
  maxDate?: Maybe<Scalars["String"]["output"]>;
  refusals: Array<AdminArchiveImportRefusal>;
  refusalsTruncated: Scalars["Boolean"]["output"];
  state: AdminArchiveImportJobState;
  submittedAt: Scalars["String"]["output"];
  submittedByEmail: Scalars["String"]["output"];
  summary?: Maybe<AdminArchiveImportSummary>;
  warnings: Array<Scalars["String"]["output"]>;
  warningsTruncated: Scalars["Boolean"]["output"];
};

/** Where an EasySpeak archive import job has got to */
export enum AdminArchiveImportJobState {
  /** The import refused the club or threw */
  Failed = "FAILED",
  /** The import is still running */
  Running = "RUNNING",
  /** The import finished, possibly refusing some pages */
  Succeeded = "SUCCEEDED",
}

/** A captured page an archive import refused, and why */
export type AdminArchiveImportRefusal = {
  __typename: "AdminArchiveImportRefusal";
  easySpeakMeetingId: Scalars["Int"]["output"];
  reason: Scalars["String"]["output"];
};

/** What a finished EasySpeak archive import did */
export type AdminArchiveImportSummary = {
  __typename: "AdminArchiveImportSummary";
  attendanceRows: Scalars["Int"]["output"];
  considered: Scalars["Int"]["output"];
  meetingsWritten: Scalars["Int"]["output"];
  parsed: Scalars["Int"]["output"];
  refused: Scalars["Int"]["output"];
  roleAssignments: Scalars["Int"]["output"];
  stamped: Scalars["Int"]["output"];
  usersTotal: Scalars["Int"]["output"];
  usersUnmatched: Scalars["Int"]["output"];
};

/** What a manual EasySpeak auto-stage run did with one club */
export type AdminAutoStageClubOutcome = {
  __typename: "AdminAutoStageClubOutcome";
  clubId: Scalars["Int"]["output"];
  easySpeakClubId: Scalars["Int"]["output"];
  instance: Scalars["String"]["output"];
  jobId?: Maybe<Scalars["String"]["output"]>;
  outcome: AdminAutoStageOutcomeKind;
  reason?: Maybe<Scalars["String"]["output"]>;
};

/** What the next EasySpeak auto-stage run would decide for one mapped club */
export enum AdminAutoStageDecision {
  /** Every waiting capture was refused on its bytes by an earlier run in this process */
  AllRefused = "ALL_REFUSED",
  /** No capture is waiting */
  NothingWaiting = "NOTHING_WAITING",
  /** Another mapped club records the same EasySpeak club */
  SharedPair = "SHARED_PAIR",
  /** Captures are waiting and would be submitted */
  Submit = "SUBMIT",
  /** The capture index could not be read */
  Unreadable = "UNREADABLE",
}

/** What a manual EasySpeak auto-stage run did with one club */
export enum AdminAutoStageOutcomeKind {
  /** The club failed; `reason` says why */
  Failed = "FAILED",
  /** The club was skipped; `reason` says why */
  Skipped = "SKIPPED",
  /** An import was staged; `jobId` names it */
  Staged = "STAGED",
  /** Nothing was waiting */
  UpToDate = "UP_TO_DATE",
}

/** Which mapped clubs the EasySpeak auto-stage sweep would submit now (admin only) */
export type AdminAutoStagePreview = {
  __typename: "AdminAutoStagePreview";
  clubs: Array<AdminAutoStagePreviewClub>;
  running?: Maybe<Scalars["String"]["output"]>;
  scheduledEnabled: Scalars["Boolean"]["output"];
  scheduledOperatorProblem?: Maybe<Scalars["String"]["output"]>;
};

/** What the next EasySpeak auto-stage run would decide for one mapped club */
export type AdminAutoStagePreviewClub = {
  __typename: "AdminAutoStagePreviewClub";
  clubId: Scalars["Int"]["output"];
  clubName?: Maybe<Scalars["String"]["output"]>;
  decision: AdminAutoStageDecision;
  easySpeakClubId: Scalars["Int"]["output"];
  instance: Scalars["String"]["output"];
  reason?: Maybe<Scalars["String"]["output"]>;
  waiting: Scalars["Int"]["output"];
};

/** A manual EasySpeak auto-stage run, running or finished */
export type AdminAutoStageRun = {
  __typename: "AdminAutoStageRun";
  /** The clubs the admin chose, or empty when the run was not limited to chosen clubs */
  clubIds: Array<Scalars["Int"]["output"]>;
  error?: Maybe<Scalars["String"]["output"]>;
  finishedAt?: Maybe<Scalars["String"]["output"]>;
  instance?: Maybe<Scalars["String"]["output"]>;
  maxClubs?: Maybe<Scalars["Int"]["output"]>;
  outcomes: Array<AdminAutoStageClubOutcome>;
  requestedByEmail: Scalars["String"]["output"];
  /** How many mapped clubs the instance and club choices matched */
  selected: Scalars["Int"]["output"];
  startedAt: Scalars["String"]["output"];
  state: AdminAutoStageRunState;
  summary?: Maybe<AdminAutoStageSummary>;
};

/** Where a manual EasySpeak auto-stage run has got to */
export enum AdminAutoStageRunState {
  /** The run stopped on an error; `error` says what */
  Failed = "FAILED",
  /** The run finished */
  Finished = "FINISHED",
  /** The run is still going */
  Running = "RUNNING",
}

/** The counts of a finished EasySpeak auto-stage run */
export type AdminAutoStageSummary = {
  __typename: "AdminAutoStageSummary";
  considered: Scalars["Int"]["output"];
  failed: Scalars["Int"]["output"];
  skipped: Scalars["Int"]["output"];
  staged: Scalars["Int"]["output"];
  submitted: Scalars["Int"]["output"];
  upToDate: Scalars["Int"]["output"];
};

/** Capture progress for one EasySpeak instance */
export type AdminCaptureInstanceStatus = {
  __typename: "AdminCaptureInstanceStatus";
  /** Whether the archive's mount marker file is present, or null when none is configured. False means every capture write is refused. True does not prove the volume is mounted. */
  archiveMarkerPresent?: Maybe<Scalars["Boolean"]["output"]>;
  captured: Scalars["Int"]["output"];
  clubListReadAt?: Maybe<Scalars["String"]["output"]>;
  clubsKnown: Scalars["Int"]["output"];
  clubsSeeded: Scalars["Int"]["output"];
  distinctClubs: Scalars["Int"]["output"];
  error: Scalars["Int"]["output"];
  host: Scalars["String"]["output"];
  lastCapturedAt?: Maybe<Scalars["String"]["output"]>;
  missing: Scalars["Int"]["output"];
  notFound: Scalars["Int"]["output"];
  pending: Scalars["Int"]["output"];
  totalBytes: Scalars["Long"]["output"];
};

/** EasySpeak capture configuration, per-instance progress and recent sessions (admin only) */
export type AdminCaptureSettings = {
  __typename: "AdminCaptureSettings";
  archiveImportJobs: Array<AdminArchiveImportJob>;
  autoStageLastRun?: Maybe<AdminAutoStageRun>;
  enabled: Scalars["Boolean"]["output"];
  instances: Array<AdminCaptureInstanceStatus>;
  maxBytes: Scalars["Long"]["output"];
  maxPages: Scalars["Int"]["output"];
  tokens: Array<AdminCaptureTokenSummary>;
  ttlSeconds: Scalars["Long"]["output"];
};

/** An EasySpeak capture session (never includes the token secret) */
export type AdminCaptureTokenSummary = {
  __typename: "AdminCaptureTokenSummary";
  bytesUsed: Scalars["Long"]["output"];
  createdAt: Scalars["String"]["output"];
  createdByEmail: Scalars["String"]["output"];
  expiresAt: Scalars["String"]["output"];
  id: Scalars["Long"]["output"];
  instance: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  lastUsedAt?: Maybe<Scalars["String"]["output"]>;
  live: Scalars["Boolean"]["output"];
  maxBytes: Scalars["Long"]["output"];
  maxPages: Scalars["Int"]["output"];
  pagesUsed: Scalars["Int"]["output"];
  refusedReason?: Maybe<Scalars["String"]["output"]>;
  revokedAt?: Maybe<Scalars["String"]["output"]>;
};

/** Result of closing EasySpeak identity flags (admin only) */
export type AdminCloseEasySpeakIdentityFlagsResult = {
  __typename: "AdminCloseEasySpeakIdentityFlagsResult";
  closed: Scalars["Int"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

/** Summary of a club for admin browse view */
export type AdminClubBrowseItem = {
  __typename: "AdminClubBrowseItem";
  areaNumber: Scalars["Int"]["output"];
  clubId: Scalars["Int"]["output"];
  contactEmail: Scalars["String"]["output"];
  districtId: Scalars["Int"]["output"];
  divisionCode: Scalars["String"]["output"];
  id: Scalars["Long"]["output"];
  listedInTI: Scalars["Boolean"]["output"];
  longName: Scalars["String"]["output"];
  memberCount: Scalars["Int"]["output"];
  shortName: Scalars["String"]["output"];
};

/** A club whose contactEmail names an account on th_person_email that this node's contact-person index does not name, so Club.isManagedBy denies that account manager access here (#5196) */
export type AdminContactManagerDenial = {
  __typename: "AdminContactManagerDenial";
  /** The club's contactEmail as this run read it - the address the derived manager was resolved from */
  clubContactEmail: Scalars["String"]["output"];
  clubId: Scalars["Int"]["output"];
  clubShortName: Scalars["String"]["output"];
  derivedManagerUserId: Scalars["Long"]["output"];
  /** The person the index names for the club instead, who holds manager access here. Null when it names nobody */
  indexedPersonId?: Maybe<Scalars["Long"]["output"]>;
};

/** This node's contact-person index checked against each club's contact address resolved on th_person_email (#5196). Every field is a reading taken in one run: re-run before acting on a club (docs/spec/membership/contact-address-resolution.md section 4) */
export type AdminContactManagerIndexReport = {
  __typename: "AdminContactManagerIndexReport";
  clubsChecked: Scalars["Int"]["output"];
  /** Clubs whose contact address names an account on th_person_email. Only these clubs can be judged */
  clubsWithDerivedManager: Scalars["Int"]["output"];
  /** The finding: clubs whose derived manager the index does not name, so this node denies them manager access. Never truncated */
  denied: Array<AdminContactManagerDenial>;
};

/** One Slick database's two independent capacities: the executor threads that run actions, and the connections those threads draw from. They are never summed - eight connections do not imply eight threads */
export type AdminDatabasePoolCapacity = {
  __typename: "AdminDatabasePoolCapacity";
  /** How long a caller waits for a connection before Hikari fails the request. Configuration read back off the data source, and not a bound on how long a statement may run */
  connectionTimeoutMillis?: Maybe<Scalars["Long"]["output"]>;
  /** Connections handed out to a borrower right now */
  connectionsActive?: Maybe<Scalars["Int"]["output"]>;
  /** Connections held and available right now */
  connectionsIdle?: Maybe<Scalars["Int"]["output"]>;
  /** Connections the pool may open. Configuration rather than a reading */
  connectionsMax?: Maybe<Scalars["Int"]["output"]>;
  /** Connections the pool holds right now, connectionsActive and connectionsIdle together */
  connectionsTotal?: Maybe<Scalars["Int"]["output"]>;
  /** Executor threads running an action at the moment of the read, approximate */
  executorActiveThreads?: Maybe<Scalars["Int"]["output"]>;
  /** Runnables the executor has finished since its pool was constructed. A runnable is not a statement, a DBIO action or an interval of database time - Slick may run several statements in one or split one action across several. Cumulative and each pool's own, so only a delta over a stated window on one pool carries anything */
  executorCompletedTasks?: Maybe<Scalars["Long"]["output"]>;
  /** Threads the executor may run - the bound an action queues behind */
  executorMaxThreads?: Maybe<Scalars["Int"]["output"]>;
  /** Executor threads that exist at the moment of the read. Not executorMaxThreads */
  executorPoolSize?: Maybe<Scalars["Int"]["output"]>;
  /** How many actions that queue can hold, effective rather than configured: read off the live queue, so a database that sets no queueSize reports the bound Slick defaulted it to */
  executorQueueCapacity?: Maybe<Scalars["Int"]["output"]>;
  /** Actions waiting for a database thread */
  executorQueueDepth?: Maybe<Scalars["Int"]["output"]>;
  /** The Slick database this row is about: default or tm_data */
  name: Scalars["String"]["output"];
  /** Threads that have an executor slot and are waiting for a connection */
  threadsAwaitingConnection?: Maybe<Scalars["Int"]["output"]>;
  /** Why this pool has no readings - stubbed in this environment, a pool not yet built or already shut down, or an unrecognised pool implementation */
  unavailableReason?: Maybe<Scalars["String"]["output"]>;
};

/** The answer to an approval request for a debug API repair plan */
export type AdminDebugRepairApprovalResult = {
  __typename: "AdminDebugRepairApprovalResult";
  /** The one-time code, in the form XXXX-XXXX-XXXX. This answer is the only place it appears: the server keeps only its hash */
  approvalCode?: Maybe<Scalars["String"]["output"]>;
  /** When the code stops working, ISO-8601: the earlier of the approval TTL and the plan's expiry */
  expiresAt?: Maybe<Scalars["String"]["output"]>;
  /** Why no code was issued, when success is false */
  message?: Maybe<Scalars["String"]["output"]>;
  /** The plan id the request named */
  planId: Scalars["String"]["output"];
  /** Whether a code was issued */
  success: Scalars["Boolean"]["output"];
};

/** A debug API repair plan, as the approver reads it before issuing its code */
export type AdminDebugRepairPlan = {
  __typename: "AdminDebugRepairPlan";
  /** The build that made the plan. Only that build applies it */
  build: Scalars["String"]["output"];
  /** The user id of the person who made the plan */
  callerUserId: Scalars["Long"]["output"];
  /** When the plan was made, ISO-8601 */
  createdAt: Scalars["String"]["output"];
  /** When the plan expires, ISO-8601. An expired plan takes no code and is never applied */
  expiresAt: Scalars["String"]["output"];
  /** The plan id, 32 hex characters */
  id: Scalars["String"]["output"];
  /** How the apply ended, once the plan is done */
  outcome?: Maybe<Scalars["String"]["output"]>;
  /** The plan as the debug API renders it, redacted and indented */
  planText: Scalars["String"]["output"];
  /** Why the plan cannot take a code now, or null when it can */
  refusal?: Maybe<Scalars["String"]["output"]>;
  /** The repair's name, as the debug API's repairs listing gives it */
  repair: Scalars["String"]["output"];
  /** The build answering this request */
  runningBuild: Scalars["String"]["output"];
  /** pending, applying or done. Only a pending plan takes a code */
  state: Scalars["String"]["output"];
};

/** Result of deleting a nudge rule */
export type AdminDeleteNudgeResult = {
  __typename: "AdminDeleteNudgeResult";
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

/** A ToastHost account named on the EasySpeak identity review page */
export type AdminEasySpeakAccount = {
  __typename: "AdminEasySpeakAccount";
  displayName?: Maybe<Scalars["String"]["output"]>;
  emailAddress?: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["Long"]["output"];
};

/** An officer's open flag that an EasySpeak identity is wrong */
export type AdminEasySpeakIdentityFlag = {
  __typename: "AdminEasySpeakIdentityFlag";
  clubId: Scalars["Int"]["output"];
  clubName?: Maybe<Scalars["String"]["output"]>;
  /** The account the identity named when the officer flagged it */
  flaggedAccount: AdminEasySpeakAccount;
  flaggedAt: Scalars["String"]["output"];
  flaggedByEmail: Scalars["String"]["output"];
  id: Scalars["Long"]["output"];
  /** The flagging club's row the officer acted through. A club reset may have deleted it since */
  mappingId: Scalars["Long"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
};

/** An EasySpeak person a site administrator is asked to review (admin only) */
export type AdminEasySpeakIdentityReviewEntry = {
  __typename: "AdminEasySpeakIdentityReviewEntry";
  /** The row a change is sent through, with PUT /api/club/:clubId/easyspeak/user-mappings/:id. Null where every row is skipped or the person is on the unattributed sentinel, and only the flags can be dismissed */
  actionRow?: Maybe<AdminEasySpeakIdentityRow>;
  displayName: Scalars["String"]["output"];
  /** The accounts clubs confirmed this person as before identities were shared */
  disputedAccounts: Array<AdminEasySpeakAccount>;
  easySpeakUserId: Scalars["Int"]["output"];
  flags: Array<AdminEasySpeakIdentityFlag>;
  /** Who the person is for every club on the instance, or null where they have no identity */
  identity?: Maybe<AdminEasySpeakAccount>;
  instance: Scalars["String"]["output"];
  rows: Array<AdminEasySpeakIdentityRow>;
};

/** One club's review row for an EasySpeak person */
export type AdminEasySpeakIdentityRow = {
  __typename: "AdminEasySpeakIdentityRow";
  clubId: Scalars["Int"]["output"];
  clubName?: Maybe<Scalars["String"]["output"]>;
  /** The row's decision as the server states it, sent back as expectedRevision by a change made through this row */
  decisionRevision: Scalars["String"]["output"];
  easySpeakClubId: Scalars["Int"]["output"];
  easySpeakDisplayName: Scalars["String"]["output"];
  mappingId: Scalars["Long"]["output"];
  /** The identity's account on a confirmed row, the import's proposal on a pending one */
  namedAccount?: Maybe<AdminEasySpeakAccount>;
  state: Scalars["String"]["output"];
};

/** A club whose EasySpeak import needs an officer's attention (admin only) */
export type AdminEasySpeakSupportClub = {
  __typename: "AdminEasySpeakSupportClub";
  /** Officer settlements whose comparison has changed since the officer chose */
  changedSinceDecided: Scalars["Int"]["output"];
  clubId: Scalars["Long"]["output"];
  clubName?: Maybe<Scalars["String"]["output"]>;
  /** The club's short name, which its import page's URL takes. Null for a club the model no longer holds */
  clubShortName?: Maybe<Scalars["String"]["output"]>;
  /** Review rows with at least one contest reason */
  contestedMappings: Scalars["Int"]["output"];
  /** Why the club's counts could not be read. The counts are then zero */
  readError?: Maybe<Scalars["String"]["output"]>;
  /** Meetings run in both systems that no settlement covers */
  unsettledConflicts: Scalars["Int"]["output"];
};

/** An available email account for sending admin emails */
export type AdminEmailAccountInfo = {
  __typename: "AdminEmailAccountInfo";
  accountId: Scalars["String"]["output"];
  displayName: Scalars["String"]["output"];
};

/** A failed email send attempt */
export type AdminEmailFailure = {
  __typename: "AdminEmailFailure";
  clubId: Scalars["Long"]["output"];
  errorMessage: Scalars["String"]["output"];
  recipient: Scalars["String"]["output"];
};

/** A single outbound email delivery log entry for admin inspection */
export type AdminEmailLogEntry = {
  __typename: "AdminEmailLogEntry";
  activityType?: Maybe<Scalars["String"]["output"]>;
  bccRecipients: Array<Scalars["String"]["output"]>;
  ccRecipients: Array<Scalars["String"]["output"]>;
  clubId?: Maybe<Scalars["Int"]["output"]>;
  clubLongName?: Maybe<Scalars["String"]["output"]>;
  clubShortName?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["String"]["output"];
  deliveryTrackingId?: Maybe<Scalars["String"]["output"]>;
  emailCategory: Scalars["String"]["output"];
  failureReason?: Maybe<Scalars["String"]["output"]>;
  fromAddress: Scalars["String"]["output"];
  htmlBody?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["Long"]["output"];
  metadataJson: Scalars["String"]["output"];
  replyToRecipients: Array<Scalars["String"]["output"]>;
  sendStatus: Scalars["String"]["output"];
  senderAccountId: Scalars["String"]["output"];
  smtpMessageId?: Maybe<Scalars["String"]["output"]>;
  subject: Scalars["String"]["output"];
  templateKey?: Maybe<Scalars["String"]["output"]>;
  textBody?: Maybe<Scalars["String"]["output"]>;
  toRecipients: Array<Scalars["String"]["output"]>;
  triggeredByUserId?: Maybe<Scalars["Long"]["output"]>;
};

/** Paginated outbound email delivery log results for admins */
export type AdminEmailLogPage = {
  __typename: "AdminEmailLogPage";
  entries: Array<AdminEmailLogEntry>;
  limit: Scalars["Long"]["output"];
  offset: Scalars["Long"]["output"];
  totalCount: Scalars["Int"]["output"];
};

/** One thread pool's configured capacity and its occupancy at the moment of the read. Null occupancy with an unavailableReason means the reading could not be taken, which is not the same as an empty queue. The one null that is neither is completedTasks on a fork-join-pool, which does not count them */
export type AdminExecutorCapacity = {
  __typename: "AdminExecutorCapacity";
  /** Threads running a task at the moment of the read. The accessors document this as approximate */
  activeThreads?: Maybe<Scalars["Int"]["output"]>;
  /** Tasks finished since the pool was constructed - cumulative and never reset, so only a delta across two reads of the same pool means anything. A task is one runnable the executor ran, not one unit of caller work */
  completedTasks?: Maybe<Scalars["Long"]["output"]>;
  /** Configuration id the dispatcher was looked up under, e.g. pekko.actor.default-dispatcher */
  dispatcherId: Scalars["String"]["output"];
  /** Which pool answered: fork-join-pool, thread-pool, or unavailable when no reading could be taken. Also what distinguishes the two measurements parallelism reports */
  executorKind: Scalars["String"]["output"];
  /** Boundary this pool serves. The set is whatever RuntimeCapacityService.ObservedDispatchers registers and grows whenever a boundary gets a dedicated pool, so read the rows returned rather than assuming a fixed list. */
  name: Scalars["String"]["output"];
  /** Threads the pool may run: fork-join parallelism, or a thread pool's maximum size */
  parallelism?: Maybe<Scalars["Int"]["output"]>;
  /** Threads that exist at the moment of the read, which a pool grows on demand. Not parallelism */
  poolSize?: Maybe<Scalars["Int"]["output"]>;
  /** Work submitted to this pool and not yet started, read live. Zero means nothing was waiting at that moment */
  queueDepth?: Maybe<Scalars["Int"]["output"]>;
  /** Why this row has no readings - the dispatcher publishes no shared pool, or an unrecognised executor implementation */
  unavailableReason?: Maybe<Scalars["String"]["output"]>;
};

/** One drifting guest (M4), with the direction and what the operational guest row says */
export type AdminGuestDriftRow = {
  __typename: "AdminGuestDriftRow";
  eventCount: Scalars["Int"]["output"];
  lastEventAt?: Maybe<Scalars["String"]["output"]>;
  lastEventType?: Maybe<Scalars["String"]["output"]>;
  /** A ClubGuestRegistration exists but carries deactivatedAt - the 18-month guest window as guestbook_expired applied it (lifecycle spec 4.1.5.1). An enumerated expected delta, not a missing row. False with onlyInProjection means no guest row exists at all */
  legacyGuestDeactivated: Scalars["Boolean"]["output"];
  /** True for a projection Guest with no active ClubGuestRegistration at this club; false for the reverse */
  onlyInProjection: Scalars["Boolean"]["output"];
  projectionMatchesReplay?: Maybe<Scalars["Boolean"]["output"]>;
  projectionState?: Maybe<Scalars["String"]["output"]>;
  replayState?: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["Long"]["output"];
};

/** One drifting roster member (M1), with the roster and projection values that disagree */
export type AdminMemberDriftRow = {
  __typename: "AdminMemberDriftRow";
  accessDenied: Scalars["Boolean"]["output"];
  /** Events on this (user, club), officer events included - 0 means the relationship was never tracked, and a log of officer events alone is not tracked either */
  eventCount: Scalars["Int"]["output"];
  /** Roster latestPaymentDate - the M1 comparison target */
  expectedLatestPaymentDate?: Maybe<Scalars["String"]["output"]>;
  expectedNotRenewing?: Maybe<Scalars["Boolean"]["output"]>;
  /** Roster-derived reference state; null on an orphan row */
  expectedState?: Maybe<Scalars["String"]["output"]>;
  /** Most recent event's occurredAt, for orientation only - it is the event's position in the log, which can be later than its business time, and is NOT comparable to a paid-through date */
  lastEventAt?: Maybe<Scalars["String"]["output"]>;
  lastEventType?: Maybe<Scalars["String"]["output"]>;
  missingProjection: Scalars["Boolean"]["output"];
  notRenewingMismatch: Scalars["Boolean"]["output"];
  paymentDateMismatch: Scalars["Boolean"]["output"];
  /** Whether the stored projection equals a replay of its own log on the M1 fields - i.e. whether the projection is behind its log. Context only: it does NOT select the repair, because a log that is itself stale replays to a value that differs from the projection while still disagreeing with the roster. Use replayMatchesRoster. Null when there is no projection row */
  projectionMatchesReplay?: Maybe<Scalars["Boolean"]["output"]>;
  projectionNotRenewing?: Maybe<Scalars["Boolean"]["output"]>;
  projectionOrphan: Scalars["Boolean"]["output"];
  /** Projection paidUntil; the compared value is max(paidUntil, paidUntilTI) */
  projectionPaidUntil?: Maybe<Scalars["String"]["output"]>;
  projectionPaidUntilTI?: Maybe<Scalars["String"]["output"]>;
  /** Projection currentState; null when the projection row is missing */
  projectionState?: Maybe<Scalars["String"]["output"]>;
  /** THE REPAIR SELECTOR. Whether replaying this relationship's log yields a row that satisfies the M1 comparison against the roster. True: a replay closes this row and writes no events. False: the log cannot produce the roster's value, so only a corrective emission closes it. Null when the log holds no member event (it is empty, or holds only officer events, and the backfill owns the relationship) or there is no roster side to compare (an orphan row) */
  replayMatchesRoster?: Maybe<Scalars["Boolean"]["output"]>;
  replayNotRenewing?: Maybe<Scalars["Boolean"]["output"]>;
  replayPaidUntil?: Maybe<Scalars["String"]["output"]>;
  replayPaidUntilTI?: Maybe<Scalars["String"]["output"]>;
  /** currentState a replay of the event log produces; null when there are no events */
  replayState?: Maybe<Scalars["String"]["output"]>;
  rosterMemberType?: Maybe<Scalars["String"]["output"]>;
  /** Roster TH paid-through; with rosterPaidUntilTI gives the state boundary date */
  rosterPaidUntilTH?: Maybe<Scalars["String"]["output"]>;
  rosterPaidUntilTI?: Maybe<Scalars["String"]["output"]>;
  rosterStatus?: Maybe<Scalars["String"]["output"]>;
  stateMismatch: Scalars["Boolean"]["output"];
  userId: Scalars["Long"]["output"];
};

/** Result of minting an agent GraphQL token (retired: always refused) */
export type AdminMintAgentTokenResult = {
  __typename: "AdminMintAgentTokenResult";
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
  summary?: Maybe<AdminAgentTokenSummary>;
  token?: Maybe<Scalars["String"]["output"]>;
};

/** Result of minting an EasySpeak capture session - the only response carrying the secret */
export type AdminMintCaptureTokenResult = {
  __typename: "AdminMintCaptureTokenResult";
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
  summary?: Maybe<AdminCaptureTokenSummary>;
  token?: Maybe<Scalars["String"]["output"]>;
};

/** Backlog of post-commit effects the mutation outbox still owes. All zeros in steady state, since a delivered row is deleted - so the table's size is the backlog */
export type AdminMutationOutbox = {
  __typename: "AdminMutationOutbox";
  /** Rows whose attempts are exhausted, uncapped. They will not run again without a requeue. A SEPARATE READING from failedRows: do not branch on this to decide whether anything is failed, because a row exhausting its final attempt between the two is PENDING here and FAILED there. Branch on failedRows */
  failed: Scalars["Int"]["output"];
  /** Failed rows per aggregateType/kind */
  failedByKind: Array<AdminMutationOutboxKindCount>;
  /** The failed rows themselves, oldest first and capped. This is the later of the two readings and the one to decide on: anything here is failed, and an empty list means nothing was failed when it was taken */
  failedRows: Array<AdminMutationOutboxFailedRow>;
  /** Whether the store held more failed rows than this listing names. Answered by the same statement that produced the rows, so it cannot disagree with them the way a separate count can */
  failedRowsTruncated: Scalars["Boolean"]["output"];
  /** How long that row has been waiting, at the moment of the read */
  oldestPendingAgeSeconds?: Maybe<Scalars["Int"]["output"]>;
  /** When the oldest pending row was enqueued, or null when nothing is pending */
  oldestPendingCreatedAt?: Maybe<Scalars["String"]["output"]>;
  /** Rows awaiting delivery, including those backing off between attempts */
  pending: Scalars["Int"]["output"];
  /** Pending rows per aggregateType/kind, e.g. Speech/link_delivered_speech */
  pendingByKind: Array<AdminMutationOutboxKindCount>;
};

/** One mutation-outbox row whose delivery attempts are exhausted */
export type AdminMutationOutboxFailedRow = {
  __typename: "AdminMutationOutboxFailedRow";
  /** How long the effect has been owed, at the moment of the read */
  ageSeconds: Scalars["Int"]["output"];
  /** Which instance of that aggregate owes it */
  aggregateKey: Scalars["String"]["output"];
  /** The aggregate whose effect is owed, e.g. Speech */
  aggregateType: Scalars["String"]["output"];
  /** Deliveries tried before the row was abandoned */
  attempts: Scalars["Int"]["output"];
  /** When the mutation that owes this effect committed */
  createdAt: Scalars["String"]["output"];
  /** The mutation_outbox row id, which adminReconcileMutationOutboxDelivery takes */
  id: Scalars["Long"]["output"];
  /** The effect, e.g. link_delivered_speech */
  kind: Scalars["String"]["output"];
  /** What the final attempt failed with, truncated to 512 characters. Fix this before requeueing */
  lastError?: Maybe<Scalars["String"]["output"]>;
};

/** Mutation outbox backlog broken down by aggregateType/kind */
export type AdminMutationOutboxKindCount = {
  __typename: "AdminMutationOutboxKindCount";
  count: Scalars["Int"]["output"];
  kind: Scalars["String"]["output"];
};

/** A club-dashboard nudge rule */
export type AdminNudge = {
  __typename: "AdminNudge";
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["Long"]["output"];
  /** Null matches either way. Otherwise the club's DCP eligibility must equal it */
  isDCPEligible?: Maybe<Scalars["Boolean"]["output"]>;
  maxDCPPoints: Scalars["Int"]["output"];
  maxMembers: Scalars["Int"]["output"];
  /** Null matches any club. Otherwise the club's best still-achievable DCP total must be at or below it */
  maxPossibleDCPPoints?: Maybe<Scalars["Int"]["output"]>;
  minDCPPoints: Scalars["Int"]["output"];
  minMembers: Scalars["Int"]["output"];
  /** Null or empty applies all year. Otherwise a month name (Jun) or an inclusive range that may wrap the year end (Nov-Feb) */
  months?: Maybe<Scalars["String"]["output"]>;
  /** Editorial context for whoever maintains the rule, never shown to a club */
  notes?: Maybe<Scalars["String"]["output"]>;
  officerListSubmittedOnTime?: Maybe<Scalars["Boolean"]["output"]>;
  officersTrainedRnd1?: Maybe<Scalars["Boolean"]["output"]>;
  officersTrainedRnd2?: Maybe<Scalars["Boolean"]["output"]>;
  /** Highest first - a club is shown the top three matching rules */
  priority: Scalars["Int"]["output"];
  /** Shown to the club. $CLUB_NAME$, $DCP_POINTS$, $DCP_GRADE$, $NEEDED_MEMBERS_DCP$ and $GOALS_FOR_5|7|9|10$ are substituted */
  suggestion: Scalars["String"]["output"];
  /** Last admin edit. Null for a rule untouched since the rules moved in house */
  updatedAt?: Maybe<Scalars["String"]["output"]>;
  /** Optimistic-concurrency token. Send it back as expectedVersion when updating this rule - a save carrying a stale one is refused rather than reverting whoever edited it in between */
  version: Scalars["Int"]["output"];
};

/** The editable fields of a nudge rule */
export type AdminNudgeInput = {
  enabled: Scalars["Boolean"]["input"];
  isDCPEligible?: InputMaybe<Scalars["Boolean"]["input"]>;
  maxDCPPoints: Scalars["Int"]["input"];
  maxMembers: Scalars["Int"]["input"];
  maxPossibleDCPPoints?: InputMaybe<Scalars["Int"]["input"]>;
  minDCPPoints: Scalars["Int"]["input"];
  minMembers: Scalars["Int"]["input"];
  months?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  officerListSubmittedOnTime?: InputMaybe<Scalars["Boolean"]["input"]>;
  officersTrainedRnd1?: InputMaybe<Scalars["Boolean"]["input"]>;
  officersTrainedRnd2?: InputMaybe<Scalars["Boolean"]["input"]>;
  priority: Scalars["Int"]["input"];
  suggestion: Scalars["String"]["input"];
};

/** One drifting officer seat (M3), with the account, the seat, and which store names it */
export type AdminOfficerDriftRow = {
  __typename: "AdminOfficerDriftRow";
  /** True for a seat the officer projection's compatibility query names and Club.getCurrentOfficers does not; false for the reverse. An officer the two stores put in different seats is TWO rows, one each way, because the comparison is at (user, role) granularity */
  onlyInProjection: Scalars["Boolean"]["output"];
  /** The seat, as its display name - the user-supplied name for an assigned role. The projection table stores the stable key instead (President, VPEducation, ...), so the two spellings differ for the multi-word roles */
  role: Scalars["String"]["output"];
  userId: Scalars["Long"]["output"];
};

/** Aggregate result of an officer-projection backfill run (#2532) */
export type AdminOfficerProjectionBackfillResult = {
  __typename: "AdminOfficerProjectionBackfillResult";
  clubsProcessed: Scalars["Int"]["output"];
  dryRun: Scalars["Boolean"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  reports: Array<AdminOfficerProjectionBackfillRow>;
  success: Scalars["Boolean"]["output"];
  totalCurrentOfficerRows: Scalars["Int"]["output"];
  totalUpToDate: Scalars["Int"]["output"];
  totalWritten: Scalars["Int"]["output"];
};

/** Per-club summary of one officer-projection backfill run */
export type AdminOfficerProjectionBackfillRow = {
  __typename: "AdminOfficerProjectionBackfillRow";
  clubId: Scalars["Int"]["output"];
  clubShortName: Scalars["String"]["output"];
  currentOfficerRows: Scalars["Int"]["output"];
  upToDate: Scalars["Int"]["output"];
  written: Scalars["Int"]["output"];
};

/** A section 9.1 population past its bound on this run, which fails Condition B */
export type AdminPhase1CapOverflow = {
  __typename: "AdminPhase1CapOverflow";
  id: Scalars["String"]["output"];
  /** How many rows beyond its bound it matched. The rows are not individually identifiable -- every row it matched satisfied the same guard and reasons -- so an overrun is reported as a fact about the population */
  over: Scalars["Int"]["output"];
};

/** What design section 9.1's two conditions turn on, as the run itself computed them (#4628). Null on the whole object means a run stored before that release, which recorded none of these */
export type AdminPhase1ConditionInputs = {
  __typename: "AdminPhase1ConditionInputs";
  /** Condition A counter, summed registry-wide: roster members with no projection row */
  m1MissingProjection: Scalars["Int"]["output"];
  /** Condition A counter, summed registry-wide: orphans (projection claims membership, no roster row) that still GRANT ACCESS under the section 4 predicate, or claim a live Active/Overdue state. An inert PastMember orphan is excluded and never reached this counter */
  m1ProjectionOrphanMembers: Scalars["Int"]["output"];
  /** Condition A counter, summed registry-wide: guest registrations present only on the legacy side */
  m4GuestOnlyInLegacy: Scalars["Int"]["output"];
  /** Each section 9.1 population past its bound on this run, carrying the EXCESS over that bound in `over` -- not the number of rows it matched. AN EMPTY LIST IS THE PASSING STATE. An overrun is a fact about a population rather than a set of rows, so nothing here appears in unclassifiedRows */
  shapeCapOverflow: Array<AdminPhase1CapOverflow>;
};

/** A drifting row inside the Phase 1 gate, by club, account and which comparison put it there */
export type AdminPhase1DriftRow = {
  __typename: "AdminPhase1DriftRow";
  clubId: Scalars["Int"]["output"];
  /** Which M1 comparisons this row failed, ordered MISSING_PROJECTION, STATE, PAYMENT_DATE, NOT_RENEWING, ACCESS_DENIED. Empty for every kind but M1_MEMBER. ACCESS_DENIED is one of the four counters design section 9.1's Condition A turns on, so a reader asking whether a row is access-relevant reads this and not the kind. IT DOES NOT DECIDE THE RUN: these rows are a capped sample, so read phase1ConditionAMet for the verdict */
  facets: Array<Scalars["String"]["output"]>;
  /** M1_MEMBER | M1_ORPHAN | M4_PROJECTION_ONLY | M4_LEGACY_ONLY. No M3 kind: section 9.1 makes M3 the Phase 2 exit, so officer seats are counted in gateDrift and never classified */
  kind: Scalars["String"]["output"];
  userId: Scalars["Long"]["output"];
};

/** A design section 9.1 gate-drift exception population, and what this run made of it */
export type AdminPhase1Exception = {
  __typename: "AdminPhase1Exception";
  /** The population's bound, per design section 9.1: the number of rows it names, or for a guarded population the cap on how many rows it may classify in one run */
  declared: Scalars["Int"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  kind: Scalars["String"]["output"];
  /** The date the population stops classifying, ISO-8601. Null means it never classified anything: an exception with no expiry is refused, not accepted forever */
  lapses?: Maybe<Scalars["String"]["output"]>;
  /** Whether it classified anything on this run's date. False on a blank owner, an absent lapse date, or a lapsed one */
  live: Scalars["Boolean"]["output"];
  /** How many drifting rows it matched on this run. Below declared means the owning mechanism has cleared some, or the guarded shape is not at its cap */
  matched: Scalars["Int"]["output"];
  owner: Scalars["String"]["output"];
};

/** Identity and JVM capacity of the process that answered, for a per-instance baseline */
export type AdminProcessCapacity = {
  __typename: "AdminProcessCapacity";
  /** Processors the JVM can see, which is what Pekko sizes a fork-join dispatcher against. Need not be the machine's core count under a container limit */
  availableProcessors: Scalars["Int"]["output"];
  /** The resolved AppEnvironment name: dev, e2e, staging or prod */
  environment: Scalars["String"]["output"];
  /** Which process answered, from the local hostname, or unknown where that cannot be resolved. It separates one instance's readings from another's and is not an identifier anything else in the platform knows */
  instanceId: Scalars["String"]["output"];
  /** NAMES of the -D system properties this process was started with, and nothing else - no value of any kind is reported, and non -D arguments (-X, -javaagent, ...) are omitted entirely. Answers whether the deployment overrides anything not in the repository; heap is maxHeapBytes and pool sizes are the readings below, both effective rather than requested */
  jvmArguments: Array<Scalars["String"]["output"]>;
  /** Bytes of heap the JVM will use at most: the effective ceiling rather than what -Xmx asked for, and -1 where the JVM reports no maximum */
  maxHeapBytes: Scalars["Long"]["output"];
  /** Milliseconds since this JVM started. Not since the release was deployed, and not a window any cumulative counter in this snapshot is measured over */
  uptimeMillis: Scalars["Long"]["output"];
  /** The release this process is running */
  version: Scalars["String"]["output"];
};

/** Result of running the speech scheduling reconciler once, ahead of its schedule */
export type AdminReconcileSpeechScheduleResult = {
  __typename: "AdminReconcileSpeechScheduleResult";
  /** Actions whose write took */
  applied: Scalars["Int"]["output"];
  /** Speeches that could not be placed because another speech holds the slot. Retrying reaches the same answer */
  contested: Scalars["Int"]["output"];
  /** Actions that raised. These are the ones worth reading the log for */
  failed: Scalars["Int"]["output"];
  /** The drift this run set out to close, counted before any of it was applied */
  planned: AdminSpeechScheduleDrift;
  /** Actions whose compare-and-swap found the row already changed. Not a failure - the next run re-derives from whatever won */
  raced: Scalars["Int"]["output"];
};

/** Relationship co-emission retry backlog (#2755). All zeros in steady state - a queued intent normally clears on its inline attempt and never reaches a drain tick */
export type AdminRelationshipEmissionOutbox = {
  __typename: "AdminRelationshipEmissionOutbox";
  /** Intents given up on - retries exhausted, the 24h replay window elapsed, or the payload cannot be decoded. Needs an operator: adminRequeueFailedRelationshipEmissions puts them back in the queue */
  failed: Scalars["Int"]["output"];
  failedByKind: Array<AdminRelationshipEmissionOutboxKindCount>;
  /** Age of the oldest unsent intent. The drain ticks every 5 minutes, so anything much past that is retrying rather than waiting */
  oldestPendingAgeSeconds?: Maybe<Scalars["Int"]["output"]>;
  oldestPendingCreatedAt?: Maybe<Scalars["String"]["output"]>;
  /** Intents awaiting redelivery. Non-zero means a co-emission failed after its legacy write committed, so the projection is behind the roster for those relationships */
  pending: Scalars["Int"]["output"];
  pendingByKind: Array<AdminRelationshipEmissionOutboxKindCount>;
};

/** Outbox backlog broken down by emission kind */
export type AdminRelationshipEmissionOutboxKindCount = {
  __typename: "AdminRelationshipEmissionOutboxKindCount";
  count: Scalars["Int"]["output"];
  kind: Scalars["String"]["output"];
};

/** Per-club reconciliation drift with the drifting rows retained (#2661) */
export type AdminRelationshipReconciliationDetail = {
  __typename: "AdminRelationshipReconciliationDetail";
  /** The same counts adminRelationshipReconciliation returns; the rows below fold into them */
  club: AdminRelationshipReconciliationRow;
  /** One row per drifting M4 guest, in both directions */
  guestDrift: Array<AdminGuestDriftRow>;
  /** One row per drifting M1 member, including projection orphans */
  memberDrift: Array<AdminMemberDriftRow>;
  /** One row per drifting M3 officer seat, in both directions. These fold into club.m3OfficerOnlyInProjection and club.m3OfficerOnlyInLegacy, so the rows and the counts cannot disagree */
  officerDrift: Array<AdminOfficerDriftRow>;
};

/** Background all-clubs projection-vs-roster reconciliation job snapshot */
export type AdminRelationshipReconciliationJob = {
  __typename: "AdminRelationshipReconciliationJob";
  clubsProcessed: Scalars["Int"]["output"];
  clubsTotal: Scalars["Int"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
  finishedAt?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  /** Per-club results incl. accountlessMembers (D6); empty until the sweep completes */
  rows: Array<AdminRelationshipReconciliationRow>;
  startedAt: Scalars["String"]["output"];
  /** RUNNING | COMPLETED | FAILED */
  status: Scalars["String"]["output"];
  /** Registry-wide totals; null until the sweep completes */
  summary?: Maybe<AdminRelationshipReconciliationSummary>;
};

/** Per-club projection-vs-roster reconciliation (M1/M4 data drift + observed M2; accountless reported separately) */
export type AdminRelationshipReconciliationRow = {
  __typename: "AdminRelationshipReconciliationRow";
  accountHoldingMembers: Scalars["Int"]["output"];
  accountlessMembers: Scalars["Int"]["output"];
  /** M1 and M4 drift rows a live section 9.1 exception matched. classifiedPhase1Drift + unclassifiedPhase1Drift = phase1Drift, which is m1Drift + m4Drift. NOT gateDrift, which also carries m3Drift */
  classifiedPhase1Drift: Scalars["Int"]["output"];
  clubId: Scalars["Int"]["output"];
  clubLongName: Scalars["String"]["output"];
  clubShortName: Scalars["String"]["output"];
  gateDrift: Scalars["Int"]["output"];
  /** Members the projection would lock out of a club the roster still has them in, with no section 5.1 policy delta explaining the removal. In m1Drift, through m1MembersDrifted. Counts access VERDICTS rather than stored values, which is why it survives the expected-delta exceptions the other M1 counters are subject to (#2531) */
  m1AccessDenied: Scalars["Int"]["output"];
  m1Drift: Scalars["Int"]["output"];
  /** Orphans that grant nothing - a PastMember past its 30-day access grace. An enumerated expected delta, NOT in m1Drift: the roster keeps no departed-member row and projection rows are never deleted, so counting these could never reach zero. They age into this counter on their own as the grace elapses */
  m1InertOrphans: Scalars["Int"]["output"];
  m1MembersDrifted: Scalars["Int"]["output"];
  m1MissingProjection: Scalars["Int"]["output"];
  m1NotRenewingMismatch: Scalars["Int"]["output"];
  m1PaymentDateMismatch: Scalars["Int"]["output"];
  /** Orphans (projection claims membership, no roster row) that still GRANT ACCESS under the section 4 predicate, or claim a live Active/Overdue state. In m1Drift. An orphan is a membership projection row with no roster row; only those that grant access are club access without roster proof */
  m1ProjectionOrphanMembers: Scalars["Int"]["output"];
  m1StateMismatch: Scalars["Int"]["output"];
  m2AccessVerdictDiff: Scalars["Int"]["output"];
  m3Drift: Scalars["Int"]["output"];
  m3OfficerOnlyInLegacy: Scalars["Int"]["output"];
  m3OfficerOnlyInProjection: Scalars["Int"]["output"];
  /** Guests retired by guestbook_expired (deactivated_at set) and correctly absent from the projection. An enumerated expected delta, NOT in m4Drift */
  m4DeactivatedLegacyGuests: Scalars["Int"]["output"];
  m4Drift: Scalars["Int"]["output"];
  m4GuestOnlyInLegacy: Scalars["Int"]["output"];
  m4GuestOnlyInProjection: Scalars["Int"]["output"];
  /** m1Drift + m4Drift: the Phase 1 half of gateDrift, and the total the classification partitions. gateDrift spans Phase 1 and Phase 2 by construction and is not the number to read for a Phase 1 verdict */
  phase1Drift: Scalars["Int"]["output"];
  /** This club's share of the Phase 1 gate: M1 and M4 drift rows no live design section 9.1 exception approves, classified inside the run's own snapshot (#3879). Scoped to M1 + M4 because section 9.1 makes M3 the Phase 2 exit and declares no M3 exception, so an officer mismatch must not move a Phase 1 verdict */
  unclassifiedPhase1Drift: Scalars["Int"]["output"];
};

/** One completed reconciliation sweep as it was stored. Every figure was computed by that run, not by this read. A run stored from #4628's release onwards carries both of design section 9.1's conditions whole, in phase1ConditionAMet and phase1ConditionBMet. An older row carries neither in general and answers null where its own counters do not settle it — null is UNKNOWN, never a pass */
export type AdminRelationshipReconciliationRun = {
  __typename: "AdminRelationshipReconciliationRun";
  /** The release the sweep ran on. Two runs are comparable only on one build: the classifier, the exception table and the comparison rules all move between releases */
  buildVersion: Scalars["String"]["output"];
  /** The date the run classified against, ISO-8601, which decides which exceptions were live. The run's own snapshot date, not the date this is read on */
  classifiedOn: Scalars["String"]["output"];
  /** M1 and M4 drift rows a live exception matched. classifiedPhase1Drift + unclassifiedPhase1Drift = m1Drift + m4Drift, so nothing is dropped between the two */
  classifiedPhase1Drift: Scalars["Int"]["output"];
  clubsReconciled: Scalars["Int"]["output"];
  clubsWithGateDrift: Scalars["Int"]["output"];
  /** What the two conditions turn on, as this run computed them. Null means a run stored before #4628, which recorded none of it — the verdicts below then answer only where this row's own counters settle them */
  conditionInputs?: Maybe<AdminPhase1ConditionInputs>;
  /** Which section 9.1 populations classified rows on this run, by population id */
  exceptionMatches: Array<AdminRelationshipReconciliationRunExceptionMatch>;
  finishedAt: Scalars["String"]["output"];
  jobId: Scalars["String"]["output"];
  /** A SUBSET of m1Drift, not an addend: members the projection would lock out of a club the roster still has them in */
  m1AccessDenied: Scalars["Int"]["output"];
  m1Drift: Scalars["Int"]["output"];
  m3Drift: Scalars["Int"]["output"];
  m4Drift: Scalars["Int"]["output"];
  /** Design section 9.1's Condition A for this run: m1AccessDenied and conditionInputs' three counters all zero. NULL MEANS UNKNOWN, NOT MET: a run stored before #4628 holds only m1AccessDenied, and answers here only where that is above zero (failed) or unclassifiedPhase1Drift is zero (met, by section 9.1's subsumption) */
  phase1ConditionAMet?: Maybe<Scalars["Boolean"]["output"]>;
  /** Design section 9.1's Condition B for this run: no unclassified row, and no population past its bound. NULL MEANS UNKNOWN, NOT MET: a run stored before #4628 holds no overflow, so it answers here only where unclassifiedPhase1Drift is above zero, which fails the condition whatever the overflow was */
  phase1ConditionBMet?: Maybe<Scalars["Boolean"]["output"]>;
  startedAt: Scalars["String"]["output"];
  /** SCHEDULED | MANUAL. Section 9.1's Phase 1 exit counts SCHEDULED runs only, so an operator's hand-started sweep cannot stand as gate evidence */
  trigger: Scalars["String"]["output"];
  /** ONE CLAUSE OF CONDITION B. M1 and M4 drift rows no live section 9.1 exception approved, classified inside that run's own snapshot. The other clause is shapeCapOverflow being empty, so read phase1ConditionBMet for the verdict rather than this field alone */
  unclassifiedPhase1Drift: Scalars["Int"]["output"];
  /** A CAPPED SAMPLE of the rows unclassifiedPhase1Drift counted, not a complete list. Compare its length against unclassifiedPhase1Drift before reading it as one */
  unclassifiedRows: Array<AdminPhase1DriftRow>;
};

/** A section 9.1 exception population that classified rows on a stored run */
export type AdminRelationshipReconciliationRunExceptionMatch = {
  __typename: "AdminRelationshipReconciliationRunExceptionMatch";
  id: Scalars["String"]["output"];
  /** How many M1/M4 drift rows this population classified on that run. A population that matched nothing is absent, not zero: the run stores the matches it made, not the table it read */
  matched: Scalars["Int"]["output"];
};

/** Acknowledgement of a background reconciliation sweep start */
export type AdminRelationshipReconciliationRunResult = {
  __typename: "AdminRelationshipReconciliationRunResult";
  job: AdminRelationshipReconciliationJob;
  message?: Maybe<Scalars["String"]["output"]>;
  started: Scalars["Boolean"]["output"];
};

/** Registry-wide projection-vs-roster reconciliation totals. THE PHASE 1 EXIT IS phase1ConditionAMet AND phase1ConditionBMet, on two scheduled runs 24h apart -- neither alone is it, and unclassifiedPhase1Drift alone is not Condition B, because a run can read 0 there while shapeCapOverflow is non-empty (#4557, #4628) */
export type AdminRelationshipReconciliationSummary = {
  __typename: "AdminRelationshipReconciliationSummary";
  /** M1 and M4 drift rows a live exception matched. classifiedPhase1Drift + unclassifiedPhase1Drift = totalPhase1Drift, so nothing is dropped between the two. NOT totalGateDrift, which also carries Phase 2's M3 */
  classifiedPhase1Drift: Scalars["Int"]["output"];
  clubsReconciled: Scalars["Int"]["output"];
  clubsWithGateDrift: Scalars["Int"]["output"];
  /** CONDITION A, THE OTHER HALF: totalM1AccessDenied, totalM1MissingProjection, totalM1ProjectionOrphanMembers and totalM4GuestOnlyInLegacy all zero. Read from the four counters directly, so it answers at any unclassified count rather than only at zero (#4628) */
  phase1ConditionAMet: Scalars["Boolean"]["output"];
  /** CONDITION B, HALF THE PHASE 1 EXIT: unclassifiedPhase1Drift = 0 AND shapeCapOverflow empty. Read this field, not unclassifiedPhase1Drift alone -- a guarded population over its cap can leave unclassifiedPhase1Drift at 0 while this reads false */
  phase1ConditionBMet: Scalars["Boolean"]["output"];
  /** Every declared section 9.1 population, including ones that matched nothing - a cleared population and a lapsed one both read zero and need opposite responses */
  phase1Exceptions: Array<AdminPhase1Exception>;
  /** Every design section 9.1 population that matched more rows than its bound this run, by id. Empty is the passing state, and is required for phase1ConditionBMet alongside unclassifiedPhase1Drift = 0. The overrun rows are not individually identifiable -- every row a guarded population matched satisfied the same guard and reasons -- so this reports the population, not a row list */
  shapeCapOverflow: Array<AdminPhase1CapOverflow>;
  totalAccountHoldingMembers: Scalars["Int"]["output"];
  totalAccountlessMembers: Scalars["Int"]["output"];
  /** Enumerated expected delta, NOT in totalGateDrift: guests retired by guestbook_expired and correctly absent from the projection */
  totalDeactivatedLegacyGuests: Scalars["Int"]["output"];
  /** M1 + M4 (Phase 1) + M3 (Phase 2). Excludes M2 */
  totalGateDrift: Scalars["Int"]["output"];
  /** Enumerated expected delta, NOT in totalGateDrift: orphans that grant no access (a PastMember past its 30-day grace). Expected to grow with departures - projection rows are never deleted - so it is not a backlog */
  totalInertOrphans: Scalars["Int"]["output"];
  /** A SUBSET of totalM1Drift, not an addend: members the projection would lock out of a club the roster still has them in, unexplained by any section 5.1 policy delta. Zero of these is a separate condition from zero total drift, and the one Phase 4 turns on (#2531) */
  totalM1AccessDenied: Scalars["Int"]["output"];
  totalM1Drift: Scalars["Int"]["output"];
  /** Condition A counter: roster members with no projection row, summed registry-wide */
  totalM1MissingProjection: Scalars["Int"]["output"];
  /** Condition A counter, summed registry-wide: orphans (projection claims membership, no roster row) that still GRANT ACCESS under the section 4 predicate, or claim a live Active/Overdue state. An inert PastMember orphan is counted by totalInertOrphans instead and is outside Condition A */
  totalM1ProjectionOrphanMembers: Scalars["Int"]["output"];
  totalM2AccessVerdictDiff: Scalars["Int"]["output"];
  totalM3Drift: Scalars["Int"]["output"];
  totalM4Drift: Scalars["Int"]["output"];
  /** Condition A counter: guest registrations present only on the legacy side, summed registry-wide */
  totalM4GuestOnlyInLegacy: Scalars["Int"]["output"];
  /** totalM1Drift + totalM4Drift: the Phase 1 half of totalGateDrift, and the total the classification partitions */
  totalPhase1Drift: Scalars["Int"]["output"];
  /** ONE CLAUSE OF THE PHASE 1 GATE, NOT THE WHOLE OF IT -- read phase1ConditionBMet for the verdict. M1 and M4 drift rows no live section 9.1 exception approves, classified inside the run's own snapshot. A row substituted for a classified one leaves totalGateDrift unchanged and moves this instead. Scoped to M1 + M4 because section 9.1 makes M3 the Phase 2 exit and declares no M3 exception, so an officer mismatch must not move a Phase 1 verdict */
  unclassifiedPhase1Drift: Scalars["Int"]["output"];
  /** A CAPPED SAMPLE of the unclassified rows, not a complete list. Use unclassifiedPhase1Drift for the count and adminRelationshipReconciliationDetail for one club's full set */
  unclassifiedPhase1DriftRows: Array<AdminPhase1DriftRow>;
};

/** Result of returning named FAILED mutation-outbox rows to the retry queue */
export type AdminRequeueMutationOutboxRowsResult = {
  __typename: "AdminRequeueMutationOutboxRowsResult";
  /** Named rows moved from FAILED back to PENDING, due immediately. A named row no longer FAILED when the requeue ran is not moved or counted */
  requeued: Scalars["Int"]["output"];
};

/** Result of revoking an agent GraphQL token (retired: always refused) */
export type AdminRevokeAgentTokenResult = {
  __typename: "AdminRevokeAgentTokenResult";
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

/** Result of revoking an EasySpeak capture session */
export type AdminRevokeCaptureTokenResult = {
  __typename: "AdminRevokeCaptureTokenResult";
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

/** Result of starting a manual EasySpeak auto-stage run (admin only) */
export type AdminRunAutoStageResult = {
  __typename: "AdminRunAutoStageResult";
  accepted: Scalars["Boolean"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
};

/** Live pool capacity and queue depth for the async execution boundary (#2987). One process, read on demand - there is no stored series */
export type AdminRuntimeCapacity = {
  __typename: "AdminRuntimeCapacity";
  databases: Array<AdminDatabasePoolCapacity>;
  executors: Array<AdminExecutorCapacity>;
  /** When the reading was taken. Every depth below is instantaneous, not an average */
  observedAt: Scalars["String"]["output"];
  process: AdminProcessCapacity;
};

/** Result of creating or updating a nudge rule */
export type AdminSaveNudgeResult = {
  __typename: "AdminSaveNudgeResult";
  message?: Maybe<Scalars["String"]["output"]>;
  nudge?: Maybe<AdminNudge>;
  success: Scalars["Boolean"]["output"];
};

/** Result of sending admin club emails */
export type AdminSendEmailsResponse = {
  __typename: "AdminSendEmailsResponse";
  failures: Array<AdminEmailFailure>;
  successfulSends: Scalars["Int"]["output"];
  totalClubs: Scalars["Int"]["output"];
  totalRecipients: Scalars["Int"]["output"];
};

/** One difference the speech scheduling reconciler reports and deliberately does not act on. This sweep writes none of them, because the write would either be a status transition the machine does not have or one uniq_speech_assignment would refuse. Why a particular row is here, and whether it will clear, depend on the agenda, the credit and the outbox - none of which this plan reads - so the fields are evidence and this type draws no conclusion from them */
export type AdminSpeechScheduleBlocked = {
  __typename: "AdminSpeechScheduleBlocked";
  /** Agenda slot of that seat */
  agendaItemId?: Maybe<Scalars["String"]["output"]>;
  clubId: Scalars["Int"]["output"];
  /** STATUS_TRANSITION (the table holds a status the machine cannot move where the request wants it) | SEAT_OCCUPIED (a live request with no speech names a seat another speech holds) | PLAN_CONTENTION (two actions in this one plan would write the same row or fill the same seat) */
  kind: Scalars["String"]["output"];
  /** Meeting of the seat this block concerns, absent when the block is about no seat */
  meetingId?: Maybe<Scalars["String"]["output"]>;
  /** SEAT_OCCUPIED only: the request that occupant names, where it still names one. It can equal requestId above rather than naming a competitor: the plan reads speeches-by-request before seat occupants and shares no transaction with them, so a row minted in between is reported as its own request's occupant. A dead one does not by itself mean the row is stranded - read occupantSeatOwedByDelivery too */
  occupantRequestId?: Maybe<Scalars["String"]["output"]>;
  /** SEAT_OCCUPIED only: true when an outstanding delivery debt names this same seat, which is why the reconciler leaves the occupant alone rather than vacating it. It establishes that a debt shares the seat key and nothing further - not that the debt or the occupant is the correct one, and not that the block is waiting rather than stuck, since delivering the debt marks the occupant DELIVERED without vacating the seat. A FAILED outbox row is retained for an operator, so this can stay true indefinitely */
  occupantSeatOwedByDelivery?: Maybe<Scalars["Boolean"]["output"]>;
  /** SEAT_OCCUPIED only: the speech found in the seat */
  occupantSpeechId?: Maybe<Scalars["Long"]["output"]>;
  /** SEAT_OCCUPIED only: what the occupying speech is. Evidence and not a verdict - no status here implies a remedy, and none of them says whether a later sweep will clear the block. Read it with occupantRequestId and occupantSeatOwedByDelivery */
  occupantStatus?: Maybe<Scalars["String"]["output"]>;
  /** The particular seat, statuses or competing action, in prose */
  reason: Scalars["String"]["output"];
  /** The request the difference is about, where one identifies it */
  requestId?: Maybe<Scalars["String"]["output"]>;
  /** The speech the difference is about, where one identifies it */
  speechId?: Maybe<Scalars["Long"]["output"]>;
  /** Member of that seat - a slot seats more than one, so the seat is the triple */
  userId?: Maybe<Scalars["Long"]["output"]>;
};

/** Speech rows the scheduling reconciler would create, move or cancel to agree with current requests and agendas. All zeros in steady state - re-derived on every read, so it is a live reading rather than a queue */
export type AdminSpeechScheduleDrift = {
  __typename: "AdminSpeechScheduleDrift";
  /** Differences reported and deliberately not acted on: a status the machine cannot move where the request wants it, a seat another speech already holds, or two actions in this plan wanting one row or seat. Never retried, so the count stands across runs rather than draining. Read blockedActions for what each one actually is */
  blocked: Scalars["Int"]["output"];
  /** The blocked differences themselves, one per blocked. A count that does not clear is only actionable with the rows behind it */
  blockedActions: Array<AdminSpeechScheduleBlocked>;
  /** Speeches whose request is gone and whose agenda seat is gone with it */
  cancel: Scalars["Int"]["output"];
  /** Ids of clubs the scan could not read - an undecodable request blob or a failed seat lookup - and so planned nothing for. Non-empty means the counts are incomplete, not that those clubs are in steady state */
  clubsSkipped: Array<Scalars["Int"]["output"]>;
  /** Live requests with no speech row */
  mint: Scalars["Int"]["output"];
  /** Speeches whose state or slot no longer matches their request */
  move: Scalars["Int"]["output"];
  /** Cancelled speeches whose member has been put back in the seat they were cancelled from, so the speech is given back rather than a second one created */
  reactivate: Scalars["Int"]["output"];
  /** Requests pointed at a different member, so one speech is cancelled and another created */
  retarget: Scalars["Int"]["output"];
  /** The sum, so a caller can alert on one number */
  total: Scalars["Int"]["output"];
  /** Speeches whose request is gone and whose meeting could not be read. Deliberately left alone - absence of evidence is not evidence the member lost the slot */
  unreadable: Scalars["Int"]["output"];
};

/** Result of starting an EasySpeak archive import (admin only) */
export type AdminStartArchiveImportResult = {
  __typename: "AdminStartArchiveImportResult";
  accepted: Scalars["Boolean"]["output"];
  jobId?: Maybe<Scalars["String"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
};

/** A name-value pair for system statistics */
export type AdminStat = {
  __typename: "AdminStat";
  name: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

/** System statistics including memory, properties, and configuration */
export type AdminStats = {
  __typename: "AdminStats";
  /** Configuration sections */
  config: Array<ConfigSection>;
  /** System properties */
  properties: Array<AdminStat>;
  /** Runtime statistics */
  stats: Array<AdminStat>;
  /** When stats were collected */
  timestamp: Scalars["String"]["output"];
};

/** Detailed cohort row for unsubscribed-club activation analytics */
export type AdminUsageAnalyticsCohortRow = {
  __typename: "AdminUsageAnalyticsCohortRow";
  clubId: Scalars["Int"]["output"];
  clubName: Scalars["String"]["output"];
  converted: Scalars["Boolean"]["output"];
  firstAction: Scalars["String"]["output"];
  firstKnownLoginAt?: Maybe<Scalars["String"]["output"]>;
  firstUnsubscribedVisitAt: Scalars["String"]["output"];
  isOfficer: Scalars["Boolean"]["output"];
  lastSeenAt: Scalars["String"]["output"];
  userId: Scalars["Long"]["output"];
};

/** Dashboard data for unsubscribed-club activation analytics */
export type AdminUsageAnalyticsDashboard = {
  __typename: "AdminUsageAnalyticsDashboard";
  cohort: Array<AdminUsageAnalyticsCohortRow>;
  firstActions: Array<AdminUsageAnalyticsFirstAction>;
  fromDate: Scalars["String"]["output"];
  funnel: Array<AdminUsageAnalyticsFunnelStep>;
  generatedAt: Scalars["String"]["output"];
  kpis: AdminUsageAnalyticsKpis;
  toDate: Scalars["String"]["output"];
  topRoutes: Array<AdminUsageAnalyticsTopRoute>;
};

/** Grouped first actions for the unsubscribed-club cohort */
export type AdminUsageAnalyticsFirstAction = {
  __typename: "AdminUsageAnalyticsFirstAction";
  count: Scalars["Int"]["output"];
  label: Scalars["String"]["output"];
};

/** A single funnel step for unsubscribed-club activation analytics */
export type AdminUsageAnalyticsFunnelStep = {
  __typename: "AdminUsageAnalyticsFunnelStep";
  dropOffCount: Scalars["Int"]["output"];
  dropOffRate: Scalars["Float"]["output"];
  label: Scalars["String"]["output"];
  stepKey: Scalars["String"]["output"];
  userCount: Scalars["Int"]["output"];
};

/** Summary KPI metrics for unsubscribed-club activation analytics */
export type AdminUsageAnalyticsKpis = {
  __typename: "AdminUsageAnalyticsKpis";
  docsClickCount: Scalars["Int"]["output"];
  docsClickRate: Scalars["Float"]["output"];
  faqViewCount: Scalars["Int"]["output"];
  faqViewRate: Scalars["Float"]["output"];
  returnedWithin7DaysCount: Scalars["Int"]["output"];
  returnedWithin7DaysRate: Scalars["Float"]["output"];
  trialConversionCount: Scalars["Int"]["output"];
  trialConversionRate: Scalars["Float"]["output"];
  uniqueClubs: Scalars["Int"]["output"];
  uniqueUsers: Scalars["Int"]["output"];
};

/** Most common routes visited before conversion or drop-off */
export type AdminUsageAnalyticsTopRoute = {
  __typename: "AdminUsageAnalyticsTopRoute";
  count: Scalars["Int"]["output"];
  featureArea: Scalars["String"]["output"];
  routeName: Scalars["String"]["output"];
  segment: Scalars["String"]["output"];
};

/** Summary of a user for admin browse view */
export type AdminUserBrowseItem = {
  __typename: "AdminUserBrowseItem";
  emailAddress: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["Long"]["output"];
  lastName: Scalars["String"]["output"];
  userId?: Maybe<Scalars["Long"]["output"]>;
};

/** A pathway credit standing on a seat that a removal would vacate */
export type AgendaCreditAtRisk = {
  __typename: "AgendaCreditAtRisk";
  /** Agenda item the seat belongs to */
  agendaItemId: Scalars["String"]["output"];
  /** The pathway completion record carrying the credit */
  completionId: Scalars["ID"]["output"];
  /** How the credit was recorded (AUTO_FROM_MEETING, MANUAL_OFFICER_ENTRY, MIGRATION_IMPORT, ...) */
  creditMethod: Scalars["String"]["output"];
  /** Member's name, as the agenda names it */
  memberName?: Maybe<Scalars["String"]["output"]>;
  /** Which pathway, level and project the credit sits on */
  placement: SpeechPlacement;
  /** The seat's role, as the agenda names it */
  roleName?: Maybe<Scalars["String"]["output"]>;
  /** Member holding the credit */
  userId: Scalars["ID"]["output"];
  /** True when the removal would withdraw this credit. False for a manual or imported credit, which is a human decision the edit leaves standing and reports instead. */
  withdrawable: Scalars["Boolean"]["output"];
};

/** An item in a meeting agenda */
export type AgendaItem = {
  __typename: "AgendaItem";
  /** Time (seconds) when amber signal shows */
  amberMark: Scalars["Int"]["output"];
  /** Users assigned to this agenda item */
  assignedUsers: Array<Maybe<MeetingUser>>;
  /** Background color for display */
  backgroundColor?: Maybe<Scalars["String"]["output"]>;
  /** Duration in seconds */
  duration: Scalars["Int"]["output"];
  /** Event/activity name */
  event: Scalars["String"]["output"];
  /** Time (seconds) when green signal shows */
  greenMark: Scalars["Int"]["output"];
  /** Unique identifier */
  id: Scalars["ID"]["output"];
  /** Whether the agenda item is completed */
  isCompleted: Scalars["Boolean"]["output"];
  /** Whether this role type can be repeated (e.g., Speaker 1, Speaker 2) */
  isRepeatableRole?: Maybe<Scalars["Boolean"]["output"]>;
  /** Maximum number of people that can be assigned */
  maxAssignments: Scalars["Int"]["output"];
  /** ID of the pathway project assigned to this agenda item */
  pathwayProjectId?: Maybe<Scalars["ID"]["output"]>;
  /** Per-assignee pathway role target entries that will credit at meeting finish */
  pathwayRoleTargets: Array<PathwayRoleTargetEntry>;
  /** Time (seconds) when red signal shows */
  redMark: Scalars["Int"]["output"];
  /** Role name */
  role: Scalars["String"]["output"];
  /** Position for repeatable roles (e.g., 1 for Speaker 1) */
  rolePosition?: Maybe<Scalars["Int"]["output"]>;
  /** Role signup requests from members for this agenda item */
  roleRequests: Array<RoleSignupRequest>;
};

/** Input type for agenda items in template operations */
export type AgendaItemInput = {
  /** Time (seconds) when amber signal shows */
  amberMark: Scalars["Int"]["input"];
  /** Assigned users for each slot (null entries represent empty slots) */
  assignedMeetingUsers?: InputMaybe<Array<InputMaybe<MeetingUserInput>>>;
  /** Background color for display */
  backgroundColor?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether the agenda item is completed (in-progress meetings) */
  completed?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Duration in seconds */
  duration: Scalars["Int"]["input"];
  /** Event/activity name */
  event: Scalars["String"]["input"];
  /** Time (seconds) when green signal shows */
  greenMark: Scalars["Int"]["input"];
  /** Unique identifier */
  id: Scalars["String"]["input"];
  /** Whether this role type can be repeated */
  isRepeatableRole?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Maximum number of people that can be assigned */
  maxAssignments: Scalars["Int"]["input"];
  /** Assigned Pathways project ID */
  pathwayProjectId?: InputMaybe<Scalars["String"]["input"]>;
  /** Per-assignee pathway role target entries that will credit at meeting finish */
  pathwayRoleTargets?: InputMaybe<Array<PathwayRoleTargetInput>>;
  /** Time (seconds) when red signal shows */
  redMark: Scalars["Int"]["input"];
  /** Role name */
  role: Scalars["String"]["input"];
  /** Position for repeatable roles */
  rolePosition?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A single server-authoritative agenda edit operation (discriminated by `op`) */
export type AgendaOpInput = {
  /** Single-item target id */
  agendaItemId?: InputMaybe<Scalars["String"]["input"]>;
  /** Role-group target item ids */
  agendaItemIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Amber timing mark (seconds) for time / role ops */
  amberMark?: InputMaybe<Scalars["Int"]["input"]>;
  /** People the officer confirmed a switch to shared removes (SetRoleRepeatable) */
  confirmedRemovals?: InputMaybe<Array<MeetingUserInput>>;
  /** Item duration (seconds) for time / role ops */
  duration?: InputMaybe<Scalars["Int"]["input"]>;
  /** Green timing mark (seconds) for time / role ops */
  greenMark?: InputMaybe<Scalars["Int"]["input"]>;
  /** Whether the targeted role is repeatable */
  isRepeatable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether the new role is repeatable (SetAgendaItemRole) */
  isRepeatableRole?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Full new item for AddAgendaItem */
  item?: InputMaybe<AgendaItemInput>;
  /** Preserved slot capacity for SetAgendaItemRole */
  maxAssignments?: InputMaybe<Scalars["Int"]["input"]>;
  /** Operation discriminator, e.g. AssignUserToRole, RemoveAgendaItem */
  op: Scalars["String"]["input"];
  /** Desired full agenda item order */
  orderedAgendaItemIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Desired speaker slot order */
  orderedSlots?: InputMaybe<Array<SpeakerReorderSlotInput>>;
  /** Desired speaker item order */
  orderedSpeakerItemIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Linked Pathways project id */
  pathwayProjectId?: InputMaybe<Scalars["String"]["input"]>;
  /** Pathway role target to set */
  pathwayTarget?: InputMaybe<PathwayRoleTargetInput>;
  /** Red timing mark (seconds) for time / role ops */
  redMark?: InputMaybe<Scalars["Int"]["input"]>;
  /** New role name for SetAgendaItemRole */
  role?: InputMaybe<Scalars["String"]["input"]>;
  /** Role name for group ops, and the rendered role for SetRoleAssignmentSlot and SetAgendaItemRole */
  roleName?: InputMaybe<Scalars["String"]["input"]>;
  /** Sub-slot index */
  slotIndex?: InputMaybe<Scalars["Int"]["input"]>;
  /** Speech / item title */
  title?: InputMaybe<Scalars["String"]["input"]>;
  /** Occupant to assign / remove / set */
  user?: InputMaybe<MeetingUserInput>;
  /** Assignee user id for pathway-target ops */
  userId?: InputMaybe<Scalars["Long"]["input"]>;
};

/** What removing these seats would do to the credits they justify */
export type AgendaRemovalImpact = {
  __typename: "AgendaRemovalImpact";
  /** Every credit standing on the named seats, withdrawable or not */
  credits: Array<AgendaCreditAtRisk>;
  /** False when the meeting has never been finished, in which case no automatic credit exists and no query was issued for one. */
  meetingHasBeenFinished: Scalars["Boolean"]["output"];
};

/** A seat a removal is about to vacate. Omit userId to mean the whole agenda item is going. */
export type AgendaSeatInput = {
  /** Agenda item the seat belongs to */
  agendaItemId: Scalars["String"]["input"];
  /** Member being cleared from the seat; omit to name every member seated at the item */
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** A reusable meeting agenda template */
export type AgendaTemplate = {
  __typename: "AgendaTemplate";
  /** Template agenda items */
  agenda: Array<AgendaItem>;
  /** Club ID if this is a club-specific template */
  clubId?: Maybe<Scalars["ID"]["output"]>;
  /** Template description */
  description: Scalars["String"]["output"];
  /** Template identifier */
  id: Scalars["ID"]["output"];
  /** Whether this is a global template */
  isGlobal: Scalars["Boolean"]["output"];
  /** Number of agenda items in template */
  itemCount: Scalars["Int"]["output"];
  /** Template name */
  name: Scalars["String"]["output"];
};

/** Result of a AgendaTemplate mutation */
export type AgendaTemplateResult = {
  __typename: "AgendaTemplateResult";
  /** The AgendaTemplate data if successful */
  data?: Maybe<AgendaTemplate>;
  /** Machine-readable code identifying the failure outcome */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable result message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Whether the mutation succeeded */
  success: Scalars["Boolean"]["output"];
};

/** Response containing agenda templates and default template ID */
export type AgendaTemplatesResponse = {
  __typename: "AgendaTemplatesResponse";
  /** ID of the club's default agenda template */
  defaultTemplateId?: Maybe<Scalars["Long"]["output"]>;
  /** List of agenda templates */
  templates: Array<AgendaTemplate>;
};

/** Dashboard data for an area */
export type AreaDashboardResponse = {
  __typename: "AreaDashboardResponse";
  areaId: Scalars["String"]["output"];
  areaName: Scalars["String"]["output"];
  asOfDate: Scalars["String"]["output"];
  clubProvisionalStatus: Scalars["JSON"]["output"];
  clubs: Scalars["JSON"]["output"];
  clubsChart: DashboardChart;
  distClubsChart: DashboardChart;
  districtId: Scalars["Int"]["output"];
  districtName: Scalars["String"]["output"];
  divisionId: Scalars["String"]["output"];
  divisionName: Scalars["String"]["output"];
  isProvisionalPeriod: Scalars["Boolean"]["output"];
};

/** Area statistics in the clubs dashboard */
export type AreaStats = {
  __typename: "AreaStats";
  areaId: Scalars["String"]["output"];
  clubs: Array<ClubStats>;
  pathwaysEnrolledMembers: Scalars["Int"]["output"];
  pathwaysTotalMembers: Scalars["Int"]["output"];
  totalActiveMembers: Scalars["Int"]["output"];
};

/** Input for marking a member's attendance */
export type AttendanceMarkInput = {
  /** Attendance status (null clears) */
  status?: InputMaybe<AttendanceStatus>;
  /** User ID to mark */
  userId: Scalars["ID"]["input"];
};

/** How attendance was recorded */
export enum AttendanceSource {
  /** Auto-detected from feedback */
  AutoFeedback = "AUTO_FEEDBACK",
  /** Auto-detected from role assignment */
  AutoRole = "AUTO_ROLE",
  /** Auto-detected from voting */
  AutoVote = "AUTO_VOTE",
  /** Imported from EasySpeak */
  EasyspeakImport = "EASYSPEAK_IMPORT",
  /** Signed the club guestbook during an in-progress meeting */
  GuestbookSignin = "GUESTBOOK_SIGNIN",
  /** Officer recorded attendance */
  OfficerMarked = "OFFICER_MARKED",
  /** Member self check-in */
  SelfCheckin = "SELF_CHECKIN",
}

/** Recorded attendance status for a meeting */
export enum AttendanceStatus {
  /** Member attended */
  Attended = "ATTENDED",
  /** Member did not attend */
  NotAttended = "NOT_ATTENDED",
}

/** Billing cycle frequency */
export enum BillingFrequency {
  /** Annual billing */
  Annual = "ANNUAL",
  /** Monthly billing */
  Monthly = "MONTHLY",
}

/** Result of a training-event attendance mutation */
export type CotAttendanceMutationResult = {
  __typename: "COTAttendanceMutationResult";
  attendance?: Maybe<CotSessionAttendance>;
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

/** How a COT attendance row was captured */
export enum CotAttendanceSource {
  /** Imported from the Zoom/TI attendance CSV upload */
  CsvImport = "CSV_IMPORT",
  /** Host marked the attendee via the live tab */
  HostMarked = "HOST_MARKED",
  /** Officer self-checked-in (Phase 3) */
  LiveCheckIn = "LIVE_CHECK_IN",
  /** District admin entered the row manually */
  Manual = "MANUAL",
}

/** Preview of resolved recipients for a candidate broadcast audience */
export type CotAudiencePreview = {
  __typename: "COTAudiencePreview";
  audience: CotBroadcastAudience;
  recipientCount: Scalars["Int"]["output"];
  /** Up to 10 sample recipients to surface in the composer */
  sample: Array<CotBroadcastRecipient>;
};

/** Audit record of a single district COT broadcast */
export type CotBroadcast = {
  __typename: "COTBroadcast";
  audience: CotBroadcastAudience;
  bodyTemplate: Scalars["String"]["output"];
  cotEventId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  recipientCount: Scalars["Int"]["output"];
  sentAt: Scalars["String"]["output"];
  sentByName: Scalars["String"]["output"];
  sentByUserId: Scalars["ID"]["output"];
  subject: Scalars["String"]["output"];
};

/** The audience filter used to resolve recipients for a district COT broadcast */
export type CotBroadcastAudience = {
  __typename: "COTBroadcastAudience";
  /** For BY_AREA audiences: the district-scoped area identifier (e.g. "47") */
  areaId?: Maybe<Scalars["String"]["output"]>;
  /** For BY_DIVISION audiences: the district-scoped division identifier (e.g. "D") */
  divisionId?: Maybe<Scalars["String"]["output"]>;
  /** For COMPOSITE audiences: the AND-intersected sub-filters (single-level for Phase 2C) */
  filters: Array<CotBroadcastAudience>;
  kind: CotBroadcastAudienceKind;
  /** For BY_REGISTRATION_STATUS audiences: true = registered, false = unregistered */
  registered?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Audience selector for the district COT broadcast composer (Phase 1F + 2C) */
export type CotBroadcastAudienceInput = {
  /** Required when kind == BY_AREA; ignored otherwise */
  areaId?: InputMaybe<Scalars["String"]["input"]>;
  /** Required when kind == BY_DIVISION; ignored otherwise */
  divisionId?: InputMaybe<Scalars["String"]["input"]>;
  /** Required when kind == COMPOSITE (single-level — nested COMPOSITE rejected); ignored otherwise */
  filters?: InputMaybe<Array<CotBroadcastAudienceInput>>;
  /** Which audience filter to apply */
  kind: CotBroadcastAudienceKind;
  /** Required when kind == BY_REGISTRATION_STATUS; ignored otherwise */
  registered?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Discriminator for which COT broadcast audience filter is in use */
export enum CotBroadcastAudienceKind {
  /** All officers holding a trainable role at a club in this district (live) */
  AllCurrentDistrictOfficers = "ALL_CURRENT_DISTRICT_OFFICERS",
  /** Officers in the named area only (Phase 2C) */
  ByArea = "BY_AREA",
  /** Officers in the named division only (Phase 2C) */
  ByDivision = "BY_DIVISION",
  /** Filter by whether the officer has an active registration on this session */
  ByRegistrationStatus = "BY_REGISTRATION_STATUS",
  /** Intersection (AND) of multiple audience filters (Phase 2C) */
  Composite = "COMPOSITE",
}

/** Real event-scoped merge values for the broadcast composer's live preview (issue #2524) */
export type CotBroadcastPreviewContext = {
  __typename: "COTBroadcastPreviewContext";
  /** Computed "how to earn credit" message ({{creditRequirement}} merge field), or null when the event has no sessions */
  creditRequirement?: Maybe<Scalars["String"]["output"]>;
  districtName: Scalars["String"]["output"];
  eventDescription?: Maybe<Scalars["String"]["output"]>;
  eventName: Scalars["String"]["output"];
  /** Formatted date of the earliest session, or null if none scheduled */
  firstSessionDate?: Maybe<Scalars["String"]["output"]>;
  registrationLink: Scalars["String"]["output"];
};

/** A single resolved recipient in an audience preview */
export type CotBroadcastRecipient = {
  __typename: "COTBroadcastRecipient";
  displayName: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  /** True for non-ToastHost officers (only possible on registered-audience previews) */
  isExternal: Scalars["Boolean"]["output"];
};

/** Result of sendCOTBroadcast */
export type CotBroadcastResult = {
  __typename: "COTBroadcastResult";
  broadcast?: Maybe<CotBroadcast>;
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

/** Attendance detail for a club-detail officer projection */
export type CotClubAttendanceRecord = {
  __typename: "COTClubAttendanceRecord";
  attendanceTime: Scalars["String"]["output"];
  duration: Scalars["Int"]["output"];
  eventId: Scalars["ID"]["output"];
  eventName: Scalars["String"]["output"];
  qualifying: Scalars["Boolean"]["output"];
  sessionId: Scalars["ID"]["output"];
  sessionName: Scalars["String"]["output"];
  sessionType?: Maybe<Scalars["Int"]["output"]>;
};

/** Full club-detail projection for the club summary dialog */
export type CotClubDetail = {
  __typename: "COTClubDetail";
  areaId: Scalars["Int"]["output"];
  clubId: Scalars["ID"]["output"];
  clubName: Scalars["String"]["output"];
  divisionId: Scalars["String"]["output"];
  officers: Array<CotClubRoleDetail>;
};

/** Officer detail for a club-detail projection */
export type CotClubDetailOfficer = {
  __typename: "COTClubDetailOfficer";
  attendance: Array<CotClubAttendanceRecord>;
  completedDistinctRoleCount: Scalars["Int"]["output"];
  cotsCreditsEarned: Scalars["Int"]["output"];
  distinctRoleCount: Scalars["Int"]["output"];
  email: Scalars["String"]["output"];
  hasBookendsTraining: Scalars["Boolean"]["output"];
  hasCompleted: Scalars["Boolean"]["output"];
  isUnderCredited: Scalars["Boolean"]["output"];
  memberCreditsEarned: Scalars["Int"]["output"];
  memberDistinctRoleCount: Scalars["Int"]["output"];
  membershipNumber: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  requiresManualAssignment: Scalars["Boolean"]["output"];
  tiHasCompleted?: Maybe<Scalars["Boolean"]["output"]>;
  unassignedRoleTypes: Array<Scalars["String"]["output"]>;
};

/** An officer record in a COT program with training status */
export type CotClubOfficerRecord = {
  __typename: "COTClubOfficerRecord";
  /** Events this officer holds a live registration for - not cancelled, not waitlisted, not awaiting email verification. Intersect with the round's finishedEventIds to tell an officer awaiting training from one who registered and did not complete; the record alone cannot, because a registration carries no session date. */
  activeRegistrationEventIds: Array<Scalars["ID"]["output"]>;
  /** Area ID */
  areaId?: Maybe<Scalars["String"]["output"]>;
  /** IDs of sessions attended */
  attendedEvents: Array<Scalars["ID"]["output"]>;
  /** Club roles held by this officer */
  clubOfficerRoles: Array<CotOfficerClubRole>;
  /** Opaque token naming the clubOfficerRoles above. Pass it to updateCOTOfficerClubRoles as expectedClubRolesToken; that write is refused with COT_CONFLICT if the record's roles changed in between (#3623). Derive the request from the roles served with it and not from a roster fetched earlier, or the token vouches for a list the caller was never shown. Never parse or construct one. */
  clubRolesToken: Scalars["String"]["output"];
  /** Number of distinct role types that have completed training */
  completedDistinctRoleCount: Scalars["Int"]["output"];
  /** COTS credits earned by THIS record (attended sessions + external completions). Safe to total across a roster. For a member holding several records their credits sit on one of them, so use memberCreditsEarned for anything about the person. */
  cotsCreditsEarned: Scalars["Int"]["output"];
  /** Number of distinct officer role types (e.g., President at 2 clubs = 1) */
  distinctRoleCount: Scalars["Int"]["output"];
  /** List of distinct role types held by this officer */
  distinctRoleTypes: Array<Scalars["String"]["output"]>;
  /** District ID */
  districtId?: Maybe<Scalars["String"]["output"]>;
  /** Notes added by district officers */
  districtNotes: Array<CotDistrictNote>;
  /** Division ID */
  divisionId?: Maybe<Scalars["String"]["output"]>;
  /** Effective email (with override if present) */
  effectiveEmail: Scalars["String"]["output"];
  /** Effective membership number (with override if present) */
  effectiveMembershipNumber: Scalars["String"]["output"];
  /** Effective name (with override if present) */
  effectiveName: Scalars["String"]["output"];
  /** Effective user ID (with override if present) */
  effectiveUserId?: Maybe<Scalars["ID"]["output"]>;
  /** Officer email */
  email: Scalars["String"]["output"];
  /** External completion record, if any */
  externalCompletion?: Maybe<CotExternalCompletion>;
  /** Whether officer completed a bookend set (Part 1 + Part 2, or a Full Session) anywhere in the round, the halves being poolable across its events — prerequisite for any role credit */
  hasBookendsTraining: Scalars["Boolean"]["output"];
  /** Whether officer has completed training */
  hasCompletedTraining: Scalars["Boolean"]["output"];
  /** Whether officer is matched to a system user */
  isMatched: Scalars["Boolean"]["output"];
  /** Whether no role on this record is credited yet but the record holds an active event registration (signed up, credit not yet landed). Mutually exclusive with completedDistinctRoleCount > 0. */
  isScheduledNotTrained: Scalars["Boolean"]["output"];
  /** Whether the officer earned at least one credit but fewer than their distinct role count, leaving at least one role uncredited (superset of requiresManualAssignment). See #1690. */
  isUnderCredited: Scalars["Boolean"]["output"];
  /** Manual role assignments made by district officers */
  manualRoleAssignments: Array<CotManualRoleAssignment>;
  /** Manual training credits added by district officers */
  manualTrainingCredits: Array<CotManualTrainingCredit>;
  /** The user ID this record was matched to */
  matchedToUserId?: Maybe<Scalars["ID"]["output"]>;
  /** COTS credits earned by the MEMBER, across every record they hold. Equal to cotsCreditsEarned for the single-record officer. This is the budget a manual role assignment is validated against, so it is what an assignment UI must gate on. Repeats across a member's rows by construction — never sum it over a roster (#3512). */
  memberCreditsEarned: Scalars["Int"]["output"];
  /** Distinct role types held by the MEMBER, across every record they hold. Equal to distinctRoleCount for the single-record officer. Compare this with memberCreditsEarned and never with the per-record count: a member's credits against one record's roles answers a question about neither (#3512). */
  memberDistinctRoleCount: Scalars["Int"]["output"];
  /** Opaque grouping key: two officer rows carrying the same key are one member, and two carrying different keys are not known to be. Count a member-scoped verdict — requiresManualAssignment, isUnderCredited — over distinct keys rather than over rows, or a member holding two records is reported twice. Never parse it, and never derive a second grouping of your own (#3550). */
  memberKey: Scalars["String"]["output"];
  /** Toastmasters membership number */
  membershipNumber: Scalars["String"]["output"];
  /** Emails of records merged into this one */
  mergedFromEmails: Array<Scalars["String"]["output"]>;
  /** Email of record this was merged into */
  mergedIntoEmail?: Maybe<Scalars["String"]["output"]>;
  /** Officer name */
  name: Scalars["String"]["output"];
  /** The district's mark that this person is not an officer of the round, such as a presenter. A marked record is left out of the round's officer counts, training figures, club summaries, broadcast audiences and officer exports. Its registrations still count as matched (#5709) */
  notOfficerMark?: Maybe<CotNotOfficerMark>;
  /** Unique record identifier */
  recordId: Scalars["ID"]["output"];
  /** Override/corrections applied to this record */
  recordOverride?: Maybe<CotRecordOverride>;
  /** Session registrations matched to this officer record */
  registrations: Array<CotEventRegistrationRef>;
  /** Whether this officer needs manual training-to-role assignment */
  requiresManualAssignment: Scalars["Boolean"]["output"];
  /** Source of this record (district_import, registration) */
  source: Scalars["String"]["output"];
  /** List of distinct role types that still need training assignment */
  unassignedRoleTypes: Array<Scalars["String"]["output"]>;
  /** Linked system user ID */
  userId?: Maybe<Scalars["ID"]["output"]>;
};

/** Role group for a club-detail projection */
export type CotClubRoleDetail = {
  __typename: "COTClubRoleDetail";
  officers: Array<CotClubDetailOfficer>;
  role: Scalars["String"]["output"];
};

/** Per-role club completion status used by the COT club summary view */
export type CotClubRoleStatus = {
  __typename: "COTClubRoleStatus";
  email?: Maybe<Scalars["String"]["output"]>;
  hasCompleted: Scalars["Boolean"]["output"];
  officerName?: Maybe<Scalars["String"]["output"]>;
  /** recordId of the officer holding this role, for acting on a TH/TI mismatch in bulk */
  recordId?: Maybe<Scalars["ID"]["output"]>;
  role: CotOfficerRole;
  roleDisplayName: Scalars["String"]["output"];
  tiHasCompleted?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Club-level COT completion summary */
export type CotClubSummary = {
  __typename: "COTClubSummary";
  areaId: Scalars["String"]["output"];
  clubId: Scalars["ID"]["output"];
  clubName: Scalars["String"]["output"];
  completedRoles: Array<Scalars["String"]["output"]>;
  completionPercentage: Scalars["Int"]["output"];
  /** DCP compliance for this round: 'compliant' (>=4 of 7 trained), 'at-risk' (1-3 trained), or 'not-met' (0 trained) */
  complianceStatus: Scalars["String"]["output"];
  divisionId: Scalars["String"]["output"];
  hasDisagreement: Scalars["Boolean"]["output"];
  incompleteRoles: Array<Scalars["String"]["output"]>;
  /** True when this club is counted by the round's figures. Only chartered clubs are, so a false here is a club the Clubs tab lists and no DCP figure counts. */
  isChartered: Scalars["Boolean"]["output"];
  isCorporate: Scalars["Boolean"]["output"];
  /** The club's TI lifecycle status: 'Active' (chartered), 'Prospective' (being formed) or 'Suspended'. Distinct from the DCP performance grades, which are all 'Active' here. */
  lifecycleStatus: Scalars["String"]["output"];
  officers: Array<CotClubRoleStatus>;
  /** The date TI suspended the charter, where TI recorded one. Null on any club that is not suspended, and on a suspended club TI gave no date for. */
  suspendDate?: Maybe<Scalars["String"]["output"]>;
  /** Number of distinct officer roles (of 7) with a trained officer */
  trainedOfficerCount: Scalars["Int"]["output"];
};

/** Per-home-district outcome of a cross-district credit handoff */
export type CotCrossDistrictHandoffDistrict = {
  __typename: "COTCrossDistrictHandoffDistrict";
  /** External attendees from this home district who earned credit at the hosting session */
  completedAttendees: Scalars["Int"]["output"];
  /** Existing home-district officer records that received credit */
  creditedOfficers: Scalars["Int"]["output"];
  homeDistrictNumber: Scalars["String"]["output"];
  /** New officer records created in the home round because no existing officer matched */
  newOfficers: Scalars["Int"]["output"];
  /** True when this home district exists on this ToastHost instance and was auto-credited */
  onPlatform: Scalars["Boolean"]["output"];
  /** Set when an on-platform home could not be credited (e.g. no matching round) */
  skippedReason?: Maybe<Scalars["String"]["output"]>;
};

/** Result of applyCOTCrossDistrictHandoff */
export type CotCrossDistrictHandoffResult = {
  __typename: "COTCrossDistrictHandoffResult";
  message?: Maybe<Scalars["String"]["output"]>;
  /** Home district numbers not on this instance — still need the manual CSV export */
  offPlatformDistricts: Array<Scalars["String"]["output"]>;
  /** On-platform home districts and what was applied to each */
  onPlatform: Array<CotCrossDistrictHandoffDistrict>;
  success: Scalars["Boolean"]["output"];
  /** Total officer records credited across all on-platform home districts */
  totalCredited: Scalars["Int"]["output"];
};

/** Result of a delete operation */
export type CotDeleteResult = {
  __typename: "COTDeleteResult";
  deletedId?: Maybe<Scalars["ID"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

/** A note added by a district officer to an officer record */
export type CotDistrictNote = {
  __typename: "COTDistrictNote";
  /** When the note was added */
  addedAt: Scalars["String"]["output"];
  /** User ID of who added the note */
  addedBy: Scalars["ID"]["output"];
  /** Name of who added the note */
  addedByName: Scalars["String"]["output"];
  /** The note content */
  note: Scalars["String"]["output"];
};

/** A COT event containing sessions and registrations */
export type CotEvent = {
  __typename: "COTEvent";
  /** Why the district cancelled the event (#2640) */
  cancellationReason?: Maybe<Scalars["String"]["output"]>;
  /** ISO-8601 timestamp when the district cancelled the event (#2640). Null unless CANCELLED */
  cancelledAt?: Maybe<Scalars["String"]["output"]>;
  /** Session description */
  description: Scalars["String"]["output"];
  /** Whether registration is handled off-platform */
  externalRegistration: Scalars["Boolean"]["output"];
  /** Users named as hosts of this event, authorised to run the live-attendance tab (#2798) */
  hosts: Array<CotEventHost>;
  /** Unique session identifier */
  id: Scalars["ID"]["output"];
  /** A test event (#5598): shown only to senior officers, and earns no credit */
  isTest: Scalars["Boolean"]["output"];
  /** Number of active registrations the matcher links to one officer */
  matchedCount: Scalars["Int"]["output"];
  /** Session name */
  name: Scalars["String"]["output"];
  /** Parent COT program ID */
  programId: Scalars["ID"]["output"];
  /** Phase 1D: whether the public unauthenticated registration URL accepts submissions */
  publicLinkEnabled: Scalars["Boolean"]["output"];
  /** Lifecycle state */
  publishStatus: CotEventPublishStatus;
  /** ISO-8601 timestamp when registration closes */
  registrationClosesAt?: Maybe<Scalars["String"]["output"]>;
  /** Total number of registrations */
  registrationCount: Scalars["Int"]["output"];
  /** ISO-8601 timestamp when registration opens */
  registrationOpensAt?: Maybe<Scalars["String"]["output"]>;
  /** Registrations for this session. The full roster (names/emails/member numbers) is returned to any district officer; a non-officer caller receives just their own row (#1795). */
  registrations: Array<CotEventRegistration>;
  /** Required qualifying sessions for events whose sessions carry no session type */
  requiredSessionCount: Scalars["Int"]["output"];
  /** Number of active registrations the matcher links to no single officer, leaving out those marked as not an officer */
  unmatchedCount: Scalars["Int"]["output"];
  /** What the requester may do to this event (#2798) */
  viewerCapabilities: CotViewerCapabilities;
};

/** A COT event projected for the event view */
export type CotEventDetail = {
  __typename: "COTEventDetail";
  /** Why the district cancelled the event (#2640) */
  cancellationReason?: Maybe<Scalars["String"]["output"]>;
  /** ISO-8601 timestamp when the district cancelled the event (#2640). Null unless CANCELLED */
  cancelledAt?: Maybe<Scalars["String"]["output"]>;
  description: Scalars["String"]["output"];
  externalRegistration: Scalars["Boolean"]["output"];
  /** Users named as hosts of this event, authorised to run the live-attendance tab (#2798) */
  hosts: Array<CotEventHost>;
  id: Scalars["ID"]["output"];
  /** A test event (#5598): shown only to senior officers, and earns no credit */
  isTest: Scalars["Boolean"]["output"];
  matchedCount: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  programId: Scalars["ID"]["output"];
  publishStatus: CotEventPublishStatus;
  registrationClosesAt?: Maybe<Scalars["String"]["output"]>;
  registrationCount: Scalars["Int"]["output"];
  registrationOpensAt?: Maybe<Scalars["String"]["output"]>;
  registrations: Array<CotEventRegistrationDetail>;
  requiredSessionCount: Scalars["Int"]["output"];
  unmatchedCount: Scalars["Int"]["output"];
  /** What the requester may do to this event (#2798). The event page renders its controls from this rather than from the viewer's standing, so a locked round or a host without officer standing is reflected without each control re-deriving the rule. */
  viewerCapabilities: CotViewerCapabilities;
  /** True when the requester is an admin or a senior officer of this event's district (#2720). The event page is open to any district officer, so surfaces backed by a senior-only mutation — currently the cross-district credit handoff — need this to hide rather than fail. */
  viewerIsSeniorOfficer: Scalars["Boolean"]["output"];
};

/** A user named as a host of a COT event */
export type CotEventHost = {
  __typename: "COTEventHost";
  /** Display name, masked to the viewer's district tier */
  name: Scalars["String"]["output"];
  userId: Scalars["ID"]["output"];
};

/** Lifecycle state for a COT event */
export enum CotEventPublishStatus {
  /** Called off (#2640). Terminal, still visible to its former registrants so they can read cancellationReason; never open for registration, never broadcast about */
  Cancelled = "CANCELLED",
  /** Authoring state — visible only to district officers, admins and the event's named hosts */
  Draft = "DRAFT",
  /** Live: visible to officers; open for registration if within window */
  Published = "PUBLISHED",
}

/** Registration record for a COT event */
export type CotEventRegistration = {
  __typename: "COTEventRegistration";
  /** Approval status of the registration */
  approvalStatus: Scalars["String"]["output"];
  /** Area */
  area: Scalars["String"]["output"];
  /** ISO-8601 instant when the registration was cancelled, if ever */
  cancelledAt?: Maybe<Scalars["String"]["output"]>;
  /** Club name */
  clubName: Scalars["String"]["output"];
  /** Club officer role */
  clubRole: Scalars["String"]["output"];
  /** Display name */
  displayName: Scalars["String"]["output"];
  /** District */
  district: Scalars["String"]["output"];
  /** Division */
  division: Scalars["String"]["output"];
  /** Registrant's email */
  email: Scalars["String"]["output"];
  /** Set when the registrant is from a non-ToastHost district (Phase 1D public form) */
  externalAttendee?: Maybe<ExternalAttendeeInfo>;
  /** Registrant's first name */
  firstName: Scalars["String"]["output"];
  /** Convenience: true when cancelledAt is set */
  isCancelled: Scalars["Boolean"]["output"];
  /** Whether this registration is matched to an officer record */
  isMatched: Scalars["Boolean"]["output"];
  /** Convenience: true when the registration is on the waitlist (#1740) */
  isWaitlisted: Scalars["Boolean"]["output"];
  /** Registrant's last name */
  lastName: Scalars["String"]["output"];
  /** Toastmasters member number */
  memberNumber: Scalars["String"]["output"];
  /** Per-registration channel toggles for reminders / confirmations */
  notificationPrefs: NotificationPrefs;
  /** Manually linked officer record ID */
  officerRecordId?: Maybe<Scalars["String"]["output"]>;
  /** ISO-8601 instant when the registration was created */
  registeredAt: Scalars["String"]["output"];
  /** The row's stable identity, opaque. Null for a row persisted before the id existed; such a row is still selected by its address (#4814). */
  registrationId?: Maybe<Scalars["String"]["output"]>;
  /** When the registration was made */
  registrationTime: Scalars["String"]["output"];
  /** Officer's stated intent: which roles they want credit for at this session */
  seekingCreditForRoles: Array<CotOfficerClubRole>;
  /** How this registration entered the system */
  source: RegistrationSource;
  /** Linked system user ID, if matched */
  userId?: Maybe<Scalars["ID"]["output"]>;
  /** ISO-8601 instant when the registrant joined the waitlist, if waiting (#1740) */
  waitlistedAt?: Maybe<Scalars["String"]["output"]>;
};

/** Registration record enriched for the COT event view */
export type CotEventRegistrationDetail = {
  __typename: "COTEventRegistrationDetail";
  approvalStatus: Scalars["String"]["output"];
  area: Scalars["String"]["output"];
  cancelledAt?: Maybe<Scalars["String"]["output"]>;
  clubName: Scalars["String"]["output"];
  clubRole: Scalars["String"]["output"];
  displayName: Scalars["String"]["output"];
  district: Scalars["String"]["output"];
  division: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  externalAttendee?: Maybe<ExternalAttendeeInfo>;
  firstName: Scalars["String"]["output"];
  hasCompletedTraining: Scalars["Boolean"]["output"];
  isCancelled: Scalars["Boolean"]["output"];
  isMatched: Scalars["Boolean"]["output"];
  /** Whether this registration counts as unmatched: it holds a place (not cancelled, waitlisted or pending verification), the matcher found no single officer for it, and it is not marked as not an officer */
  isUnmatched: Scalars["Boolean"]["output"];
  lastName: Scalars["String"]["output"];
  linkedOfficerMatchType: Scalars["String"]["output"];
  linkedOfficerRecordId?: Maybe<Scalars["String"]["output"]>;
  memberNumber: Scalars["String"]["output"];
  /** The district's mark that this registrant is not an officer. A marked row that the matcher matches is still matched, and a marked row with no match is neither matched nor unmatched. */
  notOfficerMark?: Maybe<CotNotOfficerMark>;
  notificationPrefs: NotificationPrefs;
  officerRecordId?: Maybe<Scalars["String"]["output"]>;
  registeredAt: Scalars["String"]["output"];
  registrationId?: Maybe<Scalars["String"]["output"]>;
  registrationTime: Scalars["String"]["output"];
  seekingCreditForRoles: Array<CotOfficerClubRole>;
  sessionsAttended: Scalars["Int"]["output"];
  sessionsAttendedDetails: Array<CotSessionAttendanceDetail>;
  source: RegistrationSource;
  userId?: Maybe<Scalars["ID"]["output"]>;
};

/** A registration reference linking an officer record to a session registration */
export type CotEventRegistrationRef = {
  __typename: "COTEventRegistrationRef";
  /** The event this registration belongs to */
  eventId: Scalars["ID"]["output"];
  /** The full registration data */
  registrationData: CotEventRegistration;
  /** When the registration was made */
  registrationTime: Scalars["String"]["output"];
  /** The specific session, if known */
  sessionId?: Maybe<Scalars["ID"]["output"]>;
};

/** Result of a COT event mutation */
export type CotEventResult = {
  __typename: "COTEventResult";
  event?: Maybe<CotEvent>;
  message?: Maybe<Scalars["String"]["output"]>;
  pendingVerification: Scalars["Boolean"]["output"];
  success: Scalars["Boolean"]["output"];
  /** True when the registrant joined the waitlist because the event was full (#1740) */
  waitlisted: Scalars["Boolean"]["output"];
};

/** One session of a COT event, for a list view that renders a line per session */
export type CotEventSessionSummary = {
  __typename: "COTEventSessionSummary";
  /** Start of the session as a zoneless wall time in the district's own timezone */
  dateTime: Scalars["String"]["output"];
  /** Length of the session in minutes */
  duration: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  sessionId: Scalars["ID"]["output"];
  /** COT part code — null = Full, 1 = Part 1, 2 = Role Specific, 3 = Part 2 */
  sessionType?: Maybe<Scalars["Int"]["output"]>;
  /** Derived time state of this session (#2639) — Scheduled, In progress or Finished */
  timeState: CotTimeState;
};

/** Summary of a COT event for list views */
export type CotEventSummary = {
  __typename: "COTEventSummary";
  completedCount: Scalars["Int"]["output"];
  description: Scalars["String"]["output"];
  eventId: Scalars["ID"]["output"];
  externalRegistration: Scalars["Boolean"]["output"];
  /** Date of the event's earliest session. Null when no session is scheduled. */
  firstSessionDate?: Maybe<Scalars["String"]["output"]>;
  /** A test event (#5598): shown only to senior officers, and earns no credit */
  isTest: Scalars["Boolean"]["output"];
  /** Date of the event's latest session, omitted when it falls on the same day as the first. */
  lastSessionDate?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  publishStatus: CotEventPublishStatus;
  registrationClosesAt?: Maybe<Scalars["String"]["output"]>;
  registrationCount: Scalars["Int"]["output"];
  registrationOpensAt?: Maybe<Scalars["String"]["output"]>;
  /** Number of sessions scheduled under this event */
  sessionCount: Scalars["Int"]["output"];
  /** The event's sessions in date order, each with its part and derived time state (#2654). Empty when no session has been scheduled yet, which is a normal state. */
  sessions: Array<CotEventSessionSummary>;
  unmatchedCount: Scalars["Int"]["output"];
};

/** External COT completion record for training done outside the system */
export type CotExternalCompletion = {
  __typename: "COTExternalCompletion";
  /** Date logged on District Central */
  dateLoggedOnDistrictCentral: Scalars["String"]["output"];
  /** Date the training occurred */
  dateOfTraining: Scalars["String"]["output"];
  /** Who logged this completion */
  loggedBy: Scalars["String"]["output"];
  /** Name of the COT event */
  nameOfCOT: Scalars["String"]["output"];
  /** Source of the completion record */
  source: Scalars["String"]["output"];
};

/** Single registrant mark-attended outcome */
export type CotLiveAttendanceItem = {
  __typename: "COTLiveAttendanceItem";
  attendance: CotSessionAttendance;
  registrationEmail: Scalars["String"]["output"];
};

/** Result of markCOTAttendanceLive */
export type CotLiveAttendanceResult = {
  __typename: "COTLiveAttendanceResult";
  items: Array<CotLiveAttendanceItem>;
  message?: Maybe<Scalars["String"]["output"]>;
  session?: Maybe<CotSession>;
  success: Scalars["Boolean"]["output"];
};

/** A manual role assignment made by a district officer when credits < distinct roles */
export type CotManualRoleAssignment = {
  __typename: "COTManualRoleAssignment";
  /** When the assignment was made */
  assignedAt: Scalars["String"]["output"];
  /** User ID who made the assignment */
  assignedBy: Scalars["ID"]["output"];
  /** Session ID credited to this role (None for external completion) */
  eventId?: Maybe<Scalars["ID"]["output"]>;
  /** Notes about the assignment */
  notes?: Maybe<Scalars["String"]["output"]>;
  /** The role type being assigned */
  roleType: CotOfficerRole;
};

export type CotManualRoleAssignmentInput = {
  /** Event credited to this assignment */
  eventId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Optional notes */
  notes?: InputMaybe<Scalars["String"]["input"]>;
  /** Officer role type */
  roleType: Scalars["String"]["input"];
};

/** A manual training credit added by a district officer */
export type CotManualTrainingCredit = {
  __typename: "COTManualTrainingCredit";
  /** When the credit was added */
  addedAt: Scalars["String"]["output"];
  /** Name of who added the credit */
  addedByName: Scalars["String"]["output"];
  /** Unique credit identifier */
  creditId: Scalars["ID"]["output"];
  /** Reason the credit was added */
  reason: Scalars["String"]["output"];
  /** Date when external training occurred */
  trainingDate?: Maybe<Scalars["String"]["output"]>;
  /** Description of the external training */
  trainingDescription?: Maybe<Scalars["String"]["output"]>;
};

/** A member's manual role assignment state and the opaque token naming it, from one read */
export type CotMemberAssignmentState = {
  __typename: "COTMemberAssignmentState";
  /** Every record this member holds, the one asked for first. Derive an assignment request from these rather than from a roster fetched by an earlier query: the token describes this set and nothing else, so a request built from anything staler can carry a token that vouches for state it never showed. */
  memberRecords: Array<CotClubOfficerRecord>;
  /** Opaque token naming these assignments. Pass it to setCOTManualRoleAssignments as expectedAssignmentToken; that write is refused with COT_CONFLICT if the member's assignments changed in between (#3571). Never parse or construct one. */
  token: Scalars["String"]["output"];
};

/** A district officer's record that this person is not an officer. On a registration it leaves an active row with no officer match out of the unmatched counts, and has no effect on a matched row or a cancelled, waitlisted or pending one. On an officer record it leaves the record out of the round's roster */
export type CotNotOfficerMark = {
  __typename: "COTNotOfficerMark";
  markedAt: Scalars["String"]["output"];
  markedBy?: Maybe<Scalars["ID"]["output"]>;
  markedByName: Scalars["String"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  reason: CotNotOfficerReason;
};

/** A registration that a not-an-officer mark did not reach, and why */
export type CotNotOfficerMarkRefusal = {
  __typename: "COTNotOfficerMarkRefusal";
  email: Scalars["String"]["output"];
  errorCode: Scalars["String"]["output"];
  eventId: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
  registrationId?: Maybe<Scalars["String"]["output"]>;
};

/** Result of setting or clearing a registration's not-an-officer mark */
export type CotNotOfficerMarkResult = {
  __typename: "COTNotOfficerMarkResult";
  errorCode?: Maybe<Scalars["String"]["output"]>;
  markedCount: Scalars["Int"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  refused: Array<CotNotOfficerMarkRefusal>;
  success: Scalars["Boolean"]["output"];
};

/** Why a COT registrant or officer record is not an officer of the round */
export enum CotNotOfficerReason {
  /** A guest, not a club officer */
  Guest = "GUEST",
  /** Another reason. The note, which is optional, can say which */
  Other = "OTHER",
  /** A presenter at the training */
  Presenter = "PRESENTER",
}

/** An officer's role at a specific club with training status */
export type CotOfficerClubRole = {
  __typename: "COTOfficerClubRole";
  /** Area ID */
  areaId?: Maybe<Scalars["String"]["output"]>;
  /** Club ID */
  clubId: Scalars["ID"]["output"];
  /** Name of the club */
  clubName?: Maybe<Scalars["String"]["output"]>;
  /** ID of the session where training was completed */
  completedEventId?: Maybe<Scalars["ID"]["output"]>;
  /** District ID */
  districtId?: Maybe<Scalars["String"]["output"]>;
  /** Division ID */
  divisionId?: Maybe<Scalars["String"]["output"]>;
  /** Whether training is complete for this role */
  hasCompletedTraining: Scalars["Boolean"]["output"];
  /** Whether this is a corporate club */
  isCorporate: Scalars["Boolean"]["output"];
  /** The officer role */
  role: CotOfficerRole;
  /** Short role abbreviation */
  roleAbbreviation: Scalars["String"]["output"];
  /** Human-readable role name */
  roleDisplayName: Scalars["String"]["output"];
  /** TI recorded training status (None = no TI data imported) */
  tiHasCompletedTraining?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CotOfficerClubRoleInput = {
  /** Area ID */
  areaId?: InputMaybe<Scalars["String"]["input"]>;
  /** Club ID */
  clubId: Scalars["ID"]["input"];
  /** Club name */
  clubName?: InputMaybe<Scalars["String"]["input"]>;
  /** District ID */
  districtId?: InputMaybe<Scalars["String"]["input"]>;
  /** Division ID */
  divisionId?: InputMaybe<Scalars["String"]["input"]>;
  /** Officer role */
  role: Scalars["String"]["input"];
};

/** A candidate officer when a registration's matching key resolves to multiple officers (#1686) */
export type CotOfficerMatchCandidate = {
  __typename: "COTOfficerMatchCandidate";
  clubName?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  membershipNumber?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  recordId: Scalars["String"]["output"];
};

/** Result of an officer mutation */
export type CotOfficerMutationResult = {
  __typename: "COTOfficerMutationResult";
  errorCode?: Maybe<Scalars["String"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  officer?: Maybe<CotClubOfficerRecord>;
  success: Scalars["Boolean"]["output"];
};

/** Officer roles requiring COT training */
export enum CotOfficerRole {
  /** Club President */
  President = "PRESIDENT",
  /** Club Secretary */
  Secretary = "SECRETARY",
  /** Sergeant at Arms */
  SergeantAtArms = "SERGEANT_AT_ARMS",
  /** Club Treasurer */
  Treasurer = "TREASURER",
  /** VP of Education */
  VpEducation = "VP_EDUCATION",
  /** VP of Membership */
  VpMembership = "VP_MEMBERSHIP",
  /** VP of Public Relations */
  VpPublicRelations = "VP_PUBLIC_RELATIONS",
}

/** Result of an officer record override */
export type CotOverrideResult = {
  __typename: "COTOverrideResult";
  errorCode?: Maybe<Scalars["String"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  officer?: Maybe<CotClubOfficerRecord>;
  success: Scalars["Boolean"]["output"];
};

/** Summary of a Club Officer Training program */
export type CotProgramSummary = {
  __typename: "COTProgramSummary";
  /** COT Program ID */
  cotId: Scalars["ID"]["output"];
  /** Session number within the year */
  sessionNumber: Scalars["Int"]["output"];
  /** Toastmasters year */
  toastmastersYear: Scalars["Int"]["output"];
};

/** Override/correction applied to an officer record */
export type CotRecordOverride = {
  __typename: "COTRecordOverride";
  /** Corrected email, if changed */
  correctedEmail?: Maybe<Scalars["String"]["output"]>;
  /** Corrected membership number, if changed */
  correctedMembershipNumber?: Maybe<Scalars["String"]["output"]>;
  /** Corrected name, if changed */
  correctedName?: Maybe<Scalars["String"]["output"]>;
  /** Corrected user ID link, if changed */
  correctedUserId?: Maybe<Scalars["ID"]["output"]>;
  /** Notes about the override */
  notes?: Maybe<Scalars["String"]["output"]>;
  /** Original email before override */
  originalEmail?: Maybe<Scalars["String"]["output"]>;
  /** Original membership number before override */
  originalMembershipNumber?: Maybe<Scalars["String"]["output"]>;
  /** Original name before override */
  originalName?: Maybe<Scalars["String"]["output"]>;
  /** Original user ID before override */
  originalUserId?: Maybe<Scalars["ID"]["output"]>;
  /** When the override was made */
  overriddenAt: Scalars["String"]["output"];
  /** User ID who made the override */
  overriddenBy: Scalars["ID"]["output"];
};

/** Result of a completion status refresh */
export type CotRefreshResult = {
  __typename: "COTRefreshResult";
  completionsUpdated: Scalars["Int"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  officersRefreshed: Scalars["Int"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type CotRegistrationTargetInput = {
  /** Registration email */
  email: Scalars["String"]["input"];
  /** The event the registration is on */
  eventId: Scalars["ID"]["input"];
  /** Registration row id, when the row has one */
  registrationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** A COT training round/program for a district */
export type CotRound = {
  __typename: "COTRound";
  /** Number of officers who completed training, counted over the records officerCount counts */
  completedCount: Scalars["Int"]["output"];
  /** completedCount as a percentage of officerCount */
  completionPercentage: Scalars["Float"]["output"];
  /** Human-readable date range */
  dateRange: Scalars["String"]["output"];
  /** Display name (year + round) */
  displayName: Scalars["String"]["output"];
  /** District ID */
  districtId: Scalars["ID"]["output"];
  /** End date of the training period */
  endDate: Scalars["String"]["output"];
  /** Events in this round whose training is known to have run. An officer whose every active registration names one of these registered and did not complete; anyone else is still awaiting training. Deliberately the finished set rather than the outstanding one: an event with no sessions has no time state, and an event deleted while a registration still names it is gone from the round entirely, so both are absent here - and absent means unknown, not finished. */
  finishedEventIds: Array<Scalars["ID"]["output"]>;
  /** Unique program identifier */
  id: Scalars["ID"]["output"];
  /** Whether this round is currently active */
  isActive: Scalars["Boolean"]["output"];
  /** Whether this round is locked for editing */
  isLocked: Scalars["Boolean"]["output"];
  /** Date of the last TI data import (from TI spreadsheet header) */
  lastTIImportDate?: Maybe<Scalars["String"]["output"]>;
  /** When the last TI import was performed */
  lastTIImportedAt?: Maybe<Scalars["String"]["output"]>;
  /** Who performed the last TI import */
  lastTIImportedBy?: Maybe<Scalars["ID"]["output"]>;
  /** ISO date on which this round locks for editing (endDate + 1 month) */
  lockDate: Scalars["String"]["output"];
  /** Program name */
  name: Scalars["String"]["output"];
  /** Number of officers: records neither merged nor marked as not an officer */
  officerCount: Scalars["Int"]["output"];
  /** Officer records in this COT round, excluding merged records. Includes records marked as not an officer, which carry notOfficerMark and are left out of officerCount, completedCount and completionPercentage */
  officers: Array<CotClubOfficerRecord>;
  /** Round number (1 or 2) */
  roundNumber: Scalars["Int"]["output"];
  /** Start date of the training period */
  startDate: Scalars["String"]["output"];
  /** Where this round stands today: Active inside its training window, otherwise Preview before its stored start date, otherwise Inactive */
  status: CotRoundStatus;
  /** Toastmasters year (e.g., 2024) */
  toastmastersYear: Scalars["Int"]["output"];
  /** True when the requester may see and create test events in this round (#5598): an admin, or a senior officer of the round's district */
  viewerSeesTestEvents: Scalars["Boolean"]["output"];
  /** Year range display (e.g., '2024-25') */
  yearRange: Scalars["String"]["output"];
};

/** The name and lock state of a COT round, without its officer records */
export type CotRoundMeta = {
  __typename: "COTRoundMeta";
  displayName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isLocked: Scalars["Boolean"]["output"];
  lastTIImportDate?: Maybe<Scalars["String"]["output"]>;
  lockDate: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

/** Where a COT round stands today, calculated from its dates */
export enum CotRoundStatus {
  /** Inside its training window */
  Active = "ACTIVE",
  /** Neither Active nor Preview: outside its training window, on or after its stored start date */
  Inactive = "INACTIVE",
  /** Outside its training window and before its stored start date: only senior district officers and admins can see it */
  Preview = "PREVIEW",
}

/** A session within a COT event (one part, or a full session) */
export type CotSession = {
  __typename: "COTSession";
  /** Attendance records for this event */
  attendance: Array<CotSessionAttendance>;
  /** Total number of attendees */
  attendanceCount: Scalars["Int"]["output"];
  /** Event date and time */
  dateTime: Scalars["String"]["output"];
  /** Event description */
  description: Scalars["String"]["output"];
  /** Duration in minutes */
  duration: Scalars["Int"]["output"];
  /** Human-readable duration */
  durationDisplay: Scalars["String"]["output"];
  /** Parent session ID */
  eventId: Scalars["ID"]["output"];
  /** Unique event identifier */
  id: Scalars["ID"]["output"];
  /** Whether the event is at capacity */
  isFull: Scalars["Boolean"]["output"];
  /** Joining URL for virtual/hybrid events (e.g., Zoom link) */
  joiningUrl?: Maybe<Scalars["String"]["output"]>;
  /** Event location */
  location?: Maybe<Scalars["String"]["output"]>;
  /** Maximum number of attendees */
  maxAttendees?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum duration for qualifying attendance */
  minimumDurationMinutes: Scalars["Int"]["output"];
  /** Event name */
  name: Scalars["String"]["output"];
  /** Number of attendees who met minimum duration */
  qualifyingAttendanceCount: Scalars["Int"]["output"];
  /** 1/2/3 for modules, null for full session */
  sessionType?: Maybe<Scalars["Int"]["output"]>;
  /** Human-readable session type */
  sessionTypeDisplay: Scalars["String"]["output"];
  /** Derived time state of this session (#2639) — Scheduled before it starts, In progress while it runs, Finished after. Composes with the parent event's publishStatus. */
  timeState: CotTimeState;
  /** What the requester may do to this sitting and its event (#2798). Every control on the sitting page renders from this, so none is offered for an action its mutation would refuse. */
  viewerCapabilities: CotViewerCapabilities;
};

/** Attendance record for a COT session */
export type CotSessionAttendance = {
  __typename: "COTSessionAttendance";
  /** Club name, if identified */
  club?: Maybe<Scalars["String"]["output"]>;
  /** Duration of attendance in minutes */
  durationMinutes: Scalars["Int"]["output"];
  /** Attendee email */
  email: Scalars["String"]["output"];
  /** When the attendee joined */
  joinTime: Scalars["String"]["output"];
  /** When the attendee left */
  leaveTime: Scalars["String"]["output"];
  /** Attendee name */
  name: Scalars["String"]["output"];
  /** The registration this row was credited to when it was written. Null when nothing on the event separated one registration; such a row is resolved by address only where the address holds one. */
  registrationId?: Maybe<Scalars["ID"]["output"]>;
  /** Officer role, if identified */
  role?: Maybe<Scalars["String"]["output"]>;
  /** Phase 1G: how this attendance row was captured */
  source: CotAttendanceSource;
};

/** Attendance detail for a registration on the COT event view */
export type CotSessionAttendanceDetail = {
  __typename: "COTSessionAttendanceDetail";
  duration: Scalars["Int"]["output"];
  isQualifying: Scalars["Boolean"]["output"];
  minDuration: Scalars["Int"]["output"];
  sessionId: Scalars["ID"]["output"];
  sessionName: Scalars["String"]["output"];
  sessionType: Scalars["String"]["output"];
};

/** Result of a COT session mutation */
export type CotSessionResult = {
  __typename: "COTSessionResult";
  message?: Maybe<Scalars["String"]["output"]>;
  session?: Maybe<CotSession>;
  success: Scalars["Boolean"]["output"];
};

/** Derived time state of a COT session or event */
export enum CotTimeState {
  /** Has run its full duration */
  Finished = "FINISHED",
  /** Started and still running */
  InProgress = "IN_PROGRESS",
  /** Has not started yet */
  Scheduled = "SCHEDULED",
}

/** One division's slice of a COT round, in the same units as the round summary */
export type CotTrainingDivisionRow = {
  __typename: "COTTrainingDivisionRow";
  /** Division label, or 'Unassigned' */
  division: Scalars["String"]["output"];
  /** People: officers serving a club in this division */
  officers: Scalars["Int"]["output"];
  peopleAwaitingAssignment: Scalars["Int"]["output"];
  peopleAwaitingTraining: Scalars["Int"]["output"];
  peopleDidNotComplete: Scalars["Int"]["output"];
  peopleFullyTrained: Scalars["Int"]["output"];
  peopleNotRegistered: Scalars["Int"]["output"];
  peoplePartlyTrained: Scalars["Int"]["output"];
  peopleTrained: Scalars["Int"]["output"];
  roleTypesHeld: Scalars["Int"]["output"];
  roleTypesTrained: Scalars["Int"]["output"];
};

/** A COT round's headline figures, each naming the unit it counts */
export type CotTrainingSummary = {
  __typename: "COTTrainingSummary";
  /** Club role slots: club x role held by anyone. The shape of TI's District Club Officer Training spreadsheet. */
  clubRoleSlots: Scalars["Int"]["output"];
  /** Club role slots: club x role with at least one trained holder */
  clubRoleSlotsTrained: Scalars["Int"]["output"];
  /** Clubs: those with 1 to 3 of the 7 roles trained */
  clubsAtRisk: Scalars["Int"]["output"];
  /** Clubs: the district's chartered clubs, the set every figure here counts over. Narrower than the Clubs tab's list, which also shows prospective and suspended clubs. */
  clubsCovered: Scalars["Int"]["output"];
  /** Clubs: those with all 7 roles trained */
  clubsFullyTrained: Scalars["Int"]["output"];
  /** Clubs: those with 4 or more of the 7 roles trained, the DCP goal */
  clubsMeetingGoal: Scalars["Int"]["output"];
  /** Clubs: those with no role trained. With clubsMeetingGoal and clubsAtRisk, partitions clubsCovered. */
  clubsNotMet: Scalars["Int"]["output"];
  /** Clubs: those with at least one officer on the roster */
  clubsWithOfficers: Scalars["Int"]["output"];
  /** The same population broken down by division, over the same club scope, so the breakdown and the headline cannot disagree. A member serving two divisions appears in both rows, so these can sum to more than `officers`. */
  divisions: Array<CotTrainingDivisionRow>;
  /** People: officers holding at least one role at a chartered club of this district. The base every people* percentage divides by. */
  officers: Scalars["Int"]["output"];
  /** People: credits earned, but which role each pays for needs a district officer's decision, so nothing is credited yet. Distinct from the no-credit states: they have done the training. */
  peopleAwaitingAssignment: Scalars["Int"]["output"];
  /** People: nothing credited, registered for training that has not finished */
  peopleAwaitingTraining: Scalars["Int"]["output"];
  /** People: nothing credited, registered, and every event they registered for has finished. Deliberately not 'did not attend' - an attendance row that did not qualify still leaves an active registration and no credit, so this cannot tell a no-show from someone who turned up and did not complete. */
  peopleDidNotComplete: Scalars["Int"]["output"];
  /** People: every role type they hold is credited */
  peopleFullyTrained: Scalars["Int"]["output"];
  /** People: nothing credited and no active registration */
  peopleNotRegistered: Scalars["Int"]["output"];
  /** People: at least one role type credited and at least one not */
  peoplePartlyTrained: Scalars["Int"]["output"];
  /** People: at least one role type credited. Fully plus partly trained, not a partition member. */
  peopleTrained: Scalars["Int"]["output"];
  /** Records excluded from `officers` because they hold no role at a chartered club of this district - attendance-built records, member links, officers of other districts' clubs, and officers held only at a prospective or suspended club */
  recordsWithoutCoveredRole: Scalars["Int"]["output"];
  /** Officer role rows dropped by the projection because their club is not a chartered club of this district */
  roleRowsOutsideClubSet: Scalars["Int"]["output"];
  /** Officer role rows whose club could not be resolved from the attendee's own club name. Counted rather than dropped - the club needs matching, the officer is real - so this is a data-quality figure, not an exclusion. */
  roleRowsWithUnresolvedClub: Scalars["Int"]["output"];
  /** Role types: person x distinct role type. One credit covers a role type however many clubs the person holds it at, so this is the training workload. */
  roleTypesHeld: Scalars["Int"]["output"];
  /** Role types: person x distinct role type, credited */
  roleTypesTrained: Scalars["Int"]["output"];
  /** Role rows where TI and ToastHost disagree on completion */
  tiDisagreements: Scalars["Int"]["output"];
  /** Role rows in scope for comparison against Toastmasters International's own record */
  tiRoleRows: Scalars["Int"]["output"];
  /** Role rows an imported TI report actually says something about. Coverage, not a rival total. */
  tiRoleRowsWithData: Scalars["Int"]["output"];
};

/** An active registration (not cancelled, waitlisted or pending verification) that the matcher links to no single district officer record, or with the markedNotOfficer filter one marked as not an officer, matched or not */
export type CotUnmatchedAttendee = {
  __typename: "COTUnmatchedAttendee";
  ambiguousCandidates: Array<CotOfficerMatchCandidate>;
  attendanceTime: Scalars["String"]["output"];
  club?: Maybe<Scalars["String"]["output"]>;
  durationMinutes: Scalars["Int"]["output"];
  email: Scalars["String"]["output"];
  eventId: Scalars["ID"]["output"];
  eventName: Scalars["String"]["output"];
  isQualifying: Scalars["Boolean"]["output"];
  /** unmatched or ambiguous. matched only on a row the markedNotOfficer filter returns, whose mark has no effect because the matcher matches the row to an officer */
  matchStatus: Scalars["String"]["output"];
  membershipNumber?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  /** Set only on a row returned by the markedNotOfficer filter */
  notOfficerMark?: Maybe<CotNotOfficerMark>;
  /** The registration row this attendee is projected from, opaque. Null for a row persisted before the id existed; such a row is still selected by its address (#4814). */
  registrationId?: Maybe<Scalars["String"]["output"]>;
  role?: Maybe<Scalars["String"]["output"]>;
  sessionId: Scalars["ID"]["output"];
  sessionName: Scalars["String"]["output"];
};

/** Result of a CSV upload operation */
export type CotUploadResult = {
  __typename: "COTUploadResult";
  message?: Maybe<Scalars["String"]["output"]>;
  recordsMatched: Scalars["Int"]["output"];
  recordsProcessed: Scalars["Int"]["output"];
  recordsUnmatched: Scalars["Int"]["output"];
  success: Scalars["Boolean"]["output"];
};

/** What the requester may do here, computed by the same predicates the mutations gate on (#2798) */
export type CotViewerCapabilities = {
  __typename: "COTViewerCapabilities";
  /** Add a walk-in by hand: canManageAttendance, once the sitting has started */
  canAddManualAttendance: Scalars["Boolean"]["output"];
  /** Whether `districtOfficers` will answer for this viewer. A host from another district holds the event but not the district membership that query requires. */
  canListDistrictOfficers: Scalars["Boolean"]["output"];
  /** Import, edit or delete attendance: a district officer on an unlocked round */
  canManageAttendance: Scalars["Boolean"]["output"];
  /** Edit, publish, schedule or delete the event and its sittings */
  canManageEvent: Scalars["Boolean"]["output"];
  /** Add or remove hosts: an existing host, senior officer or admin, on an unlocked round */
  canManageHosts: Scalars["Boolean"]["output"];
  /** Mark or un-mark, right now: canRunLiveAttendance, once the sitting has started */
  canMarkAttendance: Scalars["Boolean"]["output"];
  /** Whether this event and its sittings are readable at all: a district officer, or a host named on the event. The same predicate `requireEventReadAuth` gates the reads with, so a client can tell that it has just lost access rather than discovering it on the next refused query. */
  canReadEvent: Scalars["Boolean"]["output"];
  /** Whether the live-attendance tab is this viewer's to run: an event host, on an unlocked round. No start-time term — the tab is what explains that marking is not yet open. */
  canRunLiveAttendance: Scalars["Boolean"]["output"];
  /** Standing, not permission: whether the viewer is an admin or current officer of the district */
  isDistrictOfficer: Scalars["Boolean"]["output"];
  /** Standing: admin or senior district officer, which the cross-district handoff requires */
  isSeniorOfficer: Scalars["Boolean"]["output"];
};

/** A meeting date with an activity category */
export type CategorizedMeetingDate = {
  __typename: "CategorizedMeetingDate";
  /** Activity category for the date */
  category: MeetingDateCategory;
  /** Meeting date (YYYY-MM-DD) */
  date: Scalars["String"]["output"];
};

/** One line on a dashboard chart (current or previous program year) */
export type ChartSeries = {
  __typename: "ChartSeries";
  label: Scalars["String"]["output"];
  points: Array<Scalars["Int"]["output"]>;
};

/** A consolidated, priority-resolved goal/threshold line */
export type ChartThreshold = {
  __typename: "ChartThreshold";
  label: Scalars["String"]["output"];
  level: Scalars["String"]["output"];
  qualified: Scalars["Boolean"]["output"];
  value: Scalars["Float"]["output"];
};

/** A real-time chat update event (message, reaction, presence, typing or activity) */
export type ChatUpdateEvent = {
  __typename: "ChatUpdateEvent";
  /** The chat event type (newMessage, reactionUpdated, userStatusUpdate, typingUpdate, userActivity) */
  eventType: Scalars["String"]["output"];
  /** The chat event envelope, shaped exactly as the SSE stream delivered it */
  payload: Scalars["JSON"]["output"];
};

/** A Toastmasters club */
export type Club = {
  __typename: "Club";
  /** Area ID */
  areaId: Scalars["String"]["output"];
  /** Club contact email (visible to members) */
  contactEmail?: Maybe<Scalars["String"]["output"]>;
  /** District ID */
  districtId: Scalars["String"]["output"];
  /** Division ID */
  divisionId: Scalars["String"]["output"];
  /** Guestbook configuration (requires officer/manager access) */
  guestbookConfig?: Maybe<GuestbookConfig>;
  /** Unique club identifier */
  id: Scalars["ID"]["output"];
  /** Whether this is a corporate club */
  isCorporate: Scalars["Boolean"]["output"];
  /** Full club name */
  longName: Scalars["String"]["output"];
  /** Club members (requires member access) */
  members: Array<ClubMemberBasic>;
  /** Current user's relationship to this club */
  myRelationship: ClubAuthLevel;
  /** Current club officers */
  officers: Array<ClubOfficer>;
  /** Short URL-friendly club name */
  shortName: Scalars["String"]["output"];
  /** Website configuration (requires officer/manager access) */
  webConfig?: Maybe<WebConfig>;
};

/** A club activity log entry */
export type ClubActivityEntry = {
  __typename: "ClubActivityEntry";
  /** Activity type code */
  activityType: Scalars["String"]["output"];
  /** Human-readable activity type */
  activityTypeDisplayName: Scalars["String"]["output"];
  /** Date and time of the activity */
  date: Scalars["String"]["output"];
  /** Linked email delivery log ID, if this activity is email-related */
  emailLogId?: Maybe<Scalars["Long"]["output"]>;
  /** Activity entry ID */
  id: Scalars["ID"]["output"];
  /** Additional information */
  info: Scalars["String"]["output"];
  /** Whether the activity timestamp is a legacy local wall-time value */
  isLegacyLocalTime: Scalars["Boolean"]["output"];
  /** Short description of the activity */
  shortDesc: Scalars["String"]["output"];
  /** The user associated with this activity */
  user?: Maybe<User>;
  /** User ID associated with the activity */
  userId?: Maybe<Scalars["ID"]["output"]>;
};

/** User's authorization level for a club */
export enum ClubAuthLevel {
  /** System admin */
  Admin = "ADMIN",
  /** Guest/visitor */
  Guest = "GUEST",
  /** Club manager */
  Manager = "MANAGER",
  /** Club member */
  Member = "MEMBER",
  /** No relationship */
  None = "NONE",
  /** Club officer */
  Officer = "OFFICER",
}

/** A connection to a list of Club items */
export type ClubConnection = {
  __typename: "ClubConnection";
  /** A list of edges */
  edges: Array<ClubEdge>;
  /** Pagination metadata */
  pageInfo: PageInfo;
  /** Total number of items in the connection */
  totalCount: Scalars["Int"]["output"];
};

/** DCP statistics for a single club */
export type ClubDcpData = {
  __typename: "ClubDCPData";
  activeMembers: Scalars["Int"]["output"];
  area: Scalars["String"]["output"];
  clubId: Scalars["Int"]["output"];
  clubName: Scalars["String"]["output"];
  dcpEligibility: Scalars["Boolean"]["output"];
  division: Scalars["String"]["output"];
  eligibleDCPPoints: Scalars["Int"]["output"];
  goalsMet: Scalars["Int"]["output"];
  isActive: Scalars["Boolean"]["output"];
  isIneligible: Scalars["Boolean"]["output"];
  isLow: Scalars["Boolean"]["output"];
  isSuspended: Scalars["Boolean"]["output"];
  shortName?: Maybe<Scalars["String"]["output"]>;
};

/** Dashboard data for a club */
export type ClubDashboardResponse = {
  __typename: "ClubDashboardResponse";
  areaId: Scalars["String"]["output"];
  areaName: Scalars["String"]["output"];
  asOfDate: Scalars["String"]["output"];
  clubData: Scalars["JSON"]["output"];
  clubId: Scalars["Int"]["output"];
  clubInfo?: Maybe<Scalars["JSON"]["output"]>;
  clubName: Scalars["String"]["output"];
  clubNumber: Scalars["Int"]["output"];
  /** Where clubWebsiteUrl came from: TOASTHOST, CLUB_CONFIG or TOASTMASTERS_INTERNATIONAL */
  clubWebsiteSource?: Maybe<Scalars["String"]["output"]>;
  /** The URL to show for the club (ToastHost site, club config, or TI's listing) */
  clubWebsiteUrl?: Maybe<Scalars["String"]["output"]>;
  districtId: Scalars["Int"]["output"];
  districtName: Scalars["String"]["output"];
  divisionId: Scalars["String"]["output"];
  divisionName: Scalars["String"]["output"];
  goalsChart: DashboardChart;
  isEligible: Scalars["Boolean"]["output"];
  maxObtainableDCPPoints: Scalars["Int"]["output"];
  membersChart: DashboardChart;
  membershipImportDate: Scalars["String"]["output"];
  nudges: Array<NudgeSuggestion>;
  shortName?: Maybe<Scalars["String"]["output"]>;
  /** ISO date TI suspended the club, where one was recorded. Null on an active or prospective club, and on a suspended one whose date TI never supplied - which is a real state, not a missing value */
  suspendDate?: Maybe<Scalars["String"]["output"]>;
  /** TI lifecycle status: Active / Suspended / Prospective */
  tiStatus: Scalars["String"]["output"];
  /** TI's website listing, validated and made absolute. Includes their Find-a-Club page when that is all TI holds */
  tiWebsiteUrl?: Maybe<Scalars["String"]["output"]>;
};

/** An edge in a Club connection */
export type ClubEdge = {
  __typename: "ClubEdge";
  /** A cursor for pagination */
  cursor: Scalars["String"]["output"];
  /** The Club at the end of the edge */
  node: Club;
};

export type ClubEducationConfig = {
  __typename: "ClubEducationConfig";
  hiddenRoleHistoryRoleTypes: Array<Scalars["String"]["output"]>;
};

/** Available subscription features */
export enum ClubFeatureType {
  /** Core subscription features */
  CoreSubscription = "CORE_SUBSCRIPTION",
  /** Custom email accounts */
  EmailAccounts = "EMAIL_ACCOUNTS",
  /** Website hosting */
  WebHosting = "WEB_HOSTING",
  /** Zoom integration */
  ZoomIntegration = "ZOOM_INTEGRATION",
}

/** Who the projection counted, and on what date */
export type ClubFinanceCohort = {
  __typename: "ClubFinanceCohort";
  /** ISO date the roster was read against */
  countedOn: Scalars["String"]["output"];
  /** Every roster row the platform treats as current. The count costs and TI dues are priced at */
  currentMembers: Scalars["Int"]["output"];
  /** The sentence naming this cohort and its date, required beside every figure measured over it */
  description: Scalars["String"]["output"];
  /** Counted members lapsed within the grace window. Charged for, and in no income figure */
  overdueMembers: Scalars["Int"]["output"];
  /** True when an officer entered the count rather than the roster supplying it */
  overridden: Scalars["Boolean"]["output"];
  /** Members whose effective paid-through date covers the projection date. The income denominator */
  paidMembers: Scalars["Int"]["output"];
  /** Counted members carrying no paid-through date. Charged for, and in no income figure */
  unknownMembers: Scalars["Int"]["output"];
};

/** The club's finance inputs, replaced wholesale: what is absent is cleared, because a partial save has no meaning for a list that can shrink. Two fields are nullable and neither is a cleared value: the exchange rate, because a club may genuinely have none, and expectedVersion, because a club may have saved no config for this one to be based on */
export type ClubFinanceConfigInput = {
  /** The card and bank fee on a foreign-currency payment, in basis points */
  cardFeeBasisPoints: Scalars["Int"]["input"];
  /** The club's cost lines, replacing the stored list */
  costLines: Array<ClubFinanceCostLineInput>;
  /** ISO 4217 code every cost amount is in */
  currency: Scalars["String"]["input"];
  /** The version of the stored config this save was based on, as the read reported it. Null says the club had saved none. Must be sent: a save that omits it is refused, and one naming a version the club no longer holds is refused rather than replacing what is there */
  expectedVersion?: InputMaybe<Scalars["String"]["input"]>;
  /** The currency the form displayed as Toastmasters International's when the officer typed the rate. Required alongside fxRateMicros, and refused where TI no longer charges in it: the number was entered under that pair and the server must not stamp another */
  fxRateBaseCurrency?: InputMaybe<Scalars["String"]["input"]>;
  /** The rate to convert Toastmasters International's charge at, scaled by 1e6. Null clears the club's rate. The two currencies are the server's, and the day is stamped on save */
  fxRateMicros?: InputMaybe<Scalars["Long"]["input"]>;
  /** Where the officer got the rate, kept beside it for a reader who checks */
  fxRateNote?: InputMaybe<Scalars["String"]["input"]>;
  /** How often the club meets */
  meetingsPerYear: Scalars["Int"]["input"];
};

/** The rate a projected conversion was computed at, and where that rate came from. Not necessarily a quote: stage 1 converts at the figure the club entered */
export type ClubFinanceConversion = {
  __typename: "ClubFinanceConversion";
  /** Quote currency per unit of base currency, scaled by 1e6 */
  rateMicros: Scalars["Long"]["output"];
  /** ISO date this rate is dated: the day an officer entered it, or the day it was quoted. Never the payment date, which is in the future */
  ratedOn: Scalars["String"]["output"];
  /** Where the rate came from, which says whether it is a quote or a figure a club entered */
  source: Scalars["String"]["output"];
};

/** One line of the itemised annual running cost */
export type ClubFinanceCostItem = {
  __typename: "ClubFinanceCostItem";
  /** What this line adds to a year of running the club, in minor units of the finance currency */
  annualMinor: Scalars["Long"]["output"];
  /** Category token, e.g. VENUE_HIRE. An unrecognised stored token is passed through as-is */
  category: Scalars["String"]["output"];
  /** The category's display name */
  categoryLabel: Scalars["String"]["output"];
  /** What the platform worked this amount out from, in the officer's words. Null where the club entered the line. A sentence rather than a flag because BANK_CHARGES carries a derived line and entered lines alike, so a reader seeing two rows in one category is told which is which */
  derivedFrom?: Maybe<Scalars["String"]["output"]>;
  /** What the club calls this cost */
  label: Scalars["String"]["output"];
};

/** One cost line: what it is, what it costs and how often. Used both to save the club's lines and to explore a scenario; the field carrying it says which */
export type ClubFinanceCostLineInput = {
  /** Minor units of the club's finance currency */
  amountMinor: Scalars["Int"]["input"];
  /** PER_MEETING, PER_MONTH, PER_QUARTER, PER_YEAR, PER_MEMBER_PER_PERIOD or ONE_OFF */
  cadence: Scalars["String"]["input"];
  /** A category token. TI_DUES is refused: the projection derives that charge, so an entered line doubles it */
  category: Scalars["String"]["input"];
  /** What the club calls this cost */
  label: Scalars["String"]["input"];
  /** The date this cost falls on. Required for ONE_OFF, optional for PER_QUARTER and PER_YEAR where it is the next occurrence, and refused for every other cadence */
  occursOn?: InputMaybe<Scalars["String"]["input"]>;
  /** What this is, required where the category is OTHER */
  otherLabel?: InputMaybe<Scalars["String"]["input"]>;
};

/** What the club spends and takes in over a year, none of which needs an opening balance */
export type ClubFinanceFlow = {
  __typename: "ClubFinanceFlow";
  /** A year of the recurring rate, excluding one-off spending. Excludes TI dues too when tiCharge is a refusal, which disclosure states */
  annualRunningCostMinor: Scalars["Long"]["output"];
  /** Recurring club cost lines, then TI's dues and the fee on converting them. The two derived lines are absent, not zero, when tiCharge is a refusal */
  costLines: Array<ClubFinanceCostItem>;
  /** ISO 4217 code every minor-unit figure here is in */
  currency: Scalars["String"]["output"];
  /** The club-collects assumption every figure here rests on and the member-periods it covers, or the statement that TI dues are excluded and why */
  disclosure: Scalars["String"]["output"];
  /** Income and break-even, or why the club's fees do not produce them */
  income: ClubFinanceIncomeResult;
  /** One-off spending dated inside the twelve whole calendar months the walk's year covers */
  oneOffMinorInWindow: Scalars["Long"]["output"];
  /** The cohort income is counted for */
  payingMembers: Scalars["Int"]["output"];
  /** How the membership moves through the year every figure here covers */
  rosterModel: ClubFinanceRosterModel;
  /** What Toastmasters International is projected to charge, or why it cannot be priced */
  tiCharge: ClubFinanceTiChargeResult;
  /** The recurring rate plus that one-off spending */
  twelveMonthSpendMinor: Scalars["Long"]["output"];
};

/** The flow half of the projection, or why it produced no figures */
export type ClubFinanceFlowResult = ClubFinanceFlow | ClubFinanceUnavailable;

/** What the club's dues bring in against what it costs, and where the two meet */
export type ClubFinanceIncome = {
  __typename: "ClubFinanceIncome";
  /** A year of club dues, summed over the paid roster each collection falls on rather than one count */
  annualIncomeMinor: Scalars["Long"]["output"];
  /** That income less a year of running costs */
  annualSurplusMinor: Scalars["Long"]["output"];
  /** Smallest membership whose dues cover a year of costs. Null when none does */
  breakEvenMembers?: Maybe<Scalars["Int"]["output"]>;
  /** Why no membership breaks even. Present exactly when breakEvenMembers is null */
  breakEvenUnreachable?: Maybe<Scalars["String"]["output"]>;
  /** Break-even less the counted cohort, negative above it. Null when break-even is null */
  memberGap?: Maybe<Scalars["Int"]["output"]>;
  /** What the club charges a member per month, in minor units. May carry a fraction */
  monthlyDuesMinor: Scalars["Float"]["output"];
};

/** The income half of the flow projection, or why it produced no figure */
export type ClubFinanceIncomeResult = ClubFinanceIncome | ClubFinanceUnavailable;

/** One month of the balance walk */
export type ClubFinanceMonth = {
  __typename: "ClubFinanceMonth";
  /** The balance at the end of this month */
  closingBalanceMinor: Scalars["Long"]["output"];
  /** The membership this month's costs and TI charge are priced at */
  currentMembers: Scalars["Int"]["output"];
  /** Dues collected in this month */
  incomeMinor: Scalars["Long"]["output"];
  /** ISO year-month, e.g. 2026-09. Every row lies inside the month it names */
  month: Scalars["String"]["output"];
  /** The membership this month's income is collected from */
  paidMembers: Scalars["Int"]["output"];
  /** Spending falling in this month */
  spendMinor: Scalars["Long"]["output"];
};

/** An opening balance the club has live, as the posting that carries it */
export type ClubFinanceOpeningBalance = {
  __typename: "ClubFinanceOpeningBalance";
  /** Minor units of this posting's currency, per FINANCE-AMOUNT-MINOR-UNITS */
  amountMinor: Scalars["Long"]["output"];
  /** ISO 4217 code this figure is in, stored on the row rather than derived */
  currency: Scalars["String"]["output"];
  /** ISO date the money was true, which is not the date it was typed in */
  effectiveOn: Scalars["String"]["output"];
  /** What the officer said this figure was */
  note?: Maybe<Scalars["String"]["output"]>;
  /** The posting's own id, which is what a later reversal points at */
  postingId: Scalars["Long"]["output"];
  /** When it was entered, as an ISO instant */
  recordedAt: Scalars["String"]["output"];
};

/** A value one of the finance form's pickers may produce, and what an officer choosing it reads */
export type ClubFinanceOption = {
  __typename: "ClubFinanceOption";
  /** What the officer reads */
  label: Scalars["String"]["output"];
  /** What an officer choosing this option needs to know before entering a line under it. Carried where the projection already derives a figure the option also admits, which today is BANK_CHARGES and the card fee on TI's payment. Null on every other option */
  note?: Maybe<Scalars["String"]["output"]>;
  /** The value stored and sent back on a save */
  token: Scalars["String"]["output"];
};

/** An officer's what-if. Every field defaults to the club's real data, and none of this is written back */
export type ClubFinanceOverridesInput = {
  /** The card and bank fee on a foreign-currency payment, in basis points */
  cardFeeBasisPoints?: InputMaybe<Scalars["Int"]["input"]>;
  /** The club's cost lines, replaced wholesale for this view */
  costLines?: InputMaybe<Array<ClubFinanceCostLineInput>>;
  /** A rate to convert TI's charge at, reported as entered rather than quoted */
  fxRateMicros?: InputMaybe<Scalars["Long"]["input"]>;
  /** Members joining in an average month, arriving from the month after the projection date */
  joinersPerMonth?: InputMaybe<Scalars["Int"]["input"]>;
  /** How often the club meets */
  meetingsPerYear?: InputMaybe<Scalars["Int"]["input"]>;
  /** A membership to price at. Replaces both cohorts: the members who pay and the members owed for */
  memberCount?: InputMaybe<Scalars["Int"]["input"]>;
  /** Monthly dues per member, in minor units, which may carry a fraction */
  monthlyDuesMinor?: InputMaybe<Scalars["Float"]["input"]>;
  /** A balance for the stock outputs to count down from, reported as entered rather than posted */
  openingBalanceMinor?: InputMaybe<Scalars["Long"]["input"]>;
  /** The club's own collection cycle: SEMI_ANNUAL, ANNUAL_SEPTEMBER or ANNUAL_MARCH */
  renewalCycle?: InputMaybe<Scalars["String"]["input"]>;
  /** How much of the membership renews at each collection the club makes, in hundredths of a percent. 8500 is 85% */
  retentionBasisPoints?: InputMaybe<Scalars["Int"]["input"]>;
  /** Toastmasters International dues per member per period, in minor units of TI's currency */
  tiDuesPerPeriodMinor?: InputMaybe<Scalars["Int"]["input"]>;
};

/** What a club's costs, roster, fees and TI's rates say about the year ahead. Nothing here recommends anything */
export type ClubFinanceProjection = {
  __typename: "ClubFinanceProjection";
  /** ISO date every figure is measured at */
  asOf: Scalars["String"]["output"];
  /** Who was counted, and on what date */
  cohort: ClubFinanceCohort;
  /** What the club spends and takes in over a year, or why no figure follows */
  flow: ClubFinanceFlowResult;
  /** True when an officer changed an input for this view. No override reaches stored data */
  overridden: Scalars["Boolean"]["output"];
  /** How long the club's money lasts, or why no figure follows */
  stock: ClubFinanceStockResult;
};

/** How the membership moves through the year the figures cover. The default moves nothing, and no club stores either figure */
export type ClubFinanceRosterModel = {
  __typename: "ClubFinanceRosterModel";
  /** The sentence required beside a figure priced at a modelled roster. Null where the roster does not move */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Members joining in an average month, arriving from the month after the projection date */
  joinersPerMonth: Scalars["Int"]["output"];
  /** How much of the membership renews at each collection the club makes, in hundredths of a percent */
  retentionBasisPoints: Scalars["Int"]["output"];
};

/** The half of the stock outputs that needs income, and so needs the club's fees */
export type ClubFinanceRunway = {
  __typename: "ClubFinanceRunway";
  /** What the projected balance is walked through: the twelve whole calendar months of the year, preceded by the rest of the projection date's own month where it is not the 1st */
  months: Array<ClubFinanceMonth>;
  /** The balance at the end of the walk. The closing figure of the last month below */
  projectedBalanceMinor: Scalars["Long"]["output"];
  /** Monthly steps before the balance goes negative with income counted in. Null within the horizon */
  runwayMonths?: Maybe<Scalars["Int"]["output"]>;
};

/** The income-counting half of the stock outputs, or why it produced no figure */
export type ClubFinanceRunwayResult = ClubFinanceRunway | ClubFinanceUnavailable;

/** What the club has entered, for the form that edits it rather than the page that reads figures */
export type ClubFinanceSettings = {
  __typename: "ClubFinanceSettings";
  /** The cadences a cost line may carry, in the order a form offers them */
  cadenceOptions: Array<ClubFinanceOption>;
  /** The categories an officer may put on a cost line. TI_DUES is absent: the projection derives that charge, so an entered line would count it twice. BANK_CHARGES is the one that could not take the same fix, and carries a note saying what is already derived */
  categoryOptions: Array<ClubFinanceOption>;
  /** The stored config, or null where the club has never saved one. Never a default standing in for one, per FINANCE-UNSET-IS-NOT-A-VALUE */
  config?: Maybe<ClubFinanceStoredConfig>;
  /** The currencies the platform prices in, which is the set a club's finance currency comes from. A code outside it leaves the TI charge a refusal for ever */
  currencyOptions: Array<ClubFinanceOption>;
  /** Every anchor nothing has withdrawn. Normally empty or one element; two is a defect the next correction repairs, and is shown rather than hidden */
  openingBalances: Array<ClubFinanceOpeningBalance>;
  /** The currency Toastmasters International charges in, so a form can name the pair it asks a rate for. Null where no dues rate is on file */
  tiChargingCurrency?: Maybe<Scalars["String"]["output"]>;
};

/** How long the club's money lasts, which is the only question needing an opening balance */
export type ClubFinanceStock = {
  __typename: "ClubFinanceStock";
  /** What that balance is derived from and the date it is good to. Never a bank's figure */
  balanceBasis: Scalars["String"]["output"];
  /** The club-collects assumption these figures rest on, and the member-periods it covers */
  disclosure: Scalars["String"]["output"];
  /** One sentence per cost line spread evenly across the months rather than placed on the dates it falls */
  evenlySpread: Array<Scalars["String"]["output"]>;
  /** How far the cover and runway walks look before answering "longer than this" */
  horizonMonths: Scalars["Int"]["output"];
  /** Monthly steps before the balance goes negative with no income. Null within horizonMonths */
  monthsOfCover?: Maybe<Scalars["Int"]["output"]>;
  /** The figure the walk counts down from, in minor units of the finance currency */
  openingBalanceMinor: Scalars["Long"]["output"];
  /** Runway and the projected balance, or why the club's fees do not produce them */
  withIncome: ClubFinanceRunwayResult;
};

/** The stock half of the projection, or why it produced no figures */
export type ClubFinanceStockResult = ClubFinanceStock | ClubFinanceUnavailable;

/** The club's own finance inputs as they are stored */
export type ClubFinanceStoredConfig = {
  __typename: "ClubFinanceStoredConfig";
  /** The card and bank fee on a foreign-currency payment, in basis points. 275 is 2.75% */
  cardFeeBasisPoints: Scalars["Int"]["output"];
  /** The club's cost lines, in the order it entered them */
  costLines: Array<ClubFinanceStoredCostLine>;
  /** ISO 4217 code every cost amount here is in */
  currency: Scalars["String"]["output"];
  /** The rate the club entered for converting Toastmasters International's charge. Null where it has entered none, which is why a club outside TI's currency reads refusals */
  fxRate?: Maybe<ClubFinanceStoredFxRate>;
  /** How often the club meets, which prices every per-meeting cost */
  meetingsPerYear: Scalars["Int"]["output"];
  /** Why the stored lines produce no cost figure, each naming what to repair. Empty when they price */
  unpriceableReasons: Array<Scalars["String"]["output"]>;
  /** What this config says, as one opaque value. Send it back as the save's expectedVersion: a save naming a version the club no longer holds is refused rather than replacing another officer's edit. Never parsed by a client */
  version: Scalars["String"]["output"];
};

/** One cost line as the club entered it, which is what an editor prefills from */
export type ClubFinanceStoredCostLine = {
  __typename: "ClubFinanceStoredCostLine";
  /** Minor units of the config's currency, per one occurrence of the cadence */
  amountMinor: Scalars["Int"]["output"];
  /** How often this recurs, e.g. PER_MEETING. An unrecognised stored token is passed through as-is */
  cadence: Scalars["String"]["output"];
  /** The cadence's display name. An unrecognised token is its own label */
  cadenceLabel: Scalars["String"]["output"];
  /** Category token, e.g. VENUE_HIRE. An unrecognised stored token is passed through as-is */
  category: Scalars["String"]["output"];
  /** The category's display name. An unrecognised token is its own label */
  categoryLabel: Scalars["String"]["output"];
  /** What the club calls this cost */
  label: Scalars["String"]["output"];
  /** The date this cost falls on: a ONE_OFF always, a PER_QUARTER or PER_YEAR where the club gave one */
  occursOn?: Maybe<Scalars["String"]["output"]>;
  /** What this is, where the category is OTHER */
  otherLabel?: Maybe<Scalars["String"]["output"]>;
};

/** The exchange rate the club entered, which the projection uses until an officer changes it */
export type ClubFinanceStoredFxRate = {
  __typename: "ClubFinanceStoredFxRate";
  /** What Toastmasters International charged in when the figure was entered */
  baseCurrency: Scalars["String"]["output"];
  /** ISO date the figure last changed. A save leaving the rate as it stood keeps this date, so the page can say how old the rate is */
  enteredOn: Scalars["String"]["output"];
  /** Where the officer says the figure came from, and null where they said nothing */
  note?: Maybe<Scalars["String"]["output"]>;
  /** The club's finance currency when the figure was entered */
  quoteCurrency: Scalars["String"]["output"];
  /** Quote currency per unit of base currency, scaled by 1e6 */
  rateMicros: Scalars["Long"]["output"];
  /** What the projection reports this rate as, so it is never read as a quote */
  source: Scalars["String"]["output"];
};

/** What Toastmasters International is projected to charge, and what paying it is projected to cost */
export type ClubFinanceTiCharge = {
  __typename: "ClubFinanceTICharge";
  /** A year of the charge, in minor units of the charge currency */
  annualChargeMinor: Scalars["Long"]["output"];
  /** What the club spends a year to settle the charge, conversion fee included */
  annualCostMinor: Scalars["Long"]["output"];
  /** Member-periods the club-collects assumption covers, reported beside every TI figure */
  assumedMemberPeriods: Scalars["Int"]["output"];
  /** What the card issuer adds to that foreign payment. Zero where nothing converts */
  cardFeeMinor: Scalars["Long"]["output"];
  /** The currency Toastmasters International charges in */
  chargeCurrency: Scalars["String"]["output"];
  /** The rate the charge was converted at. Null where TI charges in the club's own currency */
  conversion?: Maybe<ClubFinanceConversion>;
  /** The same annual charge in minor units of the club's finance currency */
  convertedAnnualMinor: Scalars["Long"]["output"];
  /** Dues per member per period, in minor units of the charge currency */
  duesPerPeriodMinor: Scalars["Int"]["output"];
  /** What the year's joiners cost altogether in TI's currency: their fees and their part-period dues */
  joinerChargeMinor: Scalars["Long"]["output"];
  /** Current members the charge is priced for */
  memberCount: Scalars["Int"]["output"];
  /** TI's fee per new member, in minor units of the charge currency */
  newMemberFeeMinor: Scalars["Int"]["output"];
  /** Members the year's model has joining, each charged TI's new-member fee once. Zero where the roster does not grow */
  newMembersCharged: Scalars["Int"]["output"];
  /** Toastmasters International dues periods in a year */
  periodsPerYear: Scalars["Int"]["output"];
};

/** What Toastmasters International is projected to charge, or why that one charge produced no figure */
export type ClubFinanceTiChargeResult = ClubFinanceTiCharge | ClubFinanceUnavailable;

/** Why this half of the projection produced no figure, in sentences naming what an officer would enter */
export type ClubFinanceUnavailable = {
  __typename: "ClubFinanceUnavailable";
  /** One sentence per missing or unusable input. Never empty */
  reasons: Array<Scalars["String"]["output"]>;
};

/** Basic club info for guest registration */
export type ClubGuestInfo = {
  __typename: "ClubGuestInfo";
  /** Whether the club's guestbook is enabled (registration accepted) */
  enabled: Scalars["Boolean"]["output"];
  /** Club full name */
  longName: Scalars["String"]["output"];
  /** Club short name */
  shortName: Scalars["String"]["output"];
};

/** An area entry in the hierarchy */
export type ClubHierarchyArea = {
  __typename: "ClubHierarchyArea";
  areaId: Scalars["String"]["output"];
  clubs: Array<ClubHierarchyClub>;
};

/** A club entry in the hierarchy */
export type ClubHierarchyClub = {
  __typename: "ClubHierarchyClub";
  clubLongName: Scalars["String"]["output"];
  /** TI club number — the stable navigation key when a hosted shortName is absent */
  clubNumber: Scalars["Int"]["output"];
  /** Canonical hosted short name; null for performance-only clubs with no model record */
  clubShortName?: Maybe<Scalars["String"]["output"]>;
  isActive: Scalars["Boolean"]["output"];
  isSuspended: Scalars["Boolean"]["output"];
  /** ISO date TI suspended the club, where one was recorded. Null on an active or prospective club, and on a suspended one whose date TI never supplied - which is a real state, not a missing value */
  suspendDate?: Maybe<Scalars["String"]["output"]>;
  /** TI lifecycle status: Active / Suspended / Prospective */
  tiStatus: Scalars["String"]["output"];
};

/** A district entry in the hierarchy */
export type ClubHierarchyDistrict = {
  __typename: "ClubHierarchyDistrict";
  districtId: Scalars["Int"]["output"];
  districtName: Scalars["String"]["output"];
  divisions: Array<ClubHierarchyDivision>;
};

/** A division entry in the hierarchy */
export type ClubHierarchyDivision = {
  __typename: "ClubHierarchyDivision";
  areas: Array<ClubHierarchyArea>;
  divisionId: Scalars["String"]["output"];
};

/** Metadata about a club image */
export type ClubImageMeta = {
  __typename: "ClubImageMeta";
  /** Image filename */
  imageName: Scalars["String"]["output"];
  /** Image size in bytes */
  size: Scalars["Long"]["output"];
  /** Date and time the image was uploaded */
  uploadDate: Scalars["String"]["output"];
};

/** Club calendar with upcoming meetings */
export type ClubInfoCalendar = {
  __typename: "ClubInfoCalendar";
  configState: Scalars["String"]["output"];
  futureMeetings: Array<ClubInfoMeetingSummary>;
  isEnabled: Scalars["Boolean"]["output"];
  nextMeeting?: Maybe<ClubInfoMeetingSummary>;
};

/** Club email configuration */
export type ClubInfoEmailConfig = {
  __typename: "ClubInfoEmailConfig";
  emailAddress: Scalars["String"]["output"];
  emailPassword: Scalars["String"]["output"];
  enabled: Scalars["Boolean"]["output"];
  imapServer: Scalars["String"]["output"];
  smtpPort: Scalars["Int"]["output"];
  smtpServer: Scalars["String"]["output"];
};

/** Club guestbook info for managers */
export type ClubInfoGuestbook = {
  __typename: "ClubInfoGuestbook";
  enabled: Scalars["Boolean"]["output"];
  firstEmailBody: Scalars["String"]["output"];
  reminderEmailBody: Scalars["String"]["output"];
};

/** Club guestbook configuration in club info */
export type ClubInfoGuestbookConfig = {
  __typename: "ClubInfoGuestbookConfig";
  enabled: Scalars["Boolean"]["output"];
  firstEmailBody: Scalars["String"]["output"];
  reminderEmailBody: Scalars["String"]["output"];
};

/** Club manager information (officer-only) */
export type ClubInfoManager = {
  __typename: "ClubInfoManager";
  clubOfficers: Array<ClubInfoOfficer>;
  easyspeakId?: Maybe<Scalars["Int"]["output"]>;
  easyspeakInstance?: Maybe<Scalars["String"]["output"]>;
  emailConfiguration?: Maybe<ClubInfoEmailConfig>;
  guestCount: Scalars["Int"]["output"];
  guestbook: ClubInfoGuestbook;
  listedInTI: Scalars["Boolean"]["output"];
  memberCount: Scalars["Int"]["output"];
  membershipStatus: ClubInfoMembershipStatus;
  notificationPreferences: ClubInfoNotificationPreferences;
  periodicEmail: Scalars["Boolean"]["output"];
  stripeConnected: Scalars["Boolean"]["output"];
};

/** Club meeting schedule with timezone and patterns */
export type ClubInfoMeetingSchedule = {
  __typename: "ClubInfoMeetingSchedule";
  exclusions: Array<Scalars["String"]["output"]>;
  meetingPatterns: Array<MeetingPatternEntry>;
  timezone: Scalars["String"]["output"];
};

/** A meeting summary in the club calendar */
export type ClubInfoMeetingSummary = {
  __typename: "ClubInfoMeetingSummary";
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  startDate: Scalars["String"]["output"];
};

/** Club membership status configuration */
export type ClubInfoMembershipStatus = {
  __typename: "ClubInfoMembershipStatus";
  cardPaymentsEnabled: Scalars["Boolean"]["output"];
  enabled: Scalars["Boolean"]["output"];
  newMemberRegistrationEnabled: Scalars["Boolean"]["output"];
};

/** Per-club controls over whether the club's registered inbox is copied on classes of automated notification */
export type ClubInfoNotificationPreferences = {
  __typename: "ClubInfoNotificationPreferences";
  /** Copy the club inbox on guest & prospect activity (registrations and removals) */
  copyInboxOnGuest: Scalars["Boolean"]["output"];
  /** Copy the club inbox on meeting & role activity (assignments, sign-ups, requests, proposals, reminders, feedback) */
  copyInboxOnMeetingRole: Scalars["Boolean"]["output"];
  /** Copy the club inbox on membership & dues notifications (new applications, payment requests/receipts, renewals) */
  copyInboxOnMembership: Scalars["Boolean"]["output"];
};

/** A club officer in the club info response */
export type ClubInfoOfficer = {
  __typename: "ClubInfoOfficer";
  /** Officer email, masked to the viewer's tier for this club; absent for public viewers (#2193) */
  email?: Maybe<Scalars["String"]["output"]>;
  /** Officer TI membership id, shown to officers/self only; absent for public/member viewers (#2193) */
  membershipId?: Maybe<Scalars["String"]["output"]>;
  /** Officer display name, masked to the viewer's tier for this club (#2193) */
  name: Scalars["String"]["output"];
  /** Officer role display name */
  role: Scalars["String"]["output"];
  /** Term start date */
  termBegin: Scalars["String"]["output"];
  /** Term end date */
  termEnd: Scalars["String"]["output"];
  /** Officer user id */
  userId?: Maybe<Scalars["Long"]["output"]>;
};

/** Public club information */
export type ClubInfoPublic = {
  __typename: "ClubInfoPublic";
  area: Scalars["Int"]["output"];
  calendar: ClubInfoCalendar;
  clubId: Scalars["Int"]["output"];
  clubOfficers: Array<ClubInfoOfficer>;
  contactEmail: Scalars["String"]["output"];
  district: Scalars["Int"]["output"];
  division: Scalars["String"]["output"];
  guestbookConfig: ClubInfoGuestbookConfig;
  longName: Scalars["String"]["output"];
  meetingConfig?: Maybe<ClubMeetingConfig>;
  meetingSchedule?: Maybe<ClubInfoMeetingSchedule>;
  memberCount?: Maybe<Scalars["Int"]["output"]>;
  membershipStatus?: Maybe<ClubInfoMembershipStatus>;
  shortName: Scalars["String"]["output"];
  suspendDate?: Maybe<Scalars["String"]["output"]>;
  tiStatus: Scalars["String"]["output"];
  website: ClubInfoWebsite;
};

/** Complete club info response with public and manager data */
export type ClubInfoResponse = {
  __typename: "ClubInfoResponse";
  clubConnection: Scalars["String"]["output"];
  clubMeetingsId: Scalars["Long"]["output"];
  /** DCP data as JSON string */
  dcpData?: Maybe<Scalars["String"]["output"]>;
  isOnToastHost: Scalars["Boolean"]["output"];
  managerInfo?: Maybe<ClubInfoManager>;
  publicInfo: ClubInfoPublic;
};

/** Basic club information for meeting context */
export type ClubInfoSummary = {
  __typename: "ClubInfoSummary";
  /** Public contact email for the club */
  contactEmail: Scalars["String"]["output"];
  /** Club ID */
  id: Scalars["ID"]["output"];
  /** Full club name */
  longName: Scalars["String"]["output"];
  /** Meeting configuration for meeting-context features */
  meetingConfig?: Maybe<ClubMeetingConfig>;
  /** Meeting schedule (used for timezone resolution) */
  meetingSchedule?: Maybe<ClubInfoMeetingSchedule>;
  /** Short club name */
  shortName: Scalars["String"]["output"];
};

/** Club website configuration and URL */
export type ClubInfoWebsite = {
  __typename: "ClubInfoWebsite";
  clubWebsite?: Maybe<Scalars["String"]["output"]>;
  webConfig: WebConfig;
};

/** A link in the club's link tree */
export type ClubLink = {
  __typename: "ClubLink";
  /** Club ID this link belongs to */
  clubId: Scalars["Int"]["output"];
  /** Creation timestamp */
  createdAt: Scalars["Long"]["output"];
  /** Unique link identifier */
  id: Scalars["ID"]["output"];
  /** Whether the link is active */
  isActive: Scalars["Boolean"]["output"];
  /** Display name of the link */
  name: Scalars["String"]["output"];
  /** Display order position */
  order: Scalars["Int"]["output"];
  /** Last update timestamp */
  updatedAt: Scalars["Long"]["output"];
  /** URL of the link */
  url: Scalars["String"]["output"];
};

/** Result of a ClubLink mutation */
export type ClubLinkResult = {
  __typename: "ClubLinkResult";
  /** The ClubLink data if successful */
  data?: Maybe<ClubLink>;
  /** Machine-readable code identifying the failure outcome */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable result message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Whether the mutation succeeded */
  success: Scalars["Boolean"]["output"];
};

/** Club meeting and voting configuration */
export type ClubMeetingConfig = {
  __typename: "ClubMeetingConfig";
  allowMemberRoleSelfAssign: Scalars["Boolean"]["output"];
  autoAddAgendaToFeedback: Scalars["Boolean"]["output"];
  autoSyncAgendaToVoting: Scalars["Boolean"]["output"];
  evaluatorVotingRoles: Array<Scalars["String"]["output"]>;
  /** Max number of days in advance a member can request a speech */
  memberSpeechRequestAdvanceDays: Scalars["Int"]["output"];
};

/** Club meeting and voting configuration */
export type ClubMeetingConfigInput = {
  /** When true, members take roles directly without VPE approval */
  allowMemberRoleSelfAssign?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Automatically add eligible agenda participants to feedback */
  autoAddAgendaToFeedback?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Automatically sync agenda participants into voting */
  autoSyncAgendaToVoting: Scalars["Boolean"]["input"];
  /** Agenda roles eligible for best evaluator */
  evaluatorVotingRoles: Array<Scalars["String"]["input"]>;
  /** Maximum number of days in advance a member can request a speech */
  memberSpeechRequestAdvanceDays?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A member of a club */
export type ClubMember = {
  __typename: "ClubMember";
  /** Action identifier for member mutations */
  actionId: Scalars["String"]["output"];
  /** Date the member joined this club (ISO format); absent until TI or an activation supplies one */
  clubJoinDate?: Maybe<Scalars["String"]["output"]>;
  /** Contact email address, masked to the viewer's tier for this club; shown to officers/self (#2193) */
  emailAddress?: Maybe<Scalars["String"]["output"]>;
  /** Whether mail to the row's stored address is failing; null when it works or is not shown */
  emailStatus?: Maybe<EmailAddressStatus>;
  /** Member first name */
  firstName: Scalars["String"]["output"];
  /** Full name, masked to the viewer's tier for this club (#2193) */
  fullName: Scalars["String"]["output"];
  /** Whether a submitted application form is retained for this member, so the UI can offer to open it only when there is something to show (officers/managers/admin only; #3030) */
  hasApplicationDetails: Scalars["Boolean"]["output"];
  /** Whether member renewal is due within 3 months */
  isDue: Scalars["Boolean"]["output"];
  /** Whether member is currently paid */
  isPaid: Scalars["Boolean"]["output"];
  /** Last reminder email timestamp (ISO format) */
  lastEmailSent?: Maybe<Scalars["String"]["output"]>;
  /** When the member last logged in (ISO-8601; officers/managers/admin only) */
  lastLogin?: Maybe<Scalars["String"]["output"]>;
  /** Member last name */
  lastName: Scalars["String"]["output"];
  /** Most recent payment date (ISO format) */
  latestPaymentDate?: Maybe<Scalars["String"]["output"]>;
  /** The paid-through date an officer's Mark As Paid would give this member today (ISO format), so the confirm dialog can show it */
  markAsPaidUntil?: Maybe<Scalars["String"]["output"]>;
  /** Type of membership */
  memberType: MemberType;
  /** TI membership id, shown to officers/self only; absent for member/public viewers (#2193) */
  membershipId?: Maybe<Scalars["String"]["output"]>;
  /** Mobile number from the last Club Central roster upload, as TI stored it; officers/self only (#4742) */
  mobilePhone?: Maybe<Scalars["String"]["output"]>;
  /** ToastHost payment expiration date (ISO format) */
  paidUntilTH?: Maybe<Scalars["String"]["output"]>;
  /** Toastmasters International payment expiration date (ISO format) */
  paidUntilTI?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable status string */
  statusString: Scalars["String"]["output"];
  /** ToastHost payment status */
  thStatus: ThStatus;
  /** Toastmasters International sync status */
  tiStatus: TiStatus;
  /** User ID for officer assignment (if member has a user account) */
  userId?: Maybe<Scalars["Long"]["output"]>;
};

/** Basic member information for a club member (use ClubMember for detailed membership data) */
export type ClubMemberBasic = {
  __typename: "ClubMemberBasic";
  /** Avatar image URL */
  avatarUrl?: Maybe<Scalars["String"]["output"]>;
  /** Display name, masked to the viewer's tier for this club (#2193) */
  displayName: Scalars["String"]["output"];
  /** Email address, masked to the viewer's tier for this club (#2193) */
  email?: Maybe<Scalars["String"]["output"]>;
  /** First name */
  firstName: Scalars["String"]["output"];
  /** Masked identity (name/email/tiName) for the requesting viewer in this club's scope */
  identity: DisplayedIdentity;
  /** Last name */
  lastName: Scalars["String"]["output"];
  /** User ID */
  userId?: Maybe<Scalars["ID"]["output"]>;
};

/** Summary information for a club member (used in member selection) */
export type ClubMemberSummary = {
  __typename: "ClubMemberSummary";
  /** Member email address, masked to the viewer's tier for this club; shown to officers/self (#2193) */
  email?: Maybe<Scalars["String"]["output"]>;
  /** Whether the member is active */
  isActive: Scalars["Boolean"]["output"];
  /** Membership status */
  membershipStatus: Scalars["String"]["output"];
  /** Member name, masked to the viewer's tier for this club (#2193) */
  name: Scalars["String"]["output"];
  /** User ID */
  userId?: Maybe<Scalars["ID"]["output"]>;
};

/** Lightweight club identifiers, location, and timezone (cheap alternative to clubInfo) */
export type ClubMeta = {
  __typename: "ClubMeta";
  area: Scalars["Int"]["output"];
  clubId: Scalars["Int"]["output"];
  district: Scalars["Int"]["output"];
  division: Scalars["String"]["output"];
  isOnToastHost: Scalars["Boolean"]["output"];
  longName: Scalars["String"]["output"];
  shortName: Scalars["String"]["output"];
  timezone?: Maybe<Scalars["String"]["output"]>;
};

/** A club officer with their role and term information */
export type ClubOfficer = {
  __typename: "ClubOfficer";
  /** Officer role */
  role: ClubOfficerRole;
  /** Human-readable role name */
  roleDisplayName: Scalars["String"]["output"];
  /** Start date of the officer's term */
  termBegin: Scalars["String"]["output"];
  /** End date of the officer's term */
  termEnd: Scalars["String"]["output"];
  /** The user holding this officer position */
  user?: Maybe<User>;
  /** User ID of the officer */
  userId: Scalars["ID"]["output"];
};

/** Officer roles in a Toastmasters club */
export enum ClubOfficerRole {
  /** Immediate Past President */
  ImmediatePastPresident = "IMMEDIATE_PAST_PRESIDENT",
  /** Other role */
  Other = "OTHER",
  /** Club President */
  President = "PRESIDENT",
  /** Club Secretary */
  Secretary = "SECRETARY",
  /** Sergeant at Arms */
  SergeantAtArms = "SERGEANT_AT_ARMS",
  /** Club Treasurer */
  Treasurer = "TREASURER",
  /** VP of Education */
  VpEducation = "VP_EDUCATION",
  /** VP of Membership */
  VpMembership = "VP_MEMBERSHIP",
  /** VP of Public Relations */
  VpPublicRelations = "VP_PUBLIC_RELATIONS",
  /** Club Webmaster */
  Webmaster = "WEBMASTER",
}

/** Per-relationship history timeline: materialised state plus the full event log */
export type ClubRelationshipTimeline = {
  __typename: "ClubRelationshipTimeline";
  /** Date of most-recent application_submitted or re_applied event (ISO LocalDate) */
  applicationSubmittedAt?: Maybe<Scalars["String"]["output"]>;
  clubId: Scalars["ID"]["output"];
  /** Date of first Prospective → Active transition (ISO LocalDate). Set once and never cleared. */
  convertedToMemberAt?: Maybe<Scalars["String"]["output"]>;
  /** Current lifecycle state (§4.2) */
  currentState: RelationshipState;
  /** Full event log in (occurredAt, id) order — oldest first */
  events: Array<RelationshipTimelineEvent>;
  /** Date of first state-changing event (ISO LocalDate) */
  firstContactAt?: Maybe<Scalars["String"]["output"]>;
  /** Date of most-recent guestbook_signed event (ISO LocalDate) */
  guestSignedAt?: Maybe<Scalars["String"]["output"]>;
  /** Most-recent contact-bearing date (ISO LocalDate) */
  lastContactAt?: Maybe<Scalars["String"]["output"]>;
  /** Member has indicated they will not renew */
  notRenewing: Scalars["Boolean"]["output"];
  /** End of current paid period (ISO LocalDate) */
  paidUntil?: Maybe<Scalars["String"]["output"]>;
  /** TI's paid-through date (ISO LocalDate) */
  paidUntilTI?: Maybe<Scalars["String"]["output"]>;
  /** Wall-clock when this projection row was last written (ISO-8601 instant) */
  updatedAt: Scalars["String"]["output"];
  userId: Scalars["ID"]["output"];
};

/** Club statistics in the clubs dashboard */
export type ClubStats = {
  __typename: "ClubStats";
  activeMembers: Scalars["Int"]["output"];
  area: Scalars["String"]["output"];
  awardsPerMember: Scalars["Float"]["output"];
  clubId: Scalars["Int"]["output"];
  clubName: Scalars["String"]["output"];
  clubStatus: Scalars["String"]["output"];
  division: Scalars["String"]["output"];
  goalsMet: Scalars["Int"]["output"];
  /** Whether the club has TI performance data (false for prospective/not-yet-chartered clubs) */
  hasPerformanceData: Scalars["Boolean"]["output"];
  isDCPEligible: Scalars["Boolean"]["output"];
  membershipBase: Scalars["Int"]["output"];
  membershipGrowth: Scalars["Int"]["output"];
  /** Active members TI's district import flags as enrolled in Pathways */
  pathwaysEnrolledMembers: Scalars["Int"]["output"];
  /** Active members in the district import the Pathways enrolment count is taken over. 0 when the club has no rows in the import, in which case enrolment is unknown rather than 0%. */
  pathwaysTotalMembers: Scalars["Int"]["output"];
  /** ISO date TI suspended the club, where one was recorded. Null on an active or prospective club, and on a suspended one whose date TI never supplied - which is a real state, not a missing value */
  suspendDate?: Maybe<Scalars["String"]["output"]>;
  /** TI lifecycle status: Active / Suspended / Prospective */
  tiStatus: Scalars["String"]["output"];
};

/** Comprehensive club status including features and subscription info */
export type ClubStatus = {
  __typename: "ClubStatus";
  area: Scalars["String"]["output"];
  calendarEnabled: Scalars["Boolean"]["output"];
  cardPaymentsEnabled: Scalars["Boolean"]["output"];
  charterDate?: Maybe<Scalars["String"]["output"]>;
  clubId: Scalars["Int"]["output"];
  currency?: Maybe<Scalars["String"]["output"]>;
  district: Scalars["String"]["output"];
  division: Scalars["String"]["output"];
  guestbookEnabled: Scalars["Boolean"]["output"];
  isCorporate: Scalars["Boolean"]["output"];
  isPioneerClub: Scalars["Boolean"]["output"];
  listedInTI: Scalars["Boolean"]["output"];
  longName: Scalars["String"]["output"];
  memberCount: Scalars["Int"]["output"];
  memberManagementEnabled: Scalars["Boolean"]["output"];
  monthlyDues?: Maybe<Scalars["Float"]["output"]>;
  newMemberFee?: Maybe<Scalars["Int"]["output"]>;
  shortName: Scalars["String"]["output"];
  suspendDate?: Maybe<Scalars["String"]["output"]>;
  tiStatus: Scalars["String"]["output"];
  webHosting: Scalars["String"]["output"];
};

/** Club subscription configuration and status */
export type ClubSubscription = {
  __typename: "ClubSubscription";
  /** Billing cycle frequency */
  billingFrequency: BillingFrequency;
  /** Billing start date (ISO format) */
  billingStartDate?: Maybe<Scalars["String"]["output"]>;
  /** Club identifier */
  clubId: Scalars["ID"]["output"];
  /** Subscription creation timestamp */
  createdAt: Scalars["String"]["output"];
  /** Currently enabled features */
  enabledFeatures: Array<ClubFeatureType>;
  /** Grace period end date (ISO format) */
  gracePeriodEndDate?: Maybe<Scalars["String"]["output"]>;
  /** Whether a payment method is attached */
  hasPaymentMethod: Scalars["Boolean"]["output"];
  /** Whether a Stripe customer exists */
  hasStripeCustomer: Scalars["Boolean"]["output"];
  /** Whether a Stripe subscription exists */
  hasStripeSubscription: Scalars["Boolean"]["output"];
  /** Whether this is a pioneer club (50% discount) */
  isPioneerClub: Scalars["Boolean"]["output"];
  /** Last successful payment date (ISO format) */
  lastPaymentDate?: Maybe<Scalars["String"]["output"]>;
  /** Reason for last payment failure */
  lastPaymentFailureReason?: Maybe<Scalars["String"]["output"]>;
  /** Monthly charge amount in pence */
  monthlyChargeAmountPence: Scalars["Int"]["output"];
  /** Next billing date (ISO format) */
  nextBillingDate?: Maybe<Scalars["String"]["output"]>;
  /** Number of consecutive payment failures */
  paymentFailureCount: Scalars["Int"]["output"];
  /** Current subscription status */
  status: SubscriptionStatus;
  /** Trial end date (ISO format) */
  trialEndDate?: Maybe<Scalars["String"]["output"]>;
  /** Trial start date (ISO format) */
  trialStartDate?: Maybe<Scalars["String"]["output"]>;
  /** Last update timestamp */
  updatedAt: Scalars["String"]["output"];
};

/** Clubs dashboard data grouped by division and area */
export type ClubsDashboard = {
  __typename: "ClubsDashboard";
  districtId: Scalars["Int"]["output"];
  districtName: Scalars["String"]["output"];
  divisionStats: Array<DivisionStats>;
  pathwaysEnrolledMembers: Scalars["Int"]["output"];
  pathwaysTotalMembers: Scalars["Int"]["output"];
  totalActiveMembers: Scalars["Int"]["output"];
};

/** Result of a Completion mutation */
export type CompletionResult = {
  __typename: "CompletionResult";
  /** The Completion data if successful */
  data?: Maybe<PathwayCompletionRecord>;
  /** Machine-readable code identifying the failure outcome */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable result message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Whether the mutation succeeded */
  success: Scalars["Boolean"]["output"];
};

/** Type of pathway completion */
export enum CompletionType {
  /** Education series completion */
  EducationSeries = "EDUCATION_SERIES",
  /** Non-speech activity completion */
  NonSpeech = "NON_SPEECH",
  /** Role activity completion */
  Role = "ROLE",
  /** Speech completion */
  Speech = "SPEECH",
}

/** A configuration section with multiple settings */
export type ConfigSection = {
  __typename: "ConfigSection";
  name: Scalars["String"]["output"];
  values: Array<AdminStat>;
};

/** A rendered Club Officer Training activity feed entry */
export type CotActivityEntry = {
  __typename: "CotActivityEntry";
  /** The round the entry belongs to, when known */
  cotId?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable detail of the action */
  detail: Scalars["String"]["output"];
  /** District the COT activity belongs to */
  districtId?: Maybe<Scalars["ID"]["output"]>;
  /** Id of the entity the action targeted: the COT event, or the officer record on a credit entry or an officer record's not-an-officer mark entry */
  entityId?: Maybe<Scalars["String"]["output"]>;
  /** The COT event the entry concerns, on registration and event-creation entries, while it exists */
  eventId?: Maybe<Scalars["String"]["output"]>;
  /** COT activity event type code */
  eventType: Scalars["String"]["output"];
  /** Activity entry ID */
  id: Scalars["ID"]["output"];
  /** When the action occurred (ISO-8601 UTC) */
  occurredAt: Scalars["String"]["output"];
  /** The officer record whose training credit changed, or that was marked or cleared as not an officer, while the round's Officers tab lists it */
  officerRecordId?: Maybe<Scalars["String"]["output"]>;
  /** Per-type feed title */
  title: Scalars["String"]["output"];
  /** Acting officer on district-officer actions (creation, credit additions, and not-an-officer marks and clears, which have no subject) */
  triggeredBy?: Maybe<Scalars["ID"]["output"]>;
  /** Subject the event is about */
  userId?: Maybe<Scalars["ID"]["output"]>;
};

/** DCP (Distinguished Club Program) overview for a district */
export type DcpOverview = {
  __typename: "DCPOverview";
  activeClubs: Scalars["Int"]["output"];
  clubs: Array<ClubDcpData>;
  distinguishedClubs: Scalars["Int"]["output"];
  districtId: Scalars["Int"]["output"];
  districtName: Scalars["String"]["output"];
  eligibleWithoutDCP: Scalars["Int"]["output"];
  ineligibleClubs: Scalars["Int"]["output"];
  lowClubs: Scalars["Int"]["output"];
  nonEligibleWithDCP: Scalars["Int"]["output"];
  presidentsDistinguishedClubs: Scalars["Int"]["output"];
  selectDistinguishedClubs: Scalars["Int"]["output"];
  smedleyDistinguishedClubs: Scalars["Int"]["output"];
  suspendedClubs: Scalars["Int"]["output"];
  totalClubs: Scalars["Int"]["output"];
  totalDistinguishedClubs: Scalars["Int"]["output"];
};

/** Typed dashboard chart: business data only, no Chart.js config */
export type DashboardChart = {
  __typename: "DashboardChart";
  current: ChartSeries;
  previous: ChartSeries;
  thresholds: Array<ChartThreshold>;
  title: Scalars["String"]["output"];
  yAxisMax?: Maybe<Scalars["Float"]["output"]>;
};

/** A rejected date for a project request */
export type DateRejection = {
  __typename: "DateRejection";
  /** The rejected date */
  date: Scalars["String"]["output"];
  /** Rejection reason */
  reason: Scalars["String"]["output"];
  /** When the date was rejected */
  rejectedAt: Scalars["String"]["output"];
  /** Who rejected the date */
  rejectedBy: ProjectRequestUser;
};

/** Day of week */
export enum DayOfWeekInput {
  /** Friday */
  Friday = "FRIDAY",
  /** Monday */
  Monday = "MONDAY",
  /** Saturday */
  Saturday = "SATURDAY",
  /** Sunday */
  Sunday = "SUNDAY",
  /** Thursday */
  Thursday = "THURSDAY",
  /** Tuesday */
  Tuesday = "TUESDAY",
  /** Wednesday */
  Wednesday = "WEDNESDAY",
}

/** Result of a delete operation */
export type DeleteResult = {
  __typename: "DeleteResult";
  deletedId?: Maybe<Scalars["String"]["output"]>;
  errorCode?: Maybe<Scalars["String"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

/** A user's identity as masked for the requesting viewer within a visibility scope */
export type DisplayedIdentity = {
  __typename: "DisplayedIdentity";
  /** Display name, masked to the viewer's tier (full, or "Fred B*") */
  displayName: Scalars["String"]["output"];
  /** Email address, masked to the viewer's tier; absent when hidden */
  email?: Maybe<Scalars["String"]["output"]>;
  /** TI-canonical "First Last", shown to officers/self only when a display-name override is set */
  tiName?: Maybe<Scalars["String"]["output"]>;
};

/** A Toastmasters district */
export type District = {
  __typename: "District";
  /** All district officers including past/future terms */
  allOfficers: Array<DistrictOfficer>;
  /** Whether calendar features are enabled */
  calendarEnabled: Scalars["Boolean"]["output"];
  /** Number of clubs in this district */
  clubCount: Scalars["Int"]["output"];
  /** Clubs in this district */
  clubs: Array<Club>;
  /** Contact email (visible to district members) */
  contactEmail?: Maybe<Scalars["String"]["output"]>;
  /** Club Officer Training programs for this district */
  cotPrograms: Array<CotProgramSummary>;
  /** Full display name (e.g., 'D91 - UK South') */
  displayName: Scalars["String"]["output"];
  /** District number (e.g., 91 for District 91) */
  districtNumber: Scalars["Int"]["output"];
  /** Unique district identifier */
  id: Scalars["ID"]["output"];
  /** Number of active district members */
  memberCount: Scalars["Int"]["output"];
  /** District name */
  name: Scalars["String"]["output"];
  /** Current district officers */
  officers: Array<DistrictOfficer>;
  /** Short display name (e.g., 'D91') */
  shortDisplayName: Scalars["String"]["output"];
  /** District timezone */
  timezone: Scalars["String"]["output"];
};

/** Full dashboard data for a district (charts, divisions, history) */
export type DistrictDashboardResponse = {
  __typename: "DistrictDashboardResponse";
  clubsChart: DashboardChart;
  districtId: Scalars["Int"]["output"];
  districtName: Scalars["String"]["output"];
  divisionProvisionalCounts: Scalars["JSON"]["output"];
  divisions: Scalars["JSON"]["output"];
  entriesByYear: Scalars["JSON"]["output"];
  isProvisionalPeriod: Scalars["Boolean"]["output"];
  longDescription?: Maybe<Scalars["String"]["output"]>;
  membersChart: DashboardChart;
  membershipPaymentsChart: DashboardChart;
  membershipsByDate: Scalars["JSON"]["output"];
  region?: Maybe<Scalars["Int"]["output"]>;
  shortDescription?: Maybe<Scalars["String"]["output"]>;
  timezones: Array<Scalars["String"]["output"]>;
  totalPaidClubs: Scalars["Int"]["output"];
  websiteUrl?: Maybe<Scalars["String"]["output"]>;
};

/** A member of a club in the district */
export type DistrictMember = {
  __typename: "DistrictMember";
  clubName: Scalars["String"]["output"];
  /** Member email, masked to the viewer's district remit tier; absent when hidden */
  email?: Maybe<Scalars["String"]["output"]>;
  /** TI membership id, shown to district officers within remit/self only (#2193) */
  membershipId?: Maybe<Scalars["String"]["output"]>;
  /** Member name, masked to the viewer's district remit tier */
  name: Scalars["String"]["output"];
  userId: Scalars["ID"]["output"];
};

/** A district officer with their role and term information */
export type DistrictOfficer = {
  __typename: "DistrictOfficer";
  /** Whether this is an official TI role */
  isOfficial: Scalars["Boolean"]["output"];
  /** Whether this is a senior-level role */
  isSenior: Scalars["Boolean"]["output"];
  /** TI membership ID, shown to district officers (by remit)/self only (#2193) */
  membershipId?: Maybe<Scalars["String"]["output"]>;
  /** Officer role display name */
  role: Scalars["String"]["output"];
  /** Start date of the officer's term */
  termBegin: Scalars["String"]["output"];
  /** End date of the officer's term */
  termEnd: Scalars["String"]["output"];
  /** The user holding this officer position */
  user?: Maybe<User>;
  /** User ID of the officer */
  userId: Scalars["ID"]["output"];
};

/** A district officer with full details including user name */
export type DistrictOfficerDto = {
  __typename: "DistrictOfficerDTO";
  area?: Maybe<Scalars["String"]["output"]>;
  displayName: Scalars["String"]["output"];
  division?: Maybe<Scalars["String"]["output"]>;
  isAssigned: Scalars["Boolean"]["output"];
  isSenior: Scalars["Boolean"]["output"];
  memberName: Scalars["String"]["output"];
  membershipId: Scalars["String"]["output"];
  role: Scalars["String"]["output"];
  termEnd: Scalars["String"]["output"];
  termStart: Scalars["String"]["output"];
  userId: Scalars["ID"]["output"];
};

/** Dashboard data for a division */
export type DivisionDashboardResponse = {
  __typename: "DivisionDashboardResponse";
  areaProvisionalCounts: Scalars["JSON"]["output"];
  areas: Scalars["JSON"]["output"];
  asOfDate: Scalars["String"]["output"];
  clubsChart: DashboardChart;
  distClubsChart: DashboardChart;
  districtId: Scalars["Int"]["output"];
  districtName: Scalars["String"]["output"];
  divisionId: Scalars["String"]["output"];
  divisionName: Scalars["String"]["output"];
  isProvisionalPeriod: Scalars["Boolean"]["output"];
};

/** Division statistics in the clubs dashboard */
export type DivisionStats = {
  __typename: "DivisionStats";
  areaStats: Array<AreaStats>;
  divisionId: Scalars["String"]["output"];
  pathwaysEnrolledMembers: Scalars["Int"]["output"];
  pathwaysTotalMembers: Scalars["Int"]["output"];
  totalActiveMembers: Scalars["Int"]["output"];
};

/** An EasySpeak instance a club mapping may name, with its display name */
export type EasySpeakInstanceOption = {
  __typename: "EasySpeakInstanceOption";
  host: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
};

/** A club's staged EasySpeak meeting, with its agenda link and every person recorded in it */
export type EasySpeakMeeting = {
  __typename: "EasySpeakMeeting";
  easySpeakMeetingId: Scalars["Int"]["output"];
  easySpeakUrl?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["Long"]["output"];
  isImported: Scalars["Boolean"]["output"];
  isUpcoming: Scalars["Boolean"]["output"];
  meetingDate: Scalars["String"]["output"];
  meetingNumber?: Maybe<Scalars["Int"]["output"]>;
  people: Array<EasySpeakMeetingPerson>;
  theme?: Maybe<Scalars["String"]["output"]>;
};

/** A person with an attendance row or a role at a staged EasySpeak meeting, with their mapping */
export type EasySpeakMeetingPerson = {
  __typename: "EasySpeakMeetingPerson";
  attended: Scalars["Boolean"]["output"];
  easySpeakName: Scalars["String"]["output"];
  easySpeakUserId: Scalars["Int"]["output"];
  mappingId?: Maybe<Scalars["Long"]["output"]>;
  roles: Array<EasySpeakMeetingRole>;
  status: EasySpeakMeetingPersonStatus;
  toasthostName?: Maybe<Scalars["String"]["output"]>;
};

/** A person's standing on the club's EasySpeak review list */
export enum EasySpeakMeetingPersonStatus {
  /** The row is confirmed to a ToastHost account */
  Confirmed = "CONFIRMED",
  /** The EasySpeak account was deleted */
  Deleted = "DELETED",
  /** The row awaits an officer's decision */
  Pending = "PENDING",
  /** An officer skipped the row */
  Skipped = "SKIPPED",
  /** The club holds no mapping row for the person */
  Unmapped = "UNMAPPED",
}

/** A role a person held at a staged EasySpeak meeting, with its speech title */
export type EasySpeakMeetingRole = {
  __typename: "EasySpeakMeetingRole";
  roleName: Scalars["String"]["output"];
  speechTitle?: Maybe<Scalars["String"]["output"]>;
};

/** An asset bundled with an education series presentation */
export type EducationSeriesAsset = {
  __typename: "EducationSeriesAsset";
  /** Type of asset */
  assetType: Scalars["String"]["output"];
  /** Asset file path */
  file: Scalars["String"]["output"];
};

/** Links to facilitator guide and slides for an education series */
export type EducationSeriesMaterialsLinks = {
  __typename: "EducationSeriesMaterialsLinks";
  facilitatorGuideUrl?: Maybe<Scalars["String"]["output"]>;
  slidesUrl?: Maybe<Scalars["String"]["output"]>;
};

/** Pathway level and count requirement for an education series */
export type EducationSeriesPathwaysRequirement = {
  __typename: "EducationSeriesPathwaysRequirement";
  count: Scalars["Int"]["output"];
  level: Scalars["Int"]["output"];
};

/** An education series presentation topic */
export type EducationSeriesPresentation = {
  __typename: "EducationSeriesPresentation";
  /** Associated assets */
  assets: Array<EducationSeriesAsset>;
  /** Default duration in minutes */
  defaultDurationMinutes: Scalars["Int"]["output"];
  /** Description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Tips for facilitators */
  facilitatorTips: Array<Scalars["String"]["output"]>;
  /** Unique presentation identifier */
  id: Scalars["ID"]["output"];
  /** Links to materials */
  materialsLinks?: Maybe<EducationSeriesMaterialsLinks>;
  /** Pathway requirement */
  pathwaysRequirement: EducationSeriesPathwaysRequirement;
  /** Recommended audience */
  recommendedAudience: Scalars["String"]["output"];
  /** Series key */
  seriesKey: Scalars["String"]["output"];
  /** Series display name */
  seriesName: Scalars["String"]["output"];
  /** URL-friendly slug */
  slug: Scalars["String"]["output"];
  /** Speech timing limits */
  speechTimings?: Maybe<SpeechTimings>;
  /** Toastmasters International code */
  tiCode: Scalars["String"]["output"];
  /** Presentation title */
  title: Scalars["String"]["output"];
};

/** Education series requirement for a pathway level */
export type EducationSeriesRequirement = {
  __typename: "EducationSeriesRequirement";
  /** Number of presentations required */
  count: Scalars["Int"]["output"];
  /** Whether education series requirement is active */
  enabled: Scalars["Boolean"]["output"];
  /** Specific allowed presentation IDs */
  presentationIds: Array<Scalars["String"]["output"]>;
  /** Required series keys */
  series: Array<Scalars["String"]["output"]>;
};

/** Whether mail to a member's or guest's stored address is failing */
export type EmailAddressStatus = {
  __typename: "EmailAddressStatus";
  /** The stored address this status is for */
  address: Scalars["String"]["output"];
  /** Whether this viewer may mark the address as working */
  canMarkWorking: Scalars["Boolean"]["output"];
  /** hard_bounce, complaint or unsendable, when suppressed */
  reason?: Maybe<Scalars["String"]["output"]>;
  /** When the state began (ISO format) */
  since: Scalars["String"]["output"];
  /** transient or suppressed */
  state: Scalars["String"]["output"];
};

/** Email configuration settings */
export type EmailConfigInput = {
  /** Email address */
  emailAddress: Scalars["String"]["input"];
  /** Email password */
  emailPassword: Scalars["String"]["input"];
  /** Enable club email */
  enabled: Scalars["Boolean"]["input"];
  /** IMAP server hostname */
  imapServer: Scalars["String"]["input"];
  /** SMTP port number */
  smtpPort: Scalars["Int"]["input"];
  /** SMTP server hostname */
  smtpServer: Scalars["String"]["input"];
};

/** Options for controlling email notifications */
export type EmailControlOptionsInput = {
  /** Personal note to include in emails */
  personalNote?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether to send email notifications */
  sendNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EmailPreview = {
  __typename: "EmailPreview";
  fromAddress: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
  replyToAddress: Scalars["String"]["output"];
  subject: Scalars["String"]["output"];
  toAddress: Scalars["String"]["output"];
};

/** Response containing action summary and email previews */
export type EmailPreviewResponse = {
  __typename: "EmailPreviewResponse";
  /** Summary of the action being performed */
  actionSummary: Scalars["String"]["output"];
  /** List of email previews for each recipient */
  emailPreviews: Array<EmailPreviewResult>;
};

/** A single email preview with rendered content */
export type EmailPreviewResult = {
  __typename: "EmailPreviewResult";
  /** Rendered HTML content of the email */
  htmlContent: Scalars["String"]["output"];
  /** Recipient email address */
  recipientEmail: Scalars["String"]["output"];
  /** Email subject line */
  subject: Scalars["String"]["output"];
};

/** Input type for email recipients in preview requests */
export type EmailRecipientInput = {
  /** Reason for the action affecting this recipient */
  actionReason?: InputMaybe<Scalars["String"]["input"]>;
  /** Recipient email address (optional - backend will look up) */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Recipient name */
  name: Scalars["String"]["input"];
};

/** Result of a Enrollment list mutation */
export type EnrollmentListResult = {
  __typename: "EnrollmentListResult";
  /** The Enrollment list data if successful */
  data?: Maybe<Array<UserPathwayEnrollment>>;
  /** Machine-readable code identifying the failure outcome */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable result message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Whether the mutation succeeded */
  success: Scalars["Boolean"]["output"];
};

/** Identity of an officer registering from a non-ToastHost district */
export type ExternalAttendeeInfo = {
  __typename: "ExternalAttendeeInfo";
  /** Home club name as entered by the registrant */
  homeClubName: Scalars["String"]["output"];
  /** TI club number, when known */
  homeClubNumber?: Maybe<Scalars["String"]["output"]>;
  /** TI district number (free text) */
  homeDistrictNumber: Scalars["String"]["output"];
  /** Stated current officer role(s) at home club */
  roles: Array<CotOfficerRole>;
};

/** Identity captured when an officer from a non-ToastHost district submits the public registration form */
export type ExternalAttendeeInput = {
  /** Contact email for confirmation + reminders */
  email: Scalars["String"]["input"];
  /** Home club name as entered by the registrant */
  homeClubName: Scalars["String"]["input"];
  /** TI club number, when known */
  homeClubNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** TI district number (free text, e.g. '71') */
  homeDistrictNumber: Scalars["String"]["input"];
  /** Registrant's full name */
  name: Scalars["String"]["input"];
  /** Stated current officer role(s) at home club */
  roles: Array<CotOfficerRole>;
};

export type FeePreviewEntry = {
  __typename: "FeePreviewEntry";
  amount: Scalars["String"]["output"];
  date: Scalars["String"]["output"];
  endDate: Scalars["String"]["output"];
  months: Scalars["String"]["output"];
  shortAmount: Scalars["String"]["output"];
  startDate: Scalars["String"]["output"];
};

/** A feedback item submitted for a subject */
export type Feedback = {
  __typename: "Feedback";
  /** Optional feedback aspects/categories */
  aspects?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Feedback content text */
  content: Scalars["String"]["output"];
  /** ID of the session this feedback belongs to */
  feedbackSessionId: Scalars["ID"]["output"];
  /** ID of the subject this feedback is for */
  feedbackSubjectId: Scalars["ID"]["output"];
  /** The attendee who submitted the feedback */
  fromAttendee?: Maybe<MeetingUser>;
  /** Feedback identifier */
  id: Scalars["ID"]["output"];
  /** When the feedback was submitted (epoch millis) */
  timestamp: Scalars["Long"]["output"];
};

/** A feedback session in a meeting */
export type FeedbackSession = {
  __typename: "FeedbackSession";
  /** All feedback items in this session */
  feedback: Array<Feedback>;
  /** Number of feedback items submitted */
  feedbackCount: Scalars["Int"]["output"];
  /** Session identifier */
  id: Scalars["ID"]["output"];
  /** Whether feedback submission is open */
  isOpen: Scalars["Boolean"]["output"];
  /** Subjects in this feedback session */
  subjects: Array<FeedbackSubject>;
  /** Session title */
  title: Scalars["String"]["output"];
};

/** A subject that can receive feedback */
export type FeedbackSubject = {
  __typename: "FeedbackSubject";
  /** Stable agenda participant sync key when this subject was created from agenda sync */
  agendaSyncKey?: Maybe<Scalars["String"]["output"]>;
  /** Feedback session identifier */
  feedbackSessionId: Scalars["ID"]["output"];
  /** Subject identifier */
  id: Scalars["ID"]["output"];
  /** Meeting user ID of the subject (for matching current user) */
  meetingUserId?: Maybe<MeetingUserId>;
  /** Subject name */
  name: Scalars["String"]["output"];
};

/** Data returned when finishing a meeting, including auto-credit summary */
export type FinishMeetingData = {
  __typename: "FinishMeetingData";
  /** The finished meeting */
  meeting: Meeting;
  /** Number of role auto-credits attempted during finish; more than rolesCredited means some failed */
  rolesAttempted: Scalars["Int"]["output"];
  /** Number of roles auto-credited during finish */
  rolesCredited: Scalars["Int"]["output"];
  /** Number of speech auto-credits attempted during finish; more than speechesCredited means some failed */
  speechesAttempted: Scalars["Int"]["output"];
  /** Number of speeches auto-credited during finish */
  speechesCredited: Scalars["Int"]["output"];
};

/** Result of a FinishMeeting mutation */
export type FinishMeetingResult = {
  __typename: "FinishMeetingResult";
  /** The FinishMeeting data if successful */
  data?: Maybe<FinishMeetingData>;
  /** Machine-readable code identifying the failure outcome */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable result message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Whether the mutation succeeded */
  success: Scalars["Boolean"]["output"];
};

/** A found-us option entry */
export type FoundUsEntry = {
  __typename: "FoundUsEntry";
  /** Display text */
  text: Scalars["String"]["output"];
  /** Option value */
  value: Scalars["String"]["output"];
};

/** An email recipient filter option */
export type GuestEmailOption = {
  __typename: "GuestEmailOption";
  /** Display label */
  label: Scalars["String"]["output"];
  /** Option value */
  value: Scalars["String"]["output"];
};

/** A guest registration entry */
export type GuestRegistration = {
  __typename: "GuestRegistration";
  /** Action ID for guest operations */
  actionId: Scalars["String"]["output"];
  /** When this club first recorded the guest, from the durable event log. Null when the log holds nothing about them, which is a defect rather than a state to design around. */
  creationDate?: Maybe<Scalars["String"]["output"]>;
  /** Guest's email address, masked to the viewer's tier for this club; shown to officers/self (#2193) */
  emailAddress?: Maybe<Scalars["String"]["output"]>;
  /** Whether mail to the guest's stored address is failing; null when it works or is not shown */
  emailStatus?: Maybe<EmailAddressStatus>;
  /** Guest's first name */
  firstName: Scalars["String"]["output"];
  /** How the guest found the club (numeric code) */
  foundUsInfo: Scalars["Int"]["output"];
  /** Current status of the guest */
  guestStatus: Scalars["String"]["output"];
  /** Date of last email sent to guest */
  lastEmailSent?: Maybe<Scalars["String"]["output"]>;
  /** Guest's last name */
  lastName: Scalars["String"]["output"];
  /** The most recent thing this club recorded about the guest (ISO-8601 UTC), from the durable event log */
  lastSignedAt?: Maybe<Scalars["String"]["output"]>;
  /** Guest's phone number */
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  /** How many signings the durable event log records. A reconstructed guest contributes the count recovered from their registration row, because the row states how many signings happened and dates only the first. */
  signingCount?: Maybe<Scalars["Int"]["output"]>;
};

/** The club meeting that was in progress when a guest signed the guestbook */
export type GuestSigningMeeting = {
  __typename: "GuestSigningMeeting";
  /** Id of the meeting, for the meeting page URL */
  meetingId: Scalars["String"]["output"];
  /** The meeting's title, as the club named it */
  title: Scalars["String"]["output"];
};

/** Club guestbook configuration */
export type GuestbookConfig = {
  __typename: "GuestbookConfig";
  /** Whether the guestbook is enabled */
  enabled: Scalars["Boolean"]["output"];
  /** Body of the first welcome email */
  firstEmailBody: Scalars["String"]["output"];
  /** Body of the reminder email */
  reminderEmailBody: Scalars["String"]["output"];
  /** Body a returning guest is sent; blank means send the welcome body */
  returningGuestEmailBody: Scalars["String"]["output"];
  /** Whether welcome emails are enabled */
  welcomeEmailEnabled: Scalars["Boolean"]["output"];
};

/** Result of a GuestbookConfig mutation */
export type GuestbookConfigResult = {
  __typename: "GuestbookConfigResult";
  /** The GuestbookConfig data if successful */
  data?: Maybe<GuestbookConfig>;
  /** Machine-readable code identifying the failure outcome */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable result message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Whether the mutation succeeded */
  success: Scalars["Boolean"]["output"];
};

/** Full guestbook data including guests and found-us options */
export type GuestbookData = {
  __typename: "GuestbookData";
  /** Whether the guestbook is enabled */
  enabled: Scalars["Boolean"]["output"];
  /** Found-us option mappings */
  foundUsMap: Array<FoundUsEntry>;
  /** List of guest registrations */
  guests: Array<GuestRegistration>;
};

/** Website hosting options */
export enum HostingOption {
  /** No ToastHost hosting, external site */
  NoneExternal = "NONE_EXTERNAL",
  /** ToastHost custom domain */
  ToasthostCustom = "TOASTHOST_CUSTOM",
  /** ToastHost d91clubs subdomain */
  ToasthostD91Clubs = "TOASTHOST_D91CLUBS",
  /** ToastHost tmclubs subdomain */
  ToasthostTmclubs = "TOASTHOST_TMCLUBS",
}

/** Website hosting options */
export enum HostingOptionInput {
  /** No ToastHost hosting */
  NoneExternal = "NONE_EXTERNAL",
  /** Custom domain */
  ToasthostCustom = "TOASTHOST_CUSTOM",
  /** d91clubs subdomain */
  ToasthostD91Clubs = "TOASTHOST_D91CLUBS",
  /** tmclubs subdomain */
  ToasthostTmclubs = "TOASTHOST_TMCLUBS",
}

/** Result of deleting a club image */
export type ImageDeleteResult = {
  __typename: "ImageDeleteResult";
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
  wasBackgroundImage: Scalars["Boolean"]["output"];
  wasLogoImage: Scalars["Boolean"]["output"];
};

/** Response indicating whether a club has an in-progress meeting */
export type InProgressMeetingResponse = {
  __typename: "InProgressMeetingResponse";
  /** Date/time of the in-progress meeting */
  datetime?: Maybe<Scalars["String"]["output"]>;
  /** Whether the club has an in-progress meeting */
  hasInProgress: Scalars["Boolean"]["output"];
  /** ID of the in-progress meeting */
  meetingId?: Maybe<Scalars["ID"]["output"]>;
  /** Title of the in-progress meeting */
  title?: Maybe<Scalars["String"]["output"]>;
};

/** Progress on a single pathway level */
export type LevelProgress = {
  __typename: "LevelProgress";
  /** Education series progress */
  education: RequirementProgress;
  /** Elective project progress */
  electives: RequirementProgress;
  /** Level number */
  level: Scalars["Int"]["output"];
  /** Required project progress */
  required: RequirementProgress;
  /** Per-role completion breakdown (null when level has no role requirement) */
  roleBreakdown?: Maybe<Array<PathwayRoleBreakdown>>;
  /** Role quota progress */
  roleQuota: RequirementProgress;
  /** Individual completion segments */
  segments?: Maybe<Array<LevelSegment>>;
  /** Level status (complete, in_progress, not_started) */
  status: Scalars["String"]["output"];
};

/** Requirements for completing a pathway level */
export type LevelRequirement = {
  __typename: "LevelRequirement";
  /** Level description */
  description: Scalars["String"]["output"];
  /** Education series requirements */
  educationSeriesRequirement?: Maybe<EducationSeriesRequirement>;
  /** Available elective project objective IDs */
  electiveProjects: Array<Scalars["String"]["output"]>;
  /** Number of electives needed */
  electivesRequired: Scalars["Int"]["output"];
  /** Level number */
  level: Scalars["Int"]["output"];
  /** Required project objective IDs */
  requiredProjects: Array<Scalars["String"]["output"]>;
  /** Role activity requirements */
  roleRequirement?: Maybe<LevelRoleRequirement>;
};

/** Role quota requirement for a level */
export type LevelRoleQuota = {
  __typename: "LevelRoleQuota";
  /** Quota description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Minimum count required */
  minimum: Scalars["Int"]["output"];
  /** Qualifying role types */
  roles: Array<Scalars["String"]["output"]>;
};

/** Role activity requirements for a pathway level */
export type LevelRoleRequirement = {
  __typename: "LevelRoleRequirement";
  /** Total role assignments needed */
  count: Scalars["Int"]["output"];
  /** Requirement description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Whether role requirements are enforced */
  enabled: Scalars["Boolean"]["output"];
  /** Specific role quotas */
  requiredRoleQuotas: Array<LevelRoleQuota>;
  /** Qualifying role types */
  roles: Array<Scalars["String"]["output"]>;
};

/** A single completion segment in a level */
export type LevelSegment = {
  __typename: "LevelSegment";
  /** Date completed */
  completionDate?: Maybe<Scalars["String"]["output"]>;
  /** Completion record ID */
  completionId?: Maybe<Scalars["String"]["output"]>;
  /** What this segment is a credit of; absent for a pending request or an unstarted slot */
  completionType?: Maybe<CompletionType>;
  /** Associated meeting ID */
  meetingId?: Maybe<Scalars["String"]["output"]>;
  /** Project name */
  projectName?: Maybe<Scalars["String"]["output"]>;
  /** Speech title, as the speech is called now rather than as it was credited */
  speechTitle?: Maybe<Scalars["String"]["output"]>;
  /** Segment status (complete, pending, etc.) */
  status: Scalars["String"]["output"];
};

/** A club meeting */
export type Meeting = {
  __typename: "Meeting";
  /** Meeting agenda items */
  agenda: Array<AgendaItem>;
  /** The officer's reason for cancelling, when the meeting is CANCELLED */
  cancellationReason?: Maybe<Scalars["String"]["output"]>;
  /** The club hosting this meeting */
  club?: Maybe<Club>;
  /** Club ID */
  clubId: Scalars["ID"]["output"];
  /** Meeting date and time (ISO 8601) */
  datetime: Scalars["String"]["output"];
  /** Feedback sessions in this meeting */
  feedbackSessions: Array<FeedbackSession>;
  /** Whether this meeting has been finished before (used for revert UI) */
  hasBeenFinishedBefore: Scalars["Boolean"]["output"];
  /** Unique meeting identifier */
  id: Scalars["ID"]["output"];
  /** Meeting calendar date (YYYY-MM-DD) in the club's configured meeting timezone. Prefer this over deriving the day from `datetime` in the browser, so the club's meeting day is shown regardless of the viewer's timezone. Null if the club or its timezone can't be resolved or the datetime is unparseable. */
  localDate?: Maybe<Scalars["String"]["output"]>;
  /** Link to map location */
  locationMapLink?: Maybe<Scalars["String"]["output"]>;
  /** Location description */
  locationText?: Maybe<Scalars["String"]["output"]>;
  /** Number of participants */
  participantCount: Scalars["Int"]["output"];
  /** Meeting participants */
  participants: Array<MeetingUser>;
  /** Project signup requests for this meeting (officers only) */
  projectRequests: Array<ProjectSignupRequest>;
  /** ID of the agenda template used to create this meeting's agenda */
  sourceAgendaTemplateId?: Maybe<Scalars["String"]["output"]>;
  /** Meeting status */
  status: MeetingStatus;
  /** Meeting theme */
  theme?: Maybe<Scalars["String"]["output"]>;
  /** Meeting title */
  title: Scalars["String"]["output"];
  /** Optimistic-concurrency counter. The client sends the value it last saw back as updateMeetingAgenda(baseVersion) so a stale full-agenda save is rejected instead of clobbering a concurrent edit. */
  version: Scalars["Long"]["output"];
  /** Voting rooms in this meeting */
  votingRooms: Array<VotingRoom>;
  /** Word of the day */
  wordOfDay?: Maybe<Scalars["String"]["output"]>;
};

/** Combined attendance summary, RSVP records, and attendance records for a meeting */
export type MeetingAttendanceBundle = {
  __typename: "MeetingAttendanceBundle";
  /** Per-member attendance records (officers only; null otherwise) */
  attendanceRecords?: Maybe<Array<MeetingAttendanceMemberRecord>>;
  /** Per-member RSVP records (officers only; null otherwise) */
  rsvpRecords?: Maybe<Array<MeetingRsvpRecord>>;
  /** RSVP/attendance summary counts (members and above) */
  summary?: Maybe<MeetingAttendanceSummary>;
};

/** RSVP and attendance status for a member in a meeting */
export type MeetingAttendanceMemberRecord = {
  __typename: "MeetingAttendanceMemberRecord";
  attendanceSource?: Maybe<AttendanceSource>;
  attendanceStatus?: Maybe<AttendanceStatus>;
  name: Scalars["String"]["output"];
  rsvpStatus?: Maybe<RsvpStatus>;
  userId: Scalars["ID"]["output"];
};

/** Summary counts for RSVP and attendance in a meeting */
export type MeetingAttendanceSummary = {
  __typename: "MeetingAttendanceSummary";
  attendedCount: Scalars["Int"]["output"];
  myAttendanceStatus?: Maybe<AttendanceStatus>;
  myRsvpStatus?: Maybe<RsvpStatus>;
  notAttendedCount: Scalars["Int"]["output"];
  rsvpAttendingCount: Scalars["Int"]["output"];
  rsvpMaybeCount: Scalars["Int"]["output"];
  rsvpNotAttendingCount: Scalars["Int"]["output"];
  /** Club members with ToastHost accounts included in this summary (not a meeting invitation list). */
  totalEligibleMembers: Scalars["Int"]["output"];
};

/** Result of a MeetingAttendanceSummary mutation */
export type MeetingAttendanceSummaryResult = {
  __typename: "MeetingAttendanceSummaryResult";
  /** The MeetingAttendanceSummary data if successful */
  data?: Maybe<MeetingAttendanceSummary>;
  /** Machine-readable code identifying the failure outcome */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable result message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Whether the mutation succeeded */
  success: Scalars["Boolean"]["output"];
};

/** A connection to a list of Meeting items */
export type MeetingConnection = {
  __typename: "MeetingConnection";
  /** A list of edges */
  edges: Array<MeetingEdge>;
  /** Pagination metadata */
  pageInfo: PageInfo;
  /** Total number of items in the connection */
  totalCount: Scalars["Int"]["output"];
};

/** What a member did at a meeting, at the strongest level recorded for that date */
export enum MeetingDateCategory {
  /** Attended without a speech, Table Topics or a role */
  AttendanceOnly = "ATTENDANCE_ONLY",
  /** Took a functionary role */
  Role = "ROLE",
  /** Delivered a prepared speech */
  Speech = "SPEECH",
  /** Spoke in Table Topics */
  TableTopics = "TABLE_TOPICS",
}

/** Information about an upcoming meeting date and available slots */
export type MeetingDateInfo = {
  __typename: "MeetingDateInfo";
  /** Number of available speech slots */
  availableSlots: Scalars["Int"]["output"];
  /** The meeting date (ISO format) */
  date: Scalars["String"]["output"];
  /** Whether this is a projected meeting (vs confirmed) */
  isProjected: Scalars["Boolean"]["output"];
};

/** An edge in a Meeting connection */
export type MeetingEdge = {
  __typename: "MeetingEdge";
  /** A cursor for pagination */
  cursor: Scalars["String"]["output"];
  /** The Meeting at the end of the edge */
  node: Meeting;
};

/** Consolidated meeting initialization data (replaces multiple REST calls) */
export type MeetingInitData = {
  __typename: "MeetingInitData";
  /** List of available meetings for the club */
  availableMeetings: Array<MeetingSummary>;
  /** Basic club information */
  clubInfo?: Maybe<ClubInfoSummary>;
  /** Club members (only if user is officer/manager) */
  clubMembers: Array<ClubMemberSummary>;
  /** Current user's meeting context */
  currentUser?: Maybe<MeetingUser>;
  /** Whether the club currently has an in-progress meeting */
  inProgressMeeting: InProgressMeetingResponse;
  /** The requested meeting (if meetingId provided) */
  meeting?: Maybe<Meeting>;
  /** Attendance/RSVP bundle for the requested meeting (null when meetingId not provided) */
  meetingAttendance?: Maybe<MeetingAttendanceBundle>;
  /** Available Toastmaster roles for the club */
  toastmasterRoles: Array<ToastmasterRole>;
};

/** A record of user participation in a meeting */
export type MeetingParticipationRecord = {
  __typename: "MeetingParticipationRecord";
  /** Specific agenda item for multiple roles in same meeting */
  agendaItemId?: Maybe<Scalars["String"]["output"]>;
  /** Category of participation */
  category: ParticipationCategory;
  /** Club where participation occurred */
  clubId: Scalars["ID"]["output"];
  /** When participation occurred (ISO format) */
  completedDate: Scalars["String"]["output"];
  /** Record creation timestamp (ISO format) */
  createdAt: Scalars["String"]["output"];
  /** How the participation was recorded */
  creditSource: ParticipationCreditSource;
  /** User who credited this participation */
  creditedBy: Scalars["ID"]["output"];
  /** Unique identifier */
  id?: Maybe<Scalars["ID"]["output"]>;
  /** Meeting identifier (supports synthetic IDs like easyspeak:tmclub.eu:123) */
  meetingId: Scalars["String"]["output"];
  /** Additional notes */
  notes?: Maybe<Scalars["String"]["output"]>;
  /** Type of participation (role or speech) */
  participationType: ParticipationType;
  /** Linked pathway completion ID */
  pathwayCompletionId?: Maybe<Scalars["ID"]["output"]>;
  /** Linked pathway project ID */
  pathwayProjectId?: Maybe<Scalars["String"]["output"]>;
  /** Custom role name */
  roleName?: Maybe<Scalars["String"]["output"]>;
  /** Raw role name (e.g., Toastmaster, General Evaluator) */
  roleType?: Maybe<Scalars["String"]["output"]>;
  /** Speech title for speech participation */
  speechTitle?: Maybe<Scalars["String"]["output"]>;
  /** Record last update timestamp (ISO format) */
  updatedAt: Scalars["String"]["output"];
  /** User who participated */
  userId: Scalars["ID"]["output"];
};

/** A meeting pattern with week numbers, day, time and duration */
export type MeetingPatternEntry = {
  __typename: "MeetingPatternEntry";
  dayOfWeek: Scalars["String"]["output"];
  durationHours: Scalars["Float"]["output"];
  startTime: Scalars["String"]["output"];
  weekNumbers: Array<Scalars["Int"]["output"]>;
};

/** Meeting pattern with day, time, and duration */
export type MeetingPatternInput = {
  /** Day of the week */
  dayOfWeek: DayOfWeekInput;
  /** Duration in hours */
  durationHours: Scalars["Float"]["input"];
  /** Start time in HH:mm format */
  startTime: Scalars["String"]["input"];
  /** Week numbers (1-5) when this pattern applies */
  weekNumbers: Array<Scalars["Int"]["input"]>;
};

/** Editable default template plus the partitioned recipient plan for a remind-all batch email */
export type MeetingRemindAllPreview = {
  __typename: "MeetingRemindAllPreview";
  actionSummary: Scalars["String"]["output"];
  defaultBody: Scalars["String"]["output"];
  defaultSubject: Scalars["String"]["output"];
  recipients: Array<MeetingReminderRecipient>;
  skippedRecipients: Array<MeetingReminderSkippedRecipient>;
};

/** Result of dispatching a remind-all batch email */
export type MeetingRemindAllSendResult = {
  __typename: "MeetingRemindAllSendResult";
  sentCount: Scalars["Int"]["output"];
  skippedCount: Scalars["Int"]["output"];
  skippedRecipients: Array<MeetingReminderSkippedRecipient>;
};

/** A role-taker who will receive a reminder email */
export type MeetingReminderRecipient = {
  __typename: "MeetingReminderRecipient";
  /** Roles the reminder covers, prefixed with 'Reminder for ' (drives the composer's per-recipient {{roles}} preview). */
  actionReason?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
};

/** A role-taker who will not receive a reminder (no deliverable email, guest, invalid address, or a send failure) */
export type MeetingReminderSkippedRecipient = {
  __typename: "MeetingReminderSkippedRecipient";
  name: Scalars["String"]["output"];
  /** One of: no_email, guest, invalid_email, send_failed */
  reason: Scalars["String"]["output"];
  roles: Array<Scalars["String"]["output"]>;
};

/** Result of a Meeting mutation */
export type MeetingResult = {
  __typename: "MeetingResult";
  /** The Meeting data if successful */
  data?: Maybe<Meeting>;
  /** Machine-readable code identifying the failure outcome */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable result message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Whether the mutation succeeded */
  success: Scalars["Boolean"]["output"];
};

/** An RSVP record for a member in a meeting */
export type MeetingRsvpRecord = {
  __typename: "MeetingRsvpRecord";
  name: Scalars["String"]["output"];
  rsvpStatus: RsvpStatus;
  userId: Scalars["ID"]["output"];
};

/** Club meeting schedule configuration */
export type MeetingScheduleInput = {
  /** Excluded dates (YYYY-MM-DD) */
  exclusions?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Meeting patterns */
  patterns: Array<MeetingPatternInput>;
  /** Timezone (e.g., 'Europe/London') */
  timezone: Scalars["String"]["input"];
};

/** Status of a club meeting */
export enum MeetingStatus {
  /** Meeting has been called off by an officer */
  Cancelled = "CANCELLED",
  /** Meeting is in draft state */
  Draft = "DRAFT",
  /** Meeting has finished */
  Finished = "FINISHED",
  /** Meeting is in progress */
  InProgress = "IN_PROGRESS",
  /** Meeting is scheduled */
  Scheduled = "SCHEDULED",
}

/** Summary information for a meeting (used in meeting lists) */
export type MeetingSummary = {
  __typename: "MeetingSummary";
  /** The officer's reason for cancelling, when the meeting is CANCELLED */
  cancellationReason?: Maybe<Scalars["String"]["output"]>;
  /** Club ID */
  clubId: Scalars["ID"]["output"];
  /** Meeting date (ISO format) */
  date: Scalars["String"]["output"];
  /** Meeting ID */
  id: Scalars["ID"]["output"];
  /** Meeting status */
  status: MeetingStatus;
  /** Meeting theme */
  theme?: Maybe<Scalars["String"]["output"]>;
  /** Meeting title */
  title: Scalars["String"]["output"];
  /** Word of the Day */
  wordOfDay?: Maybe<Scalars["String"]["output"]>;
};

/** A real-time meeting update event */
export type MeetingUpdateEvent = {
  __typename: "MeetingUpdateEvent";
  /** Agenda item ID (for agenda change events) */
  agendaItemId?: Maybe<Scalars["String"]["output"]>;
  /** Type of change (for applicable events) */
  changeType?: Maybe<Scalars["String"]["output"]>;
  eventType: Scalars["String"]["output"];
  /** Feedback session ID (for feedback events) */
  feedbackSessionId?: Maybe<Scalars["String"]["output"]>;
  /** Feedback subject ID (for feedback submitted events) */
  feedbackSubjectId?: Maybe<Scalars["String"]["output"]>;
  /** Whether voting/feedback is open (for status change events) */
  isOpen?: Maybe<Scalars["Boolean"]["output"]>;
  /** The updated meeting data (for MEETING_UPDATED events) */
  meeting?: Maybe<Meeting>;
  /** The meeting ID */
  meetingId: Scalars["String"]["output"];
  /** New meeting status (for status change events) */
  newStatus?: Maybe<Scalars["String"]["output"]>;
  /** Previous meeting status (for status change events) */
  oldStatus?: Maybe<Scalars["String"]["output"]>;
  /** Voting room ID (for voting events) */
  votingRoomId?: Maybe<Scalars["String"]["output"]>;
};

/** A participant in a meeting */
export type MeetingUser = {
  __typename: "MeetingUser";
  /** Whether the assignee has been notified via email */
  isAssigneeNotified?: Maybe<Scalars["Boolean"]["output"]>;
  /** Meeting ID this user belongs to */
  meetingId?: Maybe<Scalars["ID"]["output"]>;
  /** Composite user/guest identifier */
  meetingUserId?: Maybe<MeetingUserId>;
  /** Participant name, masked to the viewer's tier for this meeting (#2333) */
  name: Scalars["String"]["output"];
  /** User's relationship to the club */
  relationshipToClub: ClubAuthLevel;
  /** TI-canonical name, shown to officers/self when a display-name override is set (#2333) */
  tiName?: Maybe<Scalars["String"]["output"]>;
};

/** Composite identifier for a meeting participant (either a registered user or a guest) */
export type MeetingUserId = {
  __typename: "MeetingUserId";
  /** Guest ID (for guest participants) */
  guestId?: Maybe<Scalars["ID"]["output"]>;
  /** User ID (for registered users) */
  userId?: Maybe<Scalars["ID"]["output"]>;
};

/** Input type for specifying a meeting user (e.g., a slot occupant) */
export type MeetingUserInput = {
  /** Guest ID (for guest participants) */
  guestId?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether the assignee has been notified via email */
  isAssigneeNotified?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Display name */
  name: Scalars["String"]["input"];
  /** User ID (for registered users) */
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Result of a public member action (not renewing, already paid) */
export type MemberActionResult = {
  __typename: "MemberActionResult";
  clubLongName?: Maybe<Scalars["String"]["output"]>;
  memberName?: Maybe<Scalars["String"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

/** Detailed activity data for an individual member */
export type MemberActivityDetail = {
  __typename: "MemberActivityDetail";
  /** Date of most recent attendance (includes participation days) */
  lastAttendedDate?: Maybe<Scalars["String"]["output"]>;
  /** Date of most recent participation (role or speech) */
  lastParticipationDate?: Maybe<Scalars["String"]["output"]>;
  /** List of meeting dates with activity category */
  meetingDates: Array<CategorizedMeetingDate>;
  /** Number of meetings attended (participation + attendance) */
  meetingsAttended: Scalars["Int"]["output"];
  /** User ID of the member */
  memberId: Scalars["ID"]["output"];
  /** Display name of the member */
  memberName: Scalars["String"]["output"];
  /** End date of the tracking period */
  periodEnd: Scalars["String"]["output"];
  /** Start date of the tracking period */
  periodStart: Scalars["String"]["output"];
  /** Breakdown of participation by role type */
  roleBreakdown: Array<RoleBreakdownEntry>;
  /** History of speeches given */
  speechHistory: Array<SpeechHistoryEntry>;
};

/** Activity data for an individual member */
export type MemberActivityMember = {
  __typename: "MemberActivityMember";
  /** Activity level classification */
  activityLevel: ActivityLevel;
  /** Date of most recent attendance (includes participation days) */
  lastAttendedDate?: Maybe<Scalars["String"]["output"]>;
  /** Date of most recent participation (role or speech) */
  lastParticipationDate?: Maybe<Scalars["String"]["output"]>;
  /** List of meeting dates with activity category */
  meetingDates: Array<CategorizedMeetingDate>;
  /** User ID of the member */
  memberId: Scalars["ID"]["output"];
  /** Display name of the member */
  memberName: Scalars["String"]["output"];
  /** Current membership status */
  membershipStatus: MembershipStatus;
  /** Participation statistics */
  stats: MemberActivityStats;
};

/** Participation statistics for a member */
export type MemberActivityStats = {
  __typename: "MemberActivityStats";
  /** Number of meetings attended (participation + attendance) */
  meetingsAttended: Scalars["Int"]["output"];
  /** Number of meetings where member participated */
  meetingsWithParticipation: Scalars["Int"]["output"];
  /** Total number of roles filled */
  rolesCount: Scalars["Int"]["output"];
  /** Number of speeches given */
  speechesCount: Scalars["Int"]["output"];
  /** Number of Table Topics (impromptu speeches) given */
  tableTopicsCount: Scalars["Int"]["output"];
};

/** Summary statistics for member activity in a club */
export type MemberActivitySummary = {
  __typename: "MemberActivitySummary";
  /** Number of dormant members */
  dormantMembers: Scalars["Int"]["output"];
  /** Number of frequently active members */
  frequentMembers: Scalars["Int"]["output"];
  /** Number of infrequently active members */
  infrequentMembers: Scalars["Int"]["output"];
  /** Number of meetings held in the tracking period */
  meetingsInPeriod: Scalars["Int"]["output"];
  /** Number of non-expired members with at least one active pathway enrollment */
  membersWithActivePathwayEnrollment: Scalars["Int"]["output"];
  /** Number of non-expired members with more than one active pathway enrollment */
  membersWithMultipleActivePathwayEnrollments: Scalars["Int"]["output"];
  /** Total number of members tracked */
  totalMembers: Scalars["Int"]["output"];
};

/** Member activity tracker data for a club */
export type MemberActivityTracker = {
  __typename: "MemberActivityTracker";
  /** Activity data for each member */
  members: Array<MemberActivityMember>;
  /** End date of the tracking period */
  periodEnd: Scalars["String"]["output"];
  /** Start date of the tracking period */
  periodStart: Scalars["String"]["output"];
  /** Summary statistics */
  summary: MemberActivitySummary;
};

/** Aggregated pathway state for a target club member: enrollments, completions, and project requests (pending + approved/scheduled). */
export type MemberPathwayProgress = {
  __typename: "MemberPathwayProgress";
  /** Projects the member has delivered */
  completions: Array<PathwayCompletionRecord>;
  /** Pathways the member is enrolled in */
  enrollments: Array<UserPathwayEnrollment>;
  /** All of the member's outstanding project signup requests (both pending and approved/scheduled). Frontend categorises by status. */
  projectRequests: Array<ProjectSignupRequest>;
};

/** Payment initialization data for member dues */
export type MemberPaymentData = {
  __typename: "MemberPaymentData";
  alreadyPaid: Scalars["Boolean"]["output"];
  amount?: Maybe<Scalars["Long"]["output"]>;
  clientIntentSecret?: Maybe<Scalars["String"]["output"]>;
  clubLongName?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  fullDuesAmountDesc?: Maybe<Scalars["String"]["output"]>;
  memberName?: Maybe<Scalars["String"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  stripePublishableKey?: Maybe<Scalars["String"]["output"]>;
  testMode?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Type of club membership */
export enum MemberType {
  /** Current paying member */
  Active = "ACTIVE",
  /** Membership expired */
  Expired = "EXPIRED",
  /** Dual member from another club */
  ProspectiveDual = "PROSPECTIVE_DUAL",
  /** New prospective member */
  ProspectiveNew = "PROSPECTIVE_NEW",
  /** Reinstated member */
  ProspectiveReinstated = "PROSPECTIVE_REINSTATED",
  /** Member transferred from another club */
  ProspectiveTransfer = "PROSPECTIVE_TRANSFER",
}

/** Summary of club membership statistics */
export type MembersSummary = {
  __typename: "MembersSummary";
  /** Number of paid members */
  activeMembers: Scalars["Int"]["output"];
  /** Members with dues coming */
  dueCount: Scalars["Int"]["output"];
  /** Date of last membership data import (ISO format) */
  lastMembershipImport?: Maybe<Scalars["String"]["output"]>;
  /** All club members */
  members: Array<ClubMember>;
  /** Members not renewing */
  notRenewingCount: Scalars["Int"]["output"];
  /** Members in TI with active payment */
  tiMembers: Scalars["Int"]["output"];
  /** Total number of members */
  totalMembers: Scalars["Int"]["output"];
};

/** Club membership configuration */
export type MembershipConfig = {
  __typename: "MembershipConfig";
  /** Bank account name for transfers */
  accountName: Scalars["String"]["output"];
  /** Bank account number for transfers */
  accountNo: Scalars["String"]["output"];
  /** Whether bank transfer payments are enabled */
  allowBankTransfers: Scalars["Boolean"]["output"];
  /** Whether Stripe card payments are enabled */
  allowCardPayments: Scalars["Boolean"]["output"];
  /** Whether new member registration is open */
  allowNewMembers: Scalars["Boolean"]["output"];
  /** Whether Stripe card payments can be enabled (club has Stripe connected) */
  cardsEnablable: Scalars["Boolean"]["output"];
  /** Whether to charge in full months */
  chargeInFullMonths: Scalars["Boolean"]["output"];
  /** Club identifier */
  clubId: Scalars["Int"]["output"];
  /** Payment currency code */
  currency: Scalars["String"]["output"];
  /** Custom returning member email text, sent to a member whose dues lapsed months ago */
  customLongExpiredText?: Maybe<Scalars["String"]["output"]>;
  /** Custom membership application email text, sent to a new member */
  customNewMemberText?: Maybe<Scalars["String"]["output"]>;
  /** Custom renewal email text */
  customRenewalText?: Maybe<Scalars["String"]["output"]>;
  /** The returning member body a club with no custom text sends. */
  defaultLongExpiredText: Scalars["String"]["output"];
  /** The membership application body a club with no custom text sends. */
  defaultNewMemberText: Scalars["String"]["output"];
  /** The renewal body a club with no custom text is sent. The editor seeds from this so the officer's starting point is the wording members actually receive. */
  defaultRenewalText: Scalars["String"]["output"];
  /** Whether membership feature is enabled */
  enabled: Scalars["Boolean"]["output"];
  /** Whether custom renewal text is configured */
  hasCustomRenewalText: Scalars["Boolean"]["output"];
  /** IBAN for international transfers */
  iban: Scalars["String"]["output"];
  /** Minimum months forward to charge */
  minMonthsToCharge: Scalars["Int"]["output"];
  /** Monthly dues in pence, supports fractional pence */
  monthlyDuesPence: Scalars["Float"]["output"];
  /** New member fee in pence */
  newMemberFeePence: Scalars["Int"]["output"];
  /** The club's officer term length in months: 6 or 12 */
  officerTermMonths: Scalars["Int"]["output"];
  /** How often the club collects renewals: SEMI_ANNUAL, ANNUAL_SEPTEMBER or ANNUAL_MARCH */
  renewalCycle: Scalars["String"]["output"];
  /** Days before next renewal to allow re-registration */
  rolloverDays: Scalars["Int"]["output"];
  /** Bank sort code for transfers */
  sortCode: Scalars["String"]["output"];
  /** List of valid currency codes */
  validCurrencies: Array<Scalars["String"]["output"]>;
};

/** Membership configuration settings. Every field is optional; omit one to leave it unchanged. */
export type MembershipConfigInput = {
  /** Bank account name */
  accountName?: InputMaybe<Scalars["String"]["input"]>;
  /** Bank account number */
  accountNo?: InputMaybe<Scalars["String"]["input"]>;
  /** Allow bank transfer payments */
  allowBankTransfers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Allow card payments (requires Stripe) */
  allowCardPayments?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Allow new member signups */
  allowNewMembers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Charge in full months */
  chargeInFullMonths?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Currency code (e.g. 'gbp') */
  currency?: InputMaybe<Scalars["String"]["input"]>;
  /** Custom returning member email text. Omit to keep the stored body; null or "" clears it. */
  customLongExpiredText?: InputMaybe<Scalars["String"]["input"]>;
  /** Custom membership application email text. Omit to keep the stored body; null or "" clears it. */
  customNewMemberText?: InputMaybe<Scalars["String"]["input"]>;
  /** Custom renewal email text. Omit to keep the stored body; null or "" clears it. */
  customRenewalText?: InputMaybe<Scalars["String"]["input"]>;
  /** Enable membership management */
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** IBAN number */
  iban?: InputMaybe<Scalars["String"]["input"]>;
  /** Minimum months to charge */
  minMonthsToCharge?: InputMaybe<Scalars["Int"]["input"]>;
  /** Monthly dues in minor units, supports fractional pence */
  monthlyDues?: InputMaybe<Scalars["Float"]["input"]>;
  /** New member fee in minor units */
  newMemberFee?: InputMaybe<Scalars["Int"]["input"]>;
  /** The club's officer term length in months: 6 or 12 */
  officerTermMonths?: InputMaybe<Scalars["Int"]["input"]>;
  /** Renewal cycle: SEMI_ANNUAL, ANNUAL_SEPTEMBER or ANNUAL_MARCH. Defaults to SEMI_ANNUAL. */
  renewalCycle?: InputMaybe<Scalars["String"]["input"]>;
  /** Days before renewal to send reminders */
  rolloverDays?: InputMaybe<Scalars["Int"]["input"]>;
  /** Bank sort code */
  sortCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type MembershipEmailPreview = {
  __typename: "MembershipEmailPreview";
  longExpiredPreview: EmailPreview;
  newMemberPreview: EmailPreview;
  renewalPreview: EmailPreview;
};

export type MembershipFeesPreview = {
  __typename: "MembershipFeesPreview";
  paymentValues: Array<FeePreviewEntry>;
  today: Scalars["String"]["output"];
};

/** Member's current membership payment status */
export enum MembershipStatus {
  /** Membership is paid and current */
  Active = "ACTIVE",
  /** Membership has expired */
  Expired = "EXPIRED",
}

/** Whether the current member has completed Level 2 of a path, which adding the Mentor Program themselves needs */
export type MentorProgramPrerequisite = {
  __typename: "MentorProgramPrerequisite";
  /** The Mentor Program's pathway ID */
  pathwayId: Scalars["Int"]["output"];
  /** True when Level 2 of an enrolled pathway is COMPLETED, as the Pathways chart derives it */
  prerequisiteMet: Scalars["Boolean"]["output"];
};

/** The root mutation type */
export type Mutation = {
  __typename: "Mutation";
  /** Activate a Toastmasters International club on ToastHost (requires login with the club's TI management email) */
  activateClub: ActivateClubResult;
  /** Add a self-asserted COT club role for the current user (#2026) */
  addAssertedClubRole: Array<CotOfficerClubRole>;
  /** Name a user as a host of this COT event (requires an existing host, senior district officer, or admin) */
  addCOTEventHost: CotEventResult;
  /** Add a manual attendance record to a session (requires district officer or admin) */
  addCOTManualAttendance: CotUploadResult;
  /** Add a manual training credit to an officer */
  addCOTManualTrainingCredit: CotOfficerMutationResult;
  /** Add a district note to an officer record */
  addCOTOfficerNote: CotOfficerMutationResult;
  /** Add a candidate to a voting room (requires club officer or admin) */
  addCandidate: AddCandidateResult;
  /** Add a subject to a feedback session (requires club officer or admin) */
  addFeedbackSubject: MeetingResult;
  /** Add a subject to a feedback session (requires club officer or admin) */
  addFeedbackSubjectCanonical: AddFeedbackSubjectResult;
  /** Add a custom voting room to a meeting (requires club officer or admin) */
  addVotingRoom: VotingRoom;
  /** Trigger the officer-projection backfill (admin only) */
  adminBackfillOfficerProjection: AdminOfficerProjectionBackfillResult;
  /** Close officers' flags on an EasySpeak identity, as resolved or dismissed (admin only) */
  adminCloseEasySpeakIdentityFlags: AdminCloseEasySpeakIdentityFlagsResult;
  /** Delete a club-dashboard nudge rule (admin only) */
  adminDeleteNudge: AdminDeleteNudgeResult;
  /** Issue a one-time approval code for a pending debug API repair plan (admin only) */
  adminIssueDebugRepairApproval: AdminDebugRepairApprovalResult;
  /**
   * Retired: always refuses to mint an agent GraphQL token (admin only)
   * @deprecated The agent token is retired (#6641). Removed with the agent_graphql_token table drop (#6637).
   */
  adminMintAgentToken: AdminMintAgentTokenResult;
  /** Mint an EasySpeak capture session (admin only) */
  adminMintEasySpeakCaptureToken: AdminMintCaptureTokenResult;
  /** Run the speech scheduling reconciler once, ahead of its schedule (admin only). Derives every REQUESTED and SCHEDULED speech row from current requests and agendas - idempotent, so a run with nothing to do writes nothing */
  adminReconcileSpeechSchedule: AdminReconcileSpeechScheduleResult;
  /** Return every FAILED relationship co-emission to the retry queue, due immediately (admin only). Returns the backlog as it stands after the requeue */
  adminRequeueFailedRelationshipEmissions: AdminRelationshipEmissionOutbox;
  /** Return the named mutation-outbox rows that are still FAILED to the retry queue, due immediately with a fresh attempt budget (admin only) */
  adminRequeueMutationOutboxRows: AdminRequeueMutationOutboxRowsResult;
  /**
   * Retired: always refuses to revoke an agent GraphQL token (admin only)
   * @deprecated The agent token is retired (#6641). Removed with the agent_graphql_token table drop (#6637).
   */
  adminRevokeAgentToken: AdminRevokeAgentTokenResult;
  /** Revoke an EasySpeak capture session (admin only) */
  adminRevokeEasySpeakCaptureToken: AdminRevokeCaptureTokenResult;
  /** Start the EasySpeak auto-stage sweep now, over an optional subset of the mapped clubs (admin only) */
  adminRunEasySpeakAutoStage: AdminRunAutoStageResult;
  /** Start the background projection-vs-roster reconciliation sweep (admin only) */
  adminRunRelationshipReconciliation: AdminRelationshipReconciliationRunResult;
  /** Create (id omitted) or overwrite (id given) a club-dashboard nudge rule (admin only) */
  adminSaveNudge: AdminSaveNudgeResult;
  /** Send emails to selected clubs and their officers (admin only) */
  adminSendClubEmails: AdminSendEmailsResponse;
  /** Turn a club-dashboard nudge rule on or off (admin only) */
  adminSetNudgeEnabled: AdminDeleteNudgeResult;
  /** Start one club's EasySpeak archive import as a background job (admin only) */
  adminStartEasySpeakArchiveImport: AdminStartArchiveImportResult;
  /** Trigger club-only import from Toastmasters data (admin only) */
  adminTriggerClubImport: AdminActionResult;
  /** Trigger full Toastmasters data sync including DCP performance (admin only) */
  adminTriggerTMDataImport: AdminActionResult;
  /** Phase 3 (#1742): auto-apply COT credit to on-platform home districts for a session's external attendees (requires senior district officer or admin) */
  applyCOTCrossDistrictHandoff: CotCrossDistrictHandoffResult;
  /** Approve a role signup request (requires club officer or admin) */
  approveRoleRequest: MeetingResult;
  /** Assign a district officer (requires senior officer or admin) */
  assignDistrictOfficer: SimpleResult;
  /** Assign a custom officer role to a club member (requires an admin, the club manager or an elected officer) */
  assignOfficer: OfficerResult;
  /** Assign a pathway project to a speaker agenda item (requires club officer or admin) */
  assignProjectToAgendaItem: MeetingResult;
  /** Officer: bulk mark attendance for multiple members in a meeting */
  bulkMarkMeetingAttendance: MeetingAttendanceSummaryResult;
  /** Cancel a COT event, deregistering and notifying everyone (requires district officer or admin) */
  cancelCOTEvent: CotEventResult;
  /** Cancel your own COT event registration */
  cancelCOTRegistration: CotEventResult;
  /** Cancel a meeting (Draft or Scheduled -> Cancelled, requires club officer or admin). Role assignments are kept, and each registered member holding a role who has an email address is emailed once. Guests and members without an address are not. */
  cancelMeeting: MeetingResult;
  /** Cancel your own assigned meeting role or speech (requires club membership) */
  cancelMyRoleAssignment: MeetingResult;
  /** Cancel the authenticated user's own pending project request */
  cancelOwnProjectRequest: ProjectRequestListResult;
  /** Cancel the authenticated user's own scheduled project request when eligible */
  cancelOwnScheduledProjectRequest: ProjectRequestListResult;
  /** Cancel a pending project request (requires club membership, own requests only) */
  cancelProjectRequest: ProjectRequestListResult;
  /** Cancel your own pending role request */
  cancelRoleRequest: MeetingResult;
  /** Cancel a scheduled project request when the meeting date has passed (requires club membership) */
  cancelScheduledProjectRequest: ProjectRequestListResult;
  /** Clear an officer record's not-an-officer mark, which returns the record to the round's officer counts, training figures, club summaries, broadcast audiences and officer exports. */
  clearCOTOfficerNotOfficerMark: CotOfficerMutationResult;
  /** Clear a registration's not-an-officer mark. An active row with no officer match returns to the unmatched list. A matched row stays matched, and a cancelled, waitlisted or pending row stays out of the unmatched list. */
  clearCOTRegistrationNotOfficerMark: CotNotOfficerMarkResult;
  /** Clear payment status and reset to TI status (requires club officer or admin) */
  clearMemberPaymentStatus: SimpleResult;
  /** Officer-vouched confirmation of a staged guestbook signing (requires officer access) */
  confirmPendingGuestbookSubmission: SimpleResult;
  /** Officer-vouched confirmation of a staged membership application (requires officer access) */
  confirmPendingMembershipApplication: SimpleResult;
  /** Convert an officer-scheduled general speech to a pathway project (requires club officer or admin) */
  convertOfficerSpeechRequest: MeetingResult;
  /** Create a new agenda template for a club (requires club officer or admin) */
  createAgendaTemplate: AgendaTemplateResult;
  /** Create a new COT event (requires district officer or admin) */
  createCOTEvent: CotEventResult;
  /** Create a new COT session (requires district officer or admin) */
  createCOTSession: CotSessionResult;
  /** Create a new link for a club (requires officer access) */
  createClubLink: ClubLinkResult;
  /** Create a new meeting for a club (requires club officer or admin) */
  createMeeting: MeetingResult;
  /** Create a new meeting participant (guests may self-register as a named attendee) */
  createMeetingUser: MeetingUser;
  /** Create a new project/speech request (requires club membership) */
  createProjectRequest: ProjectRequestResult;
  /** Delete an agenda template (requires club officer or admin) */
  deleteAgendaTemplate: DeleteResult;
  /** Delete a training-event attendance record (requires district officer or admin) */
  deleteCOTAttendance: CotAttendanceMutationResult;
  /** Delete a COT event (requires district officer or admin) */
  deleteCOTEvent: CotDeleteResult;
  /** Delete a COT session (requires district officer or admin) */
  deleteCOTSession: CotDeleteResult;
  /** Delete a club image (requires club officer/manager or admin) */
  deleteClubImage: ImageDeleteResult;
  /** Delete a club link (requires officer access) */
  deleteClubLink: SimpleResult;
  /** Delete a meeting (requires club officer or admin) */
  deleteMeeting: DeleteResult;
  /** Delete a custom voting room from a meeting (requires club officer or admin) */
  deleteVotingRoom: Scalars["Boolean"]["output"];
  /** Enroll a club member in additional pathways */
  enrollMemberInPathways: EnrollmentListResult;
  /** Finish a meeting (InProgress -> Finished, requires club officer or admin). Returns auto-credit summary. */
  finishMeeting: FinishMeetingResult;
  /** Unsubscribe a guest from the guest list (public, no authentication required) */
  guestUnsubscribe: SimpleResult;
  /** Link a session registration to an existing or newly created officer record */
  linkCOTRegistrationToOfficer: CotOfficerMutationResult;
  /** Link a completed meeting role participation to pathway role credit */
  linkRoleParticipation: PathwayCompletionRecordRef;
  /** Phase 1G: mark one or more registrants attended live (requires event host, senior district officer, or admin) */
  markCOTAttendanceLive: CotLiveAttendanceResult;
  /** Mark a failing member or guest address as working, so mail is sent to it again (requires club officer or admin) */
  markEmailAddressWorking: SimpleResult;
  /** Officer: mark a member's attendance for a meeting */
  markMeetingAttendance: MeetingAttendanceSummaryResult;
  /** Mark a member as not renewing (requires club officer or admin) */
  markMemberNotRenewing: SimpleResult;
  /** Mark a member as notified as paid (requires club officer or admin) */
  markMemberNotifiedAsPaid: SimpleResult;
  /** Mark a member as having paid (requires club officer or admin) */
  markMemberPaid: SimpleResult;
  /** Override or correct data on an officer record (requires district officer or admin) */
  overrideCOTOfficerRecord: CotOverrideResult;
  /** Replace meeting agenda with the default agenda (requires club officer or admin) */
  populateDefaultAgenda: MeetingResult;
  /** Preview the remind-all batch email (requires club officer or admin) */
  previewRemindAll: MeetingRemindAllPreview;
  /** Propose a meeting role to a member */
  proposeRole: RoleProposalResult;
  /** Record that a member has paid via alternate means (public, action ID auth) */
  publicMemberMarkAsPaid: MemberActionResult;
  /** Record that a member will not renew (public, action ID auth) */
  publicMemberNotRenewing: MemberActionResult;
  /** Publish a COT event (requires district officer or admin) */
  publishCOTEvent: CotEventResult;
  /** Record a manual role completion or standalone role participation for a club member */
  recordManualRoleCompletion: CompletionResult;
  /** Record a manual speech completion for a club member */
  recordManualSpeechCompletion: CompletionResult;
  /** Record a manual non-speech activity completion for a club member */
  recordNonSpeechCompletion: CompletionResult;
  /** Refresh completion status for all officers in a COT round (requires district officer or admin) */
  refreshCOTCompletionStatus: CotRefreshResult;
  /** Refresh district data lists (requires district officer or admin) */
  refreshDistrictData: SimpleResult;
  /** Officer or external attendee self-registration for a published COT event */
  registerForCOTEvent: CotEventResult;
  /** Register a guest for a club (public, no authentication required) */
  registerGuest: RegisterGuestResult;
  /** Reinstate a cancelled meeting (Cancelled -> Scheduled, requires club officer or admin) */
  reinstateMeeting: MeetingResult;
  /** Reject a role signup request (requires club officer or admin) */
  rejectRoleRequest: MeetingResult;
  /** Remove a self-asserted COT club role for the current user (#2026) */
  removeAssertedClubRole: Array<CotOfficerClubRole>;
  /** Remove a user from this COT event's host list (requires an existing host, senior district officer, or admin) */
  removeCOTEventHost: CotEventResult;
  /** Remove a manual training credit from an officer */
  removeCOTManualTrainingCredit: CotOfficerMutationResult;
  /** Remove a candidate from a voting room (requires club officer or admin) */
  removeCandidate: MeetingResult;
  /** Remove a district officer (requires senior officer or admin) */
  removeDistrictOfficer: SimpleResult;
  /** Remove a subject from a feedback session (requires club officer or admin) */
  removeFeedbackSubject: MeetingResult;
  /** Remove a guest from the guestbook (requires officer access) */
  removeGuest: SimpleResult;
  /** Remove a member from the club (requires club officer or admin) */
  removeMember: SimpleResult;
  /** Remove a club member's enrollment in a pathway that has no recorded completions */
  removeMemberPathwayEnrollment: EnrollmentListResult;
  /** Remove an assigned officer role (requires an admin, the club manager or an elected officer) */
  removeOfficer: SimpleResult;
  /** Remove a pending speech request (requires club officer or admin) */
  removeProjectRequest: ProjectRequestListResult;
  /** Withdraw a speech or Education Series pathway credit from a member; officer-only */
  removeSpeechCompletion: Scalars["Boolean"]["output"];
  /** Rename a custom voting room, at any time (requires club officer or admin) */
  renameVotingRoom: VotingRoom;
  /** Reorder candidates in a voting room (requires club officer or admin) */
  reorderCandidates: MeetingResult;
  /** Reorder club links (requires officer access) */
  reorderClubLinks: SimpleResult;
  /** Request to sign up for a meeting role (requires club membership) */
  requestRole: MeetingResult;
  /** Re-send the verification email for a pending public COT registration */
  resendCOTRegistrationVerification: CotEventResult;
  /** Resend welcome email to a guest (requires officer access) */
  resendGuestWelcomeEmail: SimpleResult;
  /** Re-send the verification email for a staged guestbook signing (requires officer access) */
  resendPendingGuestbookVerification: SimpleResult;
  /** Re-send the verification email for a staged membership application (requires officer access) */
  resendPendingMembershipVerification: SimpleResult;
  /** Respond to a role proposal as the proposed member */
  respondToRoleProposal: RoleProposalResult;
  /** Retry sending a failed role proposal notification */
  retryRoleProposalSend: RoleProposalResult;
  /** Revert a meeting to draft (Scheduled -> Draft, requires club officer or admin) */
  revertMeetingToDraft: MeetingResult;
  /** Revert a meeting to in progress (Finished -> InProgress, requires club officer or admin) */
  revertMeetingToInProgress: MeetingResult;
  /** Replace the club's cost lines, meetings per year, finance currency and card fee. Officers only */
  saveClubFinanceConfig: ClubFinanceStoredConfig;
  /** Schedule a meeting (Draft -> Scheduled, requires club officer or admin) */
  scheduleMeeting: MeetingResult;
  /** Send payment reminders to all due members (requires club officer or admin) */
  sendAllPaymentReminders: SimpleResult;
  /** Send a district COT broadcast to a resolved audience (requires district officer or admin) */
  sendCOTBroadcast: CotBroadcastResult;
  /** Send a test copy of a COT broadcast to the current user only (no audience, no audit row; requires district officer or admin) */
  sendCOTBroadcastTest: CotBroadcastResult;
  /** Send an email to guestbook recipients (requires officer access) */
  sendGuestbookEmail: SimpleResult;
  /** Send payment reminder email to a member (requires club officer or admin) */
  sendPaymentReminder: SimpleResult;
  /** Send the remind-all batch email to all role-takers (requires club officer or admin) */
  sendRemindAll: MeetingRemindAllSendResult;
  /** Set the manual role assignments for the MEMBER the record belongs to. The list is their whole set: a role type not in it is unassigned wherever it sat, and a role type held on another of their records is accepted and filed there. recordId says which record the district officer was looking at, not what they may assign (#3554). The request must carry the expectedAssignmentToken it was derived from, or it is refused (#3571). */
  setCOTManualRoleAssignments: CotOfficerMutationResult;
  /** Mark an officer record as not an officer of the round, such as a presenter whose registration created it. The record leaves the round's officer counts, training figures, club summaries, broadcast audiences and officer exports, and its registrations still count as matched. Refused on a record the district's officer list names (source district_import, or such a record merged into it), and on a merged record. A set on a marked record replaces its mark. */
  setCOTOfficerNotOfficerMark: CotOfficerMutationResult;
  /** Mark an unmatched registration as not an officer, which leaves it out of the unmatched counts. Refused on a registration the matcher matches to an officer, and on a cancelled, waitlisted or pending one. alsoMark marks the same person's other unmatched registrations in the round in the same action. */
  setCOTRegistrationNotOfficerMark: CotNotOfficerMarkResult;
  /** Record or correct a club's EasySpeak club id and instance (admin only) */
  setClubEasySpeakMapping: SimpleResult;
  /** Record the club's opening balance, withdrawing any figure it entered before. Officers only */
  setClubFinanceOpeningBalance: ClubFinanceOpeningBalance;
  /** Set a template as the default for a club (requires club officer or admin) */
  setDefaultAgendaTemplate: SimpleResult;
  /** Open or close a feedback session (requires club officer or admin) */
  setFeedbackSessionStatus: MeetingResult;
  /** Officer: set a member's RSVP for a scheduled meeting on their behalf */
  setMemberMeetingRsvp: MeetingAttendanceSummaryResult;
  /** Set your RSVP status for a meeting (requires club membership) */
  setMyMeetingRsvp: MeetingAttendanceSummaryResult;
  /** Open or close a voting room (requires club officer or admin) */
  setVotingRoomStatus: MeetingResult;
  /** Start a meeting (Scheduled -> InProgress, requires club officer or admin) */
  startMeeting: MeetingResult;
  /** Submit feedback for a subject within a feedback session */
  submitFeedback: MeetingResult;
  /** Submit new member registration form (public) */
  submitNewMemberForm: NewMemberResponse;
  /** Submit a vote for a candidate in a voting room */
  submitVote: MeetingResult;
  /** Test club email configuration by sending a test email (requires club officer/manager or admin) */
  testEmailConfiguration: SimpleResult;
  /** Trigger sending the periodic email for a club (requires club officer/manager or admin) */
  triggerPeriodicEmail: SimpleResult;
  /** Unlink a role participation from pathway role credit; officer-only */
  unlinkRoleParticipation: Scalars["Boolean"]["output"];
  /** Phase 1G: remove one or more host-marked live attendance rows (requires event host, senior district officer, or admin) */
  unmarkCOTAttendanceLive: CotLiveAttendanceResult;
  /** Reverse a prior merge, restoring a merged-in record (requires district officer or admin) */
  unmergeCOTOfficerRecord: CotOverrideResult;
  /** Move a COT event back to draft, deregistering and notifying everyone (requires district officer or admin) */
  unpublishCOTEvent: CotEventResult;
  /** Update an existing agenda template (requires club officer or admin) */
  updateAgendaTemplate: AgendaTemplateResult;
  /** Update a training-event attendance record (requires district officer or admin) */
  updateCOTAttendance: CotAttendanceMutationResult;
  /** Update a COT event's metadata (requires district officer or admin) */
  updateCOTEvent: CotEventResult;
  /** Update an officer's club roles. The list is the record's whole set: a role not in it is deleted. The request must carry the expectedClubRolesToken read beside the roles it was derived from, or it is refused (#3623). */
  updateCOTOfficerClubRoles: CotOfficerMutationResult;
  /** Update a COT session (requires district officer or admin) */
  updateCOTSession: CotSessionResult;
  /** Update a candidate in a voting room (requires club officer or admin) */
  updateCandidate: MeetingResult;
  /** Update basic club configuration (requires club officer/manager or admin) */
  updateClubConfig: SimpleResult;
  /** Update the club's Education config (officer/admin only) */
  updateClubEducationConfig: ClubEducationConfig;
  /** Update an existing club link (requires officer access) */
  updateClubLink: ClubLinkResult;
  /** Update district configuration (requires district officer or admin) */
  updateDistrictConfig: SimpleResult;
  /** Update club email configuration (requires club officer/manager or admin) */
  updateEmailConfiguration: SimpleResult;
  /** Update a subject in a feedback session (requires club officer or admin) */
  updateFeedbackSubject: MeetingResult;
  /** Update club guestbook configuration (requires club officer/manager or admin) */
  updateGuestbookConfig: GuestbookConfigResult;
  /** Update the meeting agenda (requires club officer or admin) */
  updateMeetingAgenda: MeetingResult;
  /** Apply agenda edit operations to the current agenda (requires club officer or admin) */
  updateMeetingAgendaOps: MeetingResult;
  /** Update meeting details (requires club officer or admin) */
  updateMeetingDetails: MeetingResult;
  /** Update membership configuration (requires club officer or admin) */
  updateMembershipConfig: SimpleResult;
  /** Update which classes of automated notification copy the club inbox (requires club officer/manager or admin) */
  updateNotificationPreferences: SimpleResult;
  /** Update an existing project request (requires club membership) */
  updateProjectRequest: ProjectRequestListResult;
  /** Update metadata for an existing speech completion record */
  updateSpeechCompletion: CompletionResult;
  /** Edit the title and project of a requested or scheduled speech (own speech, or any speech as an officer) */
  updateSpeechSettings: SpeechCardResult;
  /** Update current user's pathway enrollments */
  updateUserEnrollments: EnrollmentListResult;
  /** Update club website configuration (requires club officer/manager or admin) */
  updateWebConfig: WebConfigResult;
  /** Confirm a pending public COT registration using its email-verification token */
  verifyCOTRegistration: CotEventResult;
  /** Withdraw a pending role proposal */
  withdrawRoleProposal: RoleProposalResult;
};

/** The root mutation type */
export type MutationActivateClubArgs = {
  clubNumber: Scalars["Int"]["input"];
};

/** The root mutation type */
export type MutationAddAssertedClubRoleArgs = {
  clubId: Scalars["ID"]["input"];
  clubName?: InputMaybe<Scalars["String"]["input"]>;
  role: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationAddCotEventHostArgs = {
  eventId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationAddCotManualAttendanceArgs = {
  club?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  joinTime: Scalars["String"]["input"];
  leaveTime: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  role?: InputMaybe<Scalars["String"]["input"]>;
  sessionId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationAddCotManualTrainingCreditArgs = {
  cotId: Scalars["ID"]["input"];
  reason: Scalars["String"]["input"];
  recordId: Scalars["ID"]["input"];
  trainingDate?: InputMaybe<Scalars["String"]["input"]>;
  trainingDescription?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationAddCotOfficerNoteArgs = {
  cotId: Scalars["ID"]["input"];
  note: Scalars["String"]["input"];
  recordId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationAddCandidateArgs = {
  agendaSyncKey?: InputMaybe<Scalars["String"]["input"]>;
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  meetingUserIdGuestId?: InputMaybe<Scalars["String"]["input"]>;
  meetingUserIdUserId?: InputMaybe<Scalars["ID"]["input"]>;
  name: Scalars["String"]["input"];
  votingRoomId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationAddFeedbackSubjectArgs = {
  agendaSyncKey?: InputMaybe<Scalars["String"]["input"]>;
  clubId: Scalars["ID"]["input"];
  feedbackSessionId: Scalars["String"]["input"];
  meetingId: Scalars["ID"]["input"];
  meetingUserIdGuestId?: InputMaybe<Scalars["String"]["input"]>;
  meetingUserIdUserId?: InputMaybe<Scalars["ID"]["input"]>;
  name: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationAddFeedbackSubjectCanonicalArgs = {
  agendaSyncKey?: InputMaybe<Scalars["String"]["input"]>;
  clubId: Scalars["ID"]["input"];
  feedbackSessionId: Scalars["String"]["input"];
  meetingId: Scalars["ID"]["input"];
  meetingUserIdGuestId?: InputMaybe<Scalars["String"]["input"]>;
  meetingUserIdUserId?: InputMaybe<Scalars["ID"]["input"]>;
  name: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationAddVotingRoomArgs = {
  clubId: Scalars["ID"]["input"];
  displayName: Scalars["String"]["input"];
  meetingId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationAdminBackfillOfficerProjectionArgs = {
  clubId?: InputMaybe<Scalars["Int"]["input"]>;
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The root mutation type */
export type MutationAdminCloseEasySpeakIdentityFlagsArgs = {
  flagIds: Array<Scalars["Long"]["input"]>;
  resolution: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationAdminDeleteNudgeArgs = {
  expectedVersion: Scalars["Int"]["input"];
  id: Scalars["Long"]["input"];
};

/** The root mutation type */
export type MutationAdminIssueDebugRepairApprovalArgs = {
  planId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationAdminMintAgentTokenArgs = {
  label?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationAdminMintEasySpeakCaptureTokenArgs = {
  instance: Scalars["String"]["input"];
  label?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationAdminRequeueMutationOutboxRowsArgs = {
  ids: Array<Scalars["Long"]["input"]>;
};

/** The root mutation type */
export type MutationAdminRevokeAgentTokenArgs = {
  id: Scalars["Long"]["input"];
};

/** The root mutation type */
export type MutationAdminRevokeEasySpeakCaptureTokenArgs = {
  id: Scalars["Long"]["input"];
};

/** The root mutation type */
export type MutationAdminRunEasySpeakAutoStageArgs = {
  clubIds?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  instance?: InputMaybe<Scalars["String"]["input"]>;
  maxClubs?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root mutation type */
export type MutationAdminSaveNudgeArgs = {
  expectedVersion?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["Long"]["input"]>;
  input: AdminNudgeInput;
};

/** The root mutation type */
export type MutationAdminSendClubEmailsArgs = {
  clubIds: Array<Scalars["Long"]["input"]>;
  emailBodyMarkdown: Scalars["String"]["input"];
  emailSubject: Scalars["String"]["input"];
  fromAccountId: Scalars["String"]["input"];
  isTest: Scalars["Boolean"]["input"];
  recipientTypes: Array<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationAdminSetNudgeEnabledArgs = {
  enabled: Scalars["Boolean"]["input"];
  id: Scalars["Long"]["input"];
};

/** The root mutation type */
export type MutationAdminStartEasySpeakArchiveImportArgs = {
  clubId: Scalars["Int"]["input"];
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  easySpeakClubId: Scalars["Int"]["input"];
  instance: Scalars["String"]["input"];
  maxDate?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationApplyCotCrossDistrictHandoffArgs = {
  eventId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationApproveRoleRequestArgs = {
  agendaItemId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  personalNote?: InputMaybe<Scalars["String"]["input"]>;
  requestId: Scalars["String"]["input"];
  sendEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
  targetAgendaItemId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationAssignDistrictOfficerArgs = {
  districtId: Scalars["ID"]["input"];
  isSenior: Scalars["Boolean"]["input"];
  memberName: Scalars["String"]["input"];
  membershipId: Scalars["String"]["input"];
  roleName: Scalars["String"]["input"];
  userId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationAssignOfficerArgs = {
  clubId: Scalars["ID"]["input"];
  memberName: Scalars["String"]["input"];
  membershipId: Scalars["String"]["input"];
  roleName: Scalars["String"]["input"];
  userId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationAssignProjectToAgendaItemArgs = {
  agendaItemId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  projectId?: InputMaybe<Scalars["String"]["input"]>;
  requestId?: InputMaybe<Scalars["String"]["input"]>;
  speechTitle?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationBulkMarkMeetingAttendanceArgs = {
  clubId: Scalars["ID"]["input"];
  marks: Array<AttendanceMarkInput>;
  meetingId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationCancelCotEventArgs = {
  eventId: Scalars["ID"]["input"];
  reason: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationCancelCotRegistrationArgs = {
  eventId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationCancelMeetingArgs = {
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationCancelMyRoleAssignmentArgs = {
  agendaItemId: Scalars["String"]["input"];
  baseVersion?: InputMaybe<Scalars["Long"]["input"]>;
  clubId: Scalars["ID"]["input"];
  markNotAttending: Scalars["Boolean"]["input"];
  meetingId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationCancelOwnProjectRequestArgs = {
  clubId: Scalars["ID"]["input"];
  requestId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationCancelOwnScheduledProjectRequestArgs = {
  clubId: Scalars["ID"]["input"];
  requestId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationCancelProjectRequestArgs = {
  clubId: Scalars["ID"]["input"];
  requestId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationCancelRoleRequestArgs = {
  agendaItemId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  requestId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationCancelScheduledProjectRequestArgs = {
  clubId: Scalars["ID"]["input"];
  requestId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationClearCotOfficerNotOfficerMarkArgs = {
  cotId: Scalars["ID"]["input"];
  recordId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationClearCotRegistrationNotOfficerMarkArgs = {
  cotId: Scalars["ID"]["input"];
  email: Scalars["String"]["input"];
  eventId: Scalars["ID"]["input"];
  registrationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationClearMemberPaymentStatusArgs = {
  actionId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationConfirmPendingGuestbookSubmissionArgs = {
  clubId: Scalars["ID"]["input"];
  submissionId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationConfirmPendingMembershipApplicationArgs = {
  applicationId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationConvertOfficerSpeechRequestArgs = {
  agendaItemId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  projectId: Scalars["String"]["input"];
  speechTitle?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationCreateAgendaTemplateArgs = {
  agendaItems: Array<AgendaItemInput>;
  clubId: Scalars["ID"]["input"];
  description: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationCreateCotEventArgs = {
  cotId: Scalars["ID"]["input"];
  description: Scalars["String"]["input"];
  externalRegistration?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTest?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  publicLinkEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  registrationClosesAt?: InputMaybe<Scalars["String"]["input"]>;
  registrationOpensAt?: InputMaybe<Scalars["String"]["input"]>;
  requiredSessionCount?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root mutation type */
export type MutationCreateCotSessionArgs = {
  dateTime: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  duration: Scalars["Int"]["input"];
  eventId: Scalars["ID"]["input"];
  joiningUrl?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  maxAttendees?: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
  sessionType?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root mutation type */
export type MutationCreateClubLinkArgs = {
  clubId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationCreateMeetingArgs = {
  agendaTemplateId?: InputMaybe<Scalars["Long"]["input"]>;
  clubId: Scalars["ID"]["input"];
  date: Scalars["String"]["input"];
  locationMapLink?: InputMaybe<Scalars["String"]["input"]>;
  locationText?: InputMaybe<Scalars["String"]["input"]>;
  theme?: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
  wordOfDay?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationCreateMeetingUserArgs = {
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The root mutation type */
export type MutationCreateProjectRequestArgs = {
  clubId: Scalars["ID"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  notifyVpe?: InputMaybe<Scalars["Boolean"]["input"]>;
  preferredDates: Array<Scalars["String"]["input"]>;
  projectId?: InputMaybe<Scalars["String"]["input"]>;
  speechTitle?: InputMaybe<Scalars["String"]["input"]>;
  userId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationDeleteAgendaTemplateArgs = {
  clubId: Scalars["ID"]["input"];
  templateId: Scalars["Long"]["input"];
};

/** The root mutation type */
export type MutationDeleteCotAttendanceArgs = {
  attendanceRegistrationId?: InputMaybe<Scalars["ID"]["input"]>;
  email: Scalars["String"]["input"];
  sessionId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationDeleteCotEventArgs = {
  eventId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationDeleteCotSessionArgs = {
  sessionId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationDeleteClubImageArgs = {
  clubId: Scalars["ID"]["input"];
  imageName: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationDeleteClubLinkArgs = {
  clubId: Scalars["ID"]["input"];
  linkId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationDeleteMeetingArgs = {
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationDeleteVotingRoomArgs = {
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  votingRoomId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationEnrollMemberInPathwaysArgs = {
  clubId: Scalars["ID"]["input"];
  pathwayIds: Array<Scalars["Int"]["input"]>;
  userId: Scalars["Long"]["input"];
};

/** The root mutation type */
export type MutationFinishMeetingArgs = {
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationGuestUnsubscribeArgs = {
  removeId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationLinkCotRegistrationToOfficerArgs = {
  clubRoles: Array<CotOfficerClubRoleInput>;
  cotId: Scalars["ID"]["input"];
  createFromMember?: InputMaybe<Scalars["Boolean"]["input"]>;
  createNew: Scalars["Boolean"]["input"];
  email: Scalars["String"]["input"];
  eventId: Scalars["ID"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  registrationId?: InputMaybe<Scalars["String"]["input"]>;
  targetClubId?: InputMaybe<Scalars["ID"]["input"]>;
  targetOfficerEmail?: InputMaybe<Scalars["String"]["input"]>;
  targetOfficerRecordId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationLinkRoleParticipationArgs = {
  level: Scalars["Int"]["input"];
  participationId: Scalars["Long"]["input"];
  pathwayId: Scalars["Long"]["input"];
  roleName: Scalars["String"]["input"];
  targetUserId: Scalars["Long"]["input"];
};

/** The root mutation type */
export type MutationMarkCotAttendanceLiveArgs = {
  registrationEmails: Array<Scalars["String"]["input"]>;
  registrationIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  sessionId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationMarkEmailAddressWorkingArgs = {
  address: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationMarkMeetingAttendanceArgs = {
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  status?: InputMaybe<AttendanceStatus>;
  userId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationMarkMemberNotRenewingArgs = {
  actionId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationMarkMemberNotifiedAsPaidArgs = {
  actionId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationMarkMemberPaidArgs = {
  actionId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationOverrideCotOfficerRecordArgs = {
  correctedEmail?: InputMaybe<Scalars["String"]["input"]>;
  correctedMembershipNumber?: InputMaybe<Scalars["String"]["input"]>;
  correctedName?: InputMaybe<Scalars["String"]["input"]>;
  correctedUserId?: InputMaybe<Scalars["ID"]["input"]>;
  cotId: Scalars["ID"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  recordId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationPopulateDefaultAgendaArgs = {
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationPreviewRemindAllArgs = {
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationProposeRoleArgs = {
  agendaItemId: Scalars["ID"]["input"];
  clubId: Scalars["ID"]["input"];
  expiresAt?: InputMaybe<Scalars["String"]["input"]>;
  meetingId: Scalars["ID"]["input"];
  proposeeUserId: Scalars["ID"]["input"];
  slotIndex: Scalars["Int"]["input"];
};

/** The root mutation type */
export type MutationPublicMemberMarkAsPaidArgs = {
  actionId: Scalars["String"]["input"];
  clubShortName: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationPublicMemberNotRenewingArgs = {
  actionId: Scalars["String"]["input"];
  clubShortName: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationPublishCotEventArgs = {
  eventId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationRecordManualRoleCompletionArgs = {
  clubId: Scalars["ID"]["input"];
  level?: InputMaybe<Scalars["Int"]["input"]>;
  meetingDate: Scalars["String"]["input"];
  meetingId?: InputMaybe<Scalars["String"]["input"]>;
  pathwayId?: InputMaybe<Scalars["Int"]["input"]>;
  pathwayRoleName?: InputMaybe<Scalars["String"]["input"]>;
  roleName: Scalars["String"]["input"];
  userId: Scalars["Long"]["input"];
};

/** The root mutation type */
export type MutationRecordManualSpeechCompletionArgs = {
  clubId: Scalars["ID"]["input"];
  completedDate?: InputMaybe<Scalars["String"]["input"]>;
  level: Scalars["Int"]["input"];
  pathwayId: Scalars["Int"]["input"];
  projectId: Scalars["String"]["input"];
  speechTitle: Scalars["String"]["input"];
  userId: Scalars["Long"]["input"];
};

/** The root mutation type */
export type MutationRecordNonSpeechCompletionArgs = {
  clubId: Scalars["ID"]["input"];
  completedDate?: InputMaybe<Scalars["String"]["input"]>;
  level: Scalars["Int"]["input"];
  pathwayId: Scalars["Int"]["input"];
  projectId: Scalars["String"]["input"];
  userId: Scalars["Long"]["input"];
};

/** The root mutation type */
export type MutationRefreshCotCompletionStatusArgs = {
  cotId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationRefreshDistrictDataArgs = {
  districtId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationRegisterForCotEventArgs = {
  attendanceConfirmation?: InputMaybe<Scalars["Boolean"]["input"]>;
  creditEarned?: InputMaybe<Scalars["Boolean"]["input"]>;
  eventId: Scalars["ID"]["input"];
  externalAttendee?: InputMaybe<ExternalAttendeeInput>;
  joinWaitlist?: InputMaybe<Scalars["Boolean"]["input"]>;
  reminder24hBefore?: InputMaybe<Scalars["Boolean"]["input"]>;
  seekingCreditForRoles?: InputMaybe<Array<CotOfficerClubRoleInput>>;
};

/** The root mutation type */
export type MutationRegisterGuestArgs = {
  clubShortName: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  formId: Scalars["String"]["input"];
  foundUsInfo: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationReinstateMeetingArgs = {
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationRejectRoleRequestArgs = {
  agendaItemId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
  requestId: Scalars["String"]["input"];
  sendEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The root mutation type */
export type MutationRemoveAssertedClubRoleArgs = {
  clubId: Scalars["ID"]["input"];
  role: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationRemoveCotEventHostArgs = {
  eventId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationRemoveCotManualTrainingCreditArgs = {
  cotId: Scalars["ID"]["input"];
  creditId: Scalars["ID"]["input"];
  recordId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationRemoveCandidateArgs = {
  candidateId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  votingRoomId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationRemoveDistrictOfficerArgs = {
  districtId: Scalars["ID"]["input"];
  role: Scalars["String"]["input"];
  userId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationRemoveFeedbackSubjectArgs = {
  clubId: Scalars["ID"]["input"];
  feedbackSessionId: Scalars["String"]["input"];
  meetingId: Scalars["ID"]["input"];
  subjectId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationRemoveGuestArgs = {
  actionId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationRemoveMemberArgs = {
  actionId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationRemoveMemberPathwayEnrollmentArgs = {
  clubId: Scalars["ID"]["input"];
  pathwayId: Scalars["Int"]["input"];
  userId: Scalars["Long"]["input"];
};

/** The root mutation type */
export type MutationRemoveOfficerArgs = {
  clubId: Scalars["ID"]["input"];
  officerId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationRemoveProjectRequestArgs = {
  clubId: Scalars["ID"]["input"];
  requestId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationRemoveSpeechCompletionArgs = {
  completionId: Scalars["Long"]["input"];
};

/** The root mutation type */
export type MutationRenameVotingRoomArgs = {
  clubId: Scalars["ID"]["input"];
  displayName: Scalars["String"]["input"];
  meetingId: Scalars["ID"]["input"];
  votingRoomId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationReorderCandidatesArgs = {
  candidateIds: Array<Scalars["String"]["input"]>;
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  votingRoomId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationReorderClubLinksArgs = {
  clubId: Scalars["ID"]["input"];
  linkIds: Array<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationRequestRoleArgs = {
  agendaItemId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationResendCotRegistrationVerificationArgs = {
  email: Scalars["String"]["input"];
  eventId: Scalars["ID"]["input"];
  registrationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationResendGuestWelcomeEmailArgs = {
  actionId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationResendPendingGuestbookVerificationArgs = {
  clubId: Scalars["ID"]["input"];
  submissionId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationResendPendingMembershipVerificationArgs = {
  applicationId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationRespondToRoleProposalArgs = {
  accept: Scalars["Boolean"]["input"];
  proposalId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationRetryRoleProposalSendArgs = {
  proposalId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationRevertMeetingToDraftArgs = {
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationRevertMeetingToInProgressArgs = {
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationSaveClubFinanceConfigArgs = {
  clubId: Scalars["ID"]["input"];
  config: ClubFinanceConfigInput;
};

/** The root mutation type */
export type MutationScheduleMeetingArgs = {
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationSendAllPaymentRemindersArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationSendCotBroadcastArgs = {
  audience: CotBroadcastAudienceInput;
  bodyTemplate: Scalars["String"]["input"];
  eventId: Scalars["ID"]["input"];
  subject: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationSendCotBroadcastTestArgs = {
  bodyTemplate: Scalars["String"]["input"];
  eventId: Scalars["ID"]["input"];
  subject: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationSendGuestbookEmailArgs = {
  clubId: Scalars["ID"]["input"];
  emailBody: Scalars["String"]["input"];
  toWhom: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationSendPaymentReminderArgs = {
  actionId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationSendRemindAllArgs = {
  body: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  subject: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationSetCotManualRoleAssignmentsArgs = {
  cotId: Scalars["ID"]["input"];
  expectedAssignmentToken: Scalars["String"]["input"];
  recordId: Scalars["ID"]["input"];
  roleAssignments: Array<CotManualRoleAssignmentInput>;
};

/** The root mutation type */
export type MutationSetCotOfficerNotOfficerMarkArgs = {
  cotId: Scalars["ID"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  reason: CotNotOfficerReason;
  recordId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationSetCotRegistrationNotOfficerMarkArgs = {
  alsoMark?: InputMaybe<Array<CotRegistrationTargetInput>>;
  cotId: Scalars["ID"]["input"];
  email: Scalars["String"]["input"];
  eventId: Scalars["ID"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  reason: CotNotOfficerReason;
  registrationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationSetClubEasySpeakMappingArgs = {
  clubId: Scalars["ID"]["input"];
  easyspeakId?: InputMaybe<Scalars["Int"]["input"]>;
  easyspeakInstance?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationSetClubFinanceOpeningBalanceArgs = {
  amountMinor: Scalars["Long"]["input"];
  clubId: Scalars["ID"]["input"];
  effectiveOn: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationSetDefaultAgendaTemplateArgs = {
  clubId: Scalars["ID"]["input"];
  templateId: Scalars["Long"]["input"];
};

/** The root mutation type */
export type MutationSetFeedbackSessionStatusArgs = {
  clubId: Scalars["ID"]["input"];
  feedbackSessionId: Scalars["String"]["input"];
  isOpen: Scalars["Boolean"]["input"];
  meetingId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationSetMemberMeetingRsvpArgs = {
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  status?: InputMaybe<RsvpStatus>;
  userId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationSetMyMeetingRsvpArgs = {
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  status: RsvpStatus;
};

/** The root mutation type */
export type MutationSetVotingRoomStatusArgs = {
  clubId: Scalars["ID"]["input"];
  isOpen: Scalars["Boolean"]["input"];
  meetingId: Scalars["ID"]["input"];
  votingRoomId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationStartMeetingArgs = {
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationSubmitFeedbackArgs = {
  aspects?: InputMaybe<Array<Scalars["String"]["input"]>>;
  clubId: Scalars["ID"]["input"];
  content: Scalars["String"]["input"];
  feedbackSessionId: Scalars["String"]["input"];
  fromAttendeeGuestId?: InputMaybe<Scalars["String"]["input"]>;
  fromAttendeeUserId?: InputMaybe<Scalars["ID"]["input"]>;
  isAnonymous?: InputMaybe<Scalars["Boolean"]["input"]>;
  meetingId: Scalars["ID"]["input"];
  subjectId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationSubmitNewMemberFormArgs = {
  clubShortName: Scalars["String"]["input"];
  data: NewMemberFormInput;
};

/** The root mutation type */
export type MutationSubmitVoteArgs = {
  candidateId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  meetingUserIdGuestId?: InputMaybe<Scalars["String"]["input"]>;
  meetingUserIdUserId?: InputMaybe<Scalars["ID"]["input"]>;
  votingRoomId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationTestEmailConfigurationArgs = {
  clubId: Scalars["ID"]["input"];
  emailConfig: EmailConfigInput;
};

/** The root mutation type */
export type MutationTriggerPeriodicEmailArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationUnlinkRoleParticipationArgs = {
  completionId: Scalars["Long"]["input"];
};

/** The root mutation type */
export type MutationUnmarkCotAttendanceLiveArgs = {
  registrationEmails: Array<Scalars["String"]["input"]>;
  registrationIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  sessionId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationUnmergeCotOfficerRecordArgs = {
  cotId: Scalars["ID"]["input"];
  mergedFromEmail: Scalars["String"]["input"];
  recordId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationUnpublishCotEventArgs = {
  eventId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationUpdateAgendaTemplateArgs = {
  agendaItems: Array<AgendaItemInput>;
  clubId: Scalars["ID"]["input"];
  description: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  templateId: Scalars["Long"]["input"];
};

/** The root mutation type */
export type MutationUpdateCotAttendanceArgs = {
  attendanceRegistrationId?: InputMaybe<Scalars["ID"]["input"]>;
  club?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  joinTime?: InputMaybe<Scalars["String"]["input"]>;
  leaveTime?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  originalEmail: Scalars["String"]["input"];
  registrationId?: InputMaybe<Scalars["ID"]["input"]>;
  role?: InputMaybe<Scalars["String"]["input"]>;
  sessionId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationUpdateCotEventArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  eventId: Scalars["ID"]["input"];
  externalRegistration?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  publicLinkEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  registrationClosesAt?: InputMaybe<Scalars["String"]["input"]>;
  registrationOpensAt?: InputMaybe<Scalars["String"]["input"]>;
  requiredSessionCount?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root mutation type */
export type MutationUpdateCotOfficerClubRolesArgs = {
  clubRoles: Array<CotOfficerClubRoleInput>;
  cotId: Scalars["ID"]["input"];
  expectedClubRolesToken: Scalars["String"]["input"];
  recordId: Scalars["ID"]["input"];
};

/** The root mutation type */
export type MutationUpdateCotSessionArgs = {
  dateTime?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  duration?: InputMaybe<Scalars["Int"]["input"]>;
  joiningUrl?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  maxAttendees?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sessionId: Scalars["ID"]["input"];
  sessionType?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root mutation type */
export type MutationUpdateCandidateArgs = {
  candidateId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  meetingUserIdGuestId?: InputMaybe<Scalars["String"]["input"]>;
  meetingUserIdUserId?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  votingRoomId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationUpdateClubConfigArgs = {
  clubId: Scalars["ID"]["input"];
  contactEmail?: InputMaybe<Scalars["String"]["input"]>;
  longName?: InputMaybe<Scalars["String"]["input"]>;
  meetingConfig?: InputMaybe<ClubMeetingConfigInput>;
  meetingSchedule?: InputMaybe<MeetingScheduleInput>;
  periodicEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
  shortName?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationUpdateClubEducationConfigArgs = {
  clubId: Scalars["ID"]["input"];
  hiddenRoleHistoryRoleTypes: Array<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationUpdateClubLinkArgs = {
  clubId: Scalars["ID"]["input"];
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  linkId: Scalars["String"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Scalars["Int"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationUpdateDistrictConfigArgs = {
  calendarEnabled: Scalars["Boolean"]["input"];
  contactEmail: Scalars["String"]["input"];
  districtId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationUpdateEmailConfigurationArgs = {
  clubId: Scalars["ID"]["input"];
  emailConfig: EmailConfigInput;
};

/** The root mutation type */
export type MutationUpdateFeedbackSubjectArgs = {
  clubId: Scalars["ID"]["input"];
  feedbackSessionId: Scalars["String"]["input"];
  meetingId: Scalars["ID"]["input"];
  meetingUserIdGuestId?: InputMaybe<Scalars["String"]["input"]>;
  meetingUserIdUserId?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  subjectId: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationUpdateGuestbookConfigArgs = {
  clubId: Scalars["ID"]["input"];
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  firstEmailBody?: InputMaybe<Scalars["String"]["input"]>;
  reminderEmailBody?: InputMaybe<Scalars["String"]["input"]>;
  returningGuestEmailBody?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationUpdateMeetingAgendaArgs = {
  agenda: Array<AgendaItemInput>;
  baseVersion?: InputMaybe<Scalars["Long"]["input"]>;
  clubId: Scalars["ID"]["input"];
  emailOptions?: InputMaybe<EmailControlOptionsInput>;
  meetingId: Scalars["ID"]["input"];
  sourceAgendaTemplateId?: InputMaybe<Scalars["Long"]["input"]>;
};

/** The root mutation type */
export type MutationUpdateMeetingAgendaOpsArgs = {
  clubId: Scalars["ID"]["input"];
  emailOptions?: InputMaybe<EmailControlOptionsInput>;
  meetingId: Scalars["ID"]["input"];
  ops: Array<AgendaOpInput>;
};

/** The root mutation type */
export type MutationUpdateMeetingDetailsArgs = {
  baseVersion?: InputMaybe<Scalars["Long"]["input"]>;
  clubId: Scalars["ID"]["input"];
  datetime?: InputMaybe<Scalars["String"]["input"]>;
  locationMapLink?: InputMaybe<Scalars["String"]["input"]>;
  locationText?: InputMaybe<Scalars["String"]["input"]>;
  meetingId: Scalars["ID"]["input"];
  theme?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  wordOfDay?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationUpdateMembershipConfigArgs = {
  clubId: Scalars["ID"]["input"];
  config: MembershipConfigInput;
  expected?: InputMaybe<MembershipConfigInput>;
};

/** The root mutation type */
export type MutationUpdateNotificationPreferencesArgs = {
  clubId: Scalars["ID"]["input"];
  copyInboxOnGuest?: InputMaybe<Scalars["Boolean"]["input"]>;
  copyInboxOnMeetingRole?: InputMaybe<Scalars["Boolean"]["input"]>;
  copyInboxOnMembership?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The root mutation type */
export type MutationUpdateProjectRequestArgs = {
  clearProjectLink?: InputMaybe<Scalars["Boolean"]["input"]>;
  clubId: Scalars["ID"]["input"];
  notifyVpe?: InputMaybe<Scalars["Boolean"]["input"]>;
  preferredDates?: InputMaybe<Array<Scalars["String"]["input"]>>;
  projectId?: InputMaybe<Scalars["String"]["input"]>;
  requestId: Scalars["String"]["input"];
  speechTitle?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationUpdateSpeechCompletionArgs = {
  clearProjectLink?: InputMaybe<Scalars["Boolean"]["input"]>;
  clearSpeechTitle?: InputMaybe<Scalars["Boolean"]["input"]>;
  completionId: Scalars["Long"]["input"];
  confirmationToken?: InputMaybe<Scalars["String"]["input"]>;
  projectId?: InputMaybe<Scalars["String"]["input"]>;
  speechTitle?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationUpdateSpeechSettingsArgs = {
  clearProjectLink?: InputMaybe<Scalars["Boolean"]["input"]>;
  clubId: Scalars["ID"]["input"];
  projectId?: InputMaybe<Scalars["String"]["input"]>;
  speechId: Scalars["ID"]["input"];
  speechTitle?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationUpdateUserEnrollmentsArgs = {
  pathwayIds: Array<Scalars["Int"]["input"]>;
};

/** The root mutation type */
export type MutationUpdateWebConfigArgs = {
  backgroundImage?: InputMaybe<Scalars["String"]["input"]>;
  clubId: Scalars["ID"]["input"];
  clubUrl?: InputMaybe<Scalars["String"]["input"]>;
  domainName?: InputMaybe<Scalars["String"]["input"]>;
  eventbriteLink?: InputMaybe<Scalars["String"]["input"]>;
  facebookLink?: InputMaybe<Scalars["String"]["input"]>;
  hostingOption?: InputMaybe<HostingOptionInput>;
  instagramLink?: InputMaybe<Scalars["String"]["input"]>;
  introductionText?: InputMaybe<Scalars["String"]["input"]>;
  linkedInLink?: InputMaybe<Scalars["String"]["input"]>;
  locationShortDesc?: InputMaybe<Scalars["String"]["input"]>;
  logoImage?: InputMaybe<Scalars["String"]["input"]>;
  mapLink?: InputMaybe<Scalars["String"]["input"]>;
  meetingTimes?: InputMaybe<Scalars["String"]["input"]>;
  meetupLink?: InputMaybe<Scalars["String"]["input"]>;
  metaDesc?: InputMaybe<Scalars["String"]["input"]>;
  tagLine?: InputMaybe<Scalars["String"]["input"]>;
  twitterLink?: InputMaybe<Scalars["String"]["input"]>;
  youtubeLink?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root mutation type */
export type MutationVerifyCotRegistrationArgs = {
  eventId: Scalars["ID"]["input"];
  token: Scalars["String"]["input"];
};

/** The root mutation type */
export type MutationWithdrawRoleProposalArgs = {
  proposalId: Scalars["ID"]["input"];
};

export type NewMemberApplicationDetails = {
  __typename: "NewMemberApplicationDetails";
  addressLine1: Scalars["String"]["output"];
  addressLine2: Scalars["String"]["output"];
  attentionCareOf: Scalars["String"]["output"];
  city: Scalars["String"]["output"];
  contactByEmail: Scalars["Boolean"]["output"];
  contactByMail: Scalars["Boolean"]["output"];
  contactByPhone: Scalars["Boolean"]["output"];
  country: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  gender: Scalars["String"]["output"];
  homePhone: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  middleName?: Maybe<Scalars["String"]["output"]>;
  mobilePhone: Scalars["String"]["output"];
  newMemberType: Scalars["String"]["output"];
  postcode: Scalars["String"]["output"];
  previousMembershipDetails?: Maybe<Scalars["String"]["output"]>;
  releaseAccepted: Scalars["Boolean"]["output"];
  toastmastersPromiseAccepted: Scalars["Boolean"]["output"];
};

/** Information for the new member registration form */
export type NewMemberFormInfo = {
  __typename: "NewMemberFormInfo";
  allowNewMembers: Scalars["Boolean"]["output"];
  clubContactEmail: Scalars["String"]["output"];
  clubLongName: Scalars["String"]["output"];
  clubShortName: Scalars["String"]["output"];
  monthlyClubFee: Scalars["String"]["output"];
  newMemberFee: Scalars["String"]["output"];
  newMemberTypes: Array<NewMemberTypeOption>;
  totalJoiningFee: Scalars["String"]["output"];
};

/** New member registration form data */
export type NewMemberFormInput = {
  addressLine1: Scalars["String"]["input"];
  addressLine2?: InputMaybe<Scalars["String"]["input"]>;
  attentionCareOf?: InputMaybe<Scalars["String"]["input"]>;
  city: Scalars["String"]["input"];
  contactByEmail: Scalars["Boolean"]["input"];
  contactByMail: Scalars["Boolean"]["input"];
  contactByPhone: Scalars["Boolean"]["input"];
  country: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  gender: Scalars["String"]["input"];
  homePhone?: InputMaybe<Scalars["String"]["input"]>;
  lastName: Scalars["String"]["input"];
  middleName?: InputMaybe<Scalars["String"]["input"]>;
  mobilePhone: Scalars["String"]["input"];
  newMemberType: Scalars["String"]["input"];
  postcode: Scalars["String"]["input"];
  previousMembershipDetails?: InputMaybe<Scalars["String"]["input"]>;
  releaseAccepted: Scalars["Boolean"]["input"];
  toastmastersPromiseAccepted: Scalars["Boolean"]["input"];
};

/** Response from new member registration */
export type NewMemberResponse = {
  __typename: "NewMemberResponse";
  actionId?: Maybe<Scalars["String"]["output"]>;
  allowCardPayments?: Maybe<Scalars["Boolean"]["output"]>;
  emailAddress?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

/** Option for new member type selection */
export type NewMemberTypeOption = {
  __typename: "NewMemberTypeOption";
  title: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

/** Per-registration notification channel toggles */
export type NotificationPrefs = {
  __typename: "NotificationPrefs";
  attendanceConfirmation: Scalars["Boolean"]["output"];
  creditEarned: Scalars["Boolean"]["output"];
  reminder24hBefore: Scalars["Boolean"]["output"];
};

/** A suggestion for club improvement */
export type NudgeSuggestion = {
  __typename: "NudgeSuggestion";
  /** Category of the suggestion */
  category: Scalars["String"]["output"];
  /** The suggestion message */
  message: Scalars["String"]["output"];
  /** Urgency level (1-5) */
  urgency: Scalars["Int"]["output"];
};

/** Officer-scoped view of a COT event — excludes other attendees' registration data */
export type OfficerCotEventInfo = {
  __typename: "OfficerCOTEventInfo";
  /** Why the district cancelled the event (#2640). The same sentence the deregistration email carried, which is why a former registrant can still read this event at all */
  cancellationReason?: Maybe<Scalars["String"]["output"]>;
  /** ISO-8601 timestamp when the district cancelled the event (#2640). Null unless CANCELLED */
  cancelledAt?: Maybe<Scalars["String"]["output"]>;
  description: Scalars["String"]["output"];
  /** District that owns this event's COT round (drives the district-scoped page URL) */
  districtId: Scalars["String"]["output"];
  externalRegistration: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  /** A test event (#5598): shown only to senior officers, and earns no credit */
  isTest: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  programId: Scalars["ID"]["output"];
  publishStatus: CotEventPublishStatus;
  registrationClosesAt?: Maybe<Scalars["String"]["output"]>;
  registrationOpensAt?: Maybe<Scalars["String"]["output"]>;
  requiredSessionCount: Scalars["Int"]["output"];
  /** True when the requester is an admin or a senior officer of this event's district (#2720). The event page is open to any district officer, so surfaces backed by a senior-only mutation — currently the cross-district credit handoff — need this to hide rather than fail. */
  viewerIsSeniorOfficer: Scalars["Boolean"]["output"];
};

/** A COT event paired with the requesting officer's own registration (Phase 1C) */
export type OfficerCotEventView = {
  __typename: "OfficerCOTEventView";
  event: OfficerCotEventInfo;
  /** True when every event is at capacity for the current registration count — registration is unavailable (#1715) */
  isFull: Scalars["Boolean"]["output"];
  /** True when the requester holds an active seat — not cancelled, not pending, and not merely waitlisted (#1740) */
  isRegistered: Scalars["Boolean"]["output"];
  /** True when publishStatus == Published, now is within the registration window, and the event's sessions have not all finished (#2639) */
  isRegistrationOpenNow: Scalars["Boolean"]["output"];
  /** True when the requester is currently on the waitlist (#1740) */
  isWaitlisted: Scalars["Boolean"]["output"];
  /** The requesting officer's club-officer roles — their live club positions merged with the roles they've self-asserted on the district COT page (#2026). Drives the register screen's credit-role options. Resolved lazily — only computed when selected. */
  knownClubRoles: Array<CotOfficerClubRole>;
  myRegistration?: Maybe<CotEventRegistration>;
  /** Active (non-cancelled) registrations on the session — drives per-event capacity (#1715) */
  registeredCount: Scalars["Int"]["output"];
  sessions: Array<CotSession>;
  /** Time state rolled up from the event's sessions (#2639). Null when the event has no sessions scheduled — that is not 'Scheduled', and clients must render it as its own state. */
  timeState?: Maybe<CotTimeState>;
  /** Registrants currently on the waitlist for this full session (#1740) */
  waitlistCount: Scalars["Int"]["output"];
  /** The requester's 1-based position in the FIFO waitlist, or null when not waiting (#1740) */
  waitlistPosition?: Maybe<Scalars["Int"]["output"]>;
};

/** Result of a Officer mutation */
export type OfficerResult = {
  __typename: "OfficerResult";
  /** The Officer data if successful */
  data?: Maybe<ClubOfficer>;
  /** Machine-readable code identifying the failure outcome */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable result message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Whether the mutation succeeded */
  success: Scalars["Boolean"]["output"];
};

/** Dashboard overview data with all district summaries */
export type OverviewDashboardData = {
  __typename: "OverviewDashboardData";
  asOfDate: Scalars["String"]["output"];
  districts: Array<OverviewDistrictSummary>;
  totalActiveClubs: Scalars["Int"]["output"];
  totalDistricts: Scalars["Int"]["output"];
};

/** District summary in dashboard overview */
export type OverviewDistrictSummary = {
  __typename: "OverviewDistrictSummary";
  activeClubs: Scalars["Int"]["output"];
  asOfDate: Scalars["String"]["output"];
  district: Scalars["String"]["output"];
  paidClubs: Scalars["Int"]["output"];
  programYear: Scalars["Int"]["output"];
  region: Scalars["String"]["output"];
  totalYtdPayments: Scalars["Int"]["output"];
};

/** Pagination metadata following the Relay Connection specification */
export type PageInfo = {
  __typename: "PageInfo";
  /** Cursor of the last edge */
  endCursor?: Maybe<Scalars["String"]["output"]>;
  /** Whether there are more items after the last edge */
  hasNextPage: Scalars["Boolean"]["output"];
  /** Whether there are more items before the first edge */
  hasPreviousPage: Scalars["Boolean"]["output"];
  /** Cursor of the first edge */
  startCursor?: Maybe<Scalars["String"]["output"]>;
};

/** Category of participation */
export enum ParticipationCategory {
  /** Education series participation */
  EducationSeries = "EDUCATION_SERIES",
  /** General participation not linked to pathway */
  General = "GENERAL",
  /** Participation linked to pathway project */
  PathwayLinked = "PATHWAY_LINKED",
}

/** How the participation was recorded */
export enum ParticipationCreditSource {
  /** Automatically recorded when meeting completed */
  AutoFinish = "AUTO_FINISH",
  /** Backfilled from historical data */
  Backfill = "BACKFILL",
  /** Imported from EasySpeak */
  EasyspeakImport = "EASYSPEAK_IMPORT",
  /** Manually entered by user */
  ManualEntry = "MANUAL_ENTRY",
  /** Manually entered by club officer */
  ManualOfficerEntry = "MANUAL_OFFICER_ENTRY",
}

/** Type of meeting participation */
export enum ParticipationType {
  /** Filling a meeting role */
  Role = "ROLE",
  /** Delivering a speech */
  Speech = "SPEECH",
  /** Delivering a Table Topics impromptu speech */
  TableTopics = "TABLE_TOPICS",
}

/** A Toastmasters education pathway */
export type Pathway = {
  __typename: "Pathway";
  /** Pathway description */
  description: Scalars["String"]["output"];
  /** Unique pathway identifier */
  id: Scalars["ID"]["output"];
  /** Whether pathway is available for enrollment */
  isActive: Scalars["Boolean"]["output"];
  /** Requirements for each level */
  levelRequirements: Array<LevelRequirement>;
  /** Pathway name */
  name: Scalars["String"]["output"];
  /** Human-readable pathway code */
  pathwayCode: Scalars["String"]["output"];
  /** Projects within this pathway */
  projects: Array<PathwayProject>;
};

/** A member's pathway progress for the club chart */
export type PathwayChartRow = {
  __typename: "PathwayChartRow";
  /** Pathway completion date */
  completedDate?: Maybe<Scalars["String"]["output"]>;
  /** Number of recorded completions on this enrollment (0 means the enrollment can be removed) */
  completionCount: Scalars["Int"]["output"];
  /** Current level */
  currentLevel: Scalars["Int"]["output"];
  /** Enrollment date */
  enrolledDate: Scalars["String"]["output"];
  /** Date of last speech */
  lastSpokeDate?: Maybe<Scalars["String"]["output"]>;
  /** Progress on each level */
  levels: Array<LevelProgress>;
  /** Member's user ID */
  memberId: Scalars["ID"]["output"];
  /** Member's display name */
  memberName: Scalars["String"]["output"];
  /** Pathway ID */
  pathwayId: Scalars["Int"]["output"];
  /** Pathway name */
  pathwayName: Scalars["String"]["output"];
  /** Number of pending speech requests */
  pendingRequestCount: Scalars["Int"]["output"];
};

/** A record of a completed pathway activity */
export type PathwayCompletionRecord = {
  __typename: "PathwayCompletionRecord";
  /** Club where completion occurred */
  clubId: Scalars["ID"]["output"];
  /** Date and time completed */
  completedDate: Scalars["String"]["output"];
  /** Type of completion */
  completionType: CompletionType;
  /** Completion record ID */
  id?: Maybe<Scalars["ID"]["output"]>;
  /** Level number */
  level: Scalars["Int"]["output"];
  /** Meeting ID if applicable */
  meetingId?: Maybe<Scalars["ID"]["output"]>;
  /** Additional notes */
  notes?: Maybe<Scalars["String"]["output"]>;
  /** The pathway details */
  pathway?: Maybe<Pathway>;
  /** Pathway ID */
  pathwayId: Scalars["Int"]["output"];
  /** The project details if applicable */
  project?: Maybe<PathwayProject>;
  /** Project ID if applicable */
  projectId?: Maybe<Scalars["String"]["output"]>;
  /** Role name if applicable */
  roleName?: Maybe<Scalars["String"]["output"]>;
  /** Role type if applicable */
  roleType?: Maybe<Scalars["String"]["output"]>;
  /** Speech title, as the speech is called now rather than as it was credited */
  speechTitle?: Maybe<Scalars["String"]["output"]>;
  /** User who completed the activity */
  userId: Scalars["ID"]["output"];
};

/** A compact reference to a pathway completion record linked to a meeting participation */
export type PathwayCompletionRecordRef = {
  __typename: "PathwayCompletionRecordRef";
  /** Completion record ID */
  completionId: Scalars["Long"]["output"];
  /** Pathway level */
  level: Scalars["Int"]["output"];
  /** Linked meeting ID */
  meetingId?: Maybe<Scalars["String"]["output"]>;
  /** Pathway ID */
  pathwayId: Scalars["Long"]["output"];
  /** Normalized role key */
  roleKey: Scalars["String"]["output"];
  /** Role display name */
  roleName: Scalars["String"]["output"];
};

/** A project within a Toastmasters pathway */
export type PathwayProject = {
  __typename: "PathwayProject";
  /** Meeting agenda summary */
  agendaSummary?: Maybe<Scalars["String"]["output"]>;
  /** Project description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Unique project identifier */
  id: Scalars["ID"]["output"];
  /** Pathway level (1-5) */
  level: Scalars["Int"]["output"];
  /** Project name */
  name: Scalars["String"]["output"];
  /** Objective identifier */
  objectiveId: Scalars["String"]["output"];
  /** Learning objectives */
  objectives?: Maybe<Scalars["String"]["output"]>;
  /** Official Toastmasters project ID */
  officialProjectId?: Maybe<Scalars["String"]["output"]>;
  /** Project overview */
  overview?: Maybe<Scalars["String"]["output"]>;
  /** Parent pathway ID */
  pathwayId: Scalars["Int"]["output"];
  /** Type of project */
  projectType: ProjectType;
  /** Display ordering */
  sortOrder: Scalars["Int"]["output"];
  /** Speech timing limits */
  speechTimings?: Maybe<SpeechTimings>;
};

/** Per-role completion count for a pathway level */
export type PathwayRoleBreakdown = {
  __typename: "PathwayRoleBreakdown";
  /** How many times this user has performed this role at this level */
  count: Scalars["Int"]["output"];
  /** True if count >= requiredMinimum (always true when requiredMinimum is 0) */
  meetsMinimum: Scalars["Boolean"]["output"];
  /** Minimum required by requiredRoleQuotas (0 if no minimum applies) */
  requiredMinimum: Scalars["Int"]["output"];
  /** Display role name (raw, e.g., 'Table Topics Master') */
  roleName: Scalars["String"]["output"];
};

/** A single per-assignee pathway role target entry on an agenda item */
export type PathwayRoleTargetEntry = {
  __typename: "PathwayRoleTargetEntry";
  /** Target pathway level */
  level: Scalars["Int"]["output"];
  /** Target pathway ID */
  pathwayId: Scalars["Int"]["output"];
  /** Role requirement display name */
  roleName: Scalars["String"]["output"];
  /** Assignee user ID */
  userId: Scalars["Long"]["output"];
};

/** Input type for a single per-assignee pathway role target */
export type PathwayRoleTargetInput = {
  /** Target pathway level */
  level: Scalars["Int"]["input"];
  /** Target pathway ID */
  pathwayId: Scalars["Int"]["input"];
  /** Role requirement display name */
  roleName: Scalars["String"]["input"];
  /** Assignee user ID */
  userId: Scalars["Long"]["input"];
};

/** A staged, unverified public submission awaiting officer confirmation or self-verification */
export type PendingSubmission = {
  __typename: "PendingSubmission";
  /** Submitter email address */
  email: Scalars["String"]["output"];
  /** When the staged row is swept if unconfirmed (ISO-8601) */
  expiresAt: Scalars["String"]["output"];
  /** Opaque staged-row id, used to confirm or resend */
  id: Scalars["ID"]["output"];
  /** Submitter display name */
  name: Scalars["String"]["output"];
  /** When the submission was staged (ISO-8601) */
  submittedAt: Scalars["String"]["output"];
};

/** Preview of periodic email for a club */
export type PeriodicEmailPreview = {
  __typename: "PeriodicEmailPreview";
  clubId: Scalars["Int"]["output"];
  clubName: Scalars["String"]["output"];
  emailHtml: Scalars["String"]["output"];
};

/** Result of a ProjectRequest list mutation */
export type ProjectRequestListResult = {
  __typename: "ProjectRequestListResult";
  /** The ProjectRequest list data if successful */
  data?: Maybe<Array<ProjectSignupRequest>>;
  /** Machine-readable code identifying the failure outcome */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable result message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Whether the mutation succeeded */
  success: Scalars["Boolean"]["output"];
};

/** Result of a ProjectRequest mutation */
export type ProjectRequestResult = {
  __typename: "ProjectRequestResult";
  /** The ProjectRequest data if successful */
  data?: Maybe<ProjectSignupRequest>;
  /** Machine-readable code identifying the failure outcome */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable result message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Whether the mutation succeeded */
  success: Scalars["Boolean"]["output"];
};

/** User information snapshot for a project request */
export type ProjectRequestUser = {
  __typename: "ProjectRequestUser";
  /** Email address */
  email?: Maybe<Scalars["String"]["output"]>;
  /** First name */
  firstName: Scalars["String"]["output"];
  /** Last name */
  lastName: Scalars["String"]["output"];
  /** User ID */
  userId: Scalars["ID"]["output"];
};

/** A request to be scheduled for a speech/project */
export type ProjectSignupRequest = {
  __typename: "ProjectSignupRequest";
  /** When request was approved */
  approvedAt?: Maybe<Scalars["String"]["output"]>;
  /** Who approved the request */
  approvedBy?: Maybe<ProjectRequestUser>;
  /** Assigned meeting date/time */
  assignedMeetingDateTime?: Maybe<Scalars["String"]["output"]>;
  /** Assigned meeting ID */
  assignedMeetingId?: Maybe<Scalars["String"]["output"]>;
  /** Whether an officer raised this request on the member's behalf */
  createdByOfficer: Scalars["Boolean"]["output"];
  /** Whether there are dates not yet rejected */
  hasPendingDates: Scalars["Boolean"]["output"];
  /** Request ID */
  id: Scalars["ID"]["output"];
  /** Additional notes */
  notes?: Maybe<Scalars["String"]["output"]>;
  /** Preferred dates for the speech */
  preferredDates: Array<Scalars["String"]["output"]>;
  /** Selected project ID */
  projectId?: Maybe<Scalars["String"]["output"]>;
  /** Rejected dates */
  rejections: Array<DateRejection>;
  /** When request was made */
  requestedAt: Scalars["String"]["output"];
  /** User who requested */
  requestedBy: ProjectRequestUser;
  /** Whether the member may cancel this scheduled request now: its speech's meeting has passed, or the speech names no meeting that can be read. False for a request that is not scheduled */
  scheduledCancellable: Scalars["Boolean"]["output"];
  /** Speech title */
  speechTitle?: Maybe<Scalars["String"]["output"]>;
  /** Current request status */
  status: RequestStatus;
  /** Requesting user's ID */
  userId: Scalars["ID"]["output"];
};

/** Type of project within a pathway */
export enum ProjectType {
  /** Elective project */
  Elective = "ELECTIVE",
  /** Non-speech activity */
  NonSpeech = "NON_SPEECH",
  /** Required project for level completion */
  Required = "REQUIRED",
  /** Role-based activity */
  RoleActivity = "ROLE_ACTIVITY",
}

/** Public, unauthenticated view of a COT event for the registration page */
export type PublicCotEventInfo = {
  __typename: "PublicCOTEventInfo";
  description: Scalars["String"]["output"];
  /** District that owns this event's COT round (drives the district-scoped page URL) */
  districtId: Scalars["String"]["output"];
  externalRegistration: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  /** True when publishStatus == Published, now is within the registration window, and the event's sessions have not all finished (#2639) */
  isRegistrationOpenNow: Scalars["Boolean"]["output"];
  /** A test event (#5598): shown only to senior officers, and earns no credit */
  isTest: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  programId: Scalars["ID"]["output"];
  publicLinkEnabled: Scalars["Boolean"]["output"];
  publishStatus: CotEventPublishStatus;
  registrationClosesAt?: Maybe<Scalars["String"]["output"]>;
  registrationOpensAt?: Maybe<Scalars["String"]["output"]>;
  /** Time state rolled up from the event's sessions (#2639). Null when the event has no sessions scheduled. */
  timeState?: Maybe<CotTimeState>;
};

/** A published COT event with its sessions for the public district calendar */
export type PublicCotEventView = {
  __typename: "PublicCOTEventView";
  event: PublicCotEventInfo;
  /** True when every session is at capacity for the current registration count */
  isFull: Scalars["Boolean"]["output"];
  /** True when publishStatus == Published, now is within the registration window, and the event's sessions have not all finished (#2639) */
  isRegistrationOpenNow: Scalars["Boolean"]["output"];
  /** Active (non-cancelled) registrations on the event */
  registeredCount: Scalars["Int"]["output"];
  sessions: Array<PublicCotSession>;
  /** Time state rolled up from the event's sessions (#2639). Null when the event has no sessions scheduled. */
  timeState?: Maybe<CotTimeState>;
  /** Registrants currently on the waitlist for this full session (#1740) */
  waitlistCount: Scalars["Int"]["output"];
};

/** Public, unauthenticated view of a COT session for the district calendar */
export type PublicCotSession = {
  __typename: "PublicCOTSession";
  dateTime: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  duration: Scalars["Int"]["output"];
  durationDisplay: Scalars["String"]["output"];
  eventId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  /** True when the session has a joining URL (an online/remote option). A boolean, not the URL itself, so the public calendar can show in-person vs online without leaking it. */
  isOnline: Scalars["Boolean"]["output"];
  location?: Maybe<Scalars["String"]["output"]>;
  maxAttendees?: Maybe<Scalars["Int"]["output"]>;
  name: Scalars["String"]["output"];
  sessionType?: Maybe<Scalars["Int"]["output"]>;
  sessionTypeDisplay: Scalars["String"]["output"];
  /** Derived time state of this session (#2639) — Scheduled, In progress or Finished */
  timeState: CotTimeState;
};

/** Anonymous stats displayed on the public landing page */
export type PublicLandingStats = {
  __typename: "PublicLandingStats";
  /** Active paid clubs (excludes trial clubs) */
  activeClubs: Scalars["Int"]["output"];
  /** Total number of meetings organised */
  meetingsOrganised: Scalars["Int"]["output"];
  /** Total feedback submissions and votes cast */
  paperSlipsSaved: Scalars["Int"]["output"];
};

/** The root query type */
export type Query = {
  __typename: "Query";
  /** Get active paid members suitable for role assignment (requires officer access) */
  activePaidMembers: Array<ClubMember>;
  /**
   * Retired agent GraphQL token panel state: always disabled and empty (admin only)
   * @deprecated The agent token is retired (#6641). Removed with the agent_graphql_token table drop (#6637).
   */
  adminAgentTokens: AdminAgentTokenSettings;
  /** Get available system email accounts for sending (admin only) */
  adminAvailableEmailAccounts: Array<AdminEmailAccountInfo>;
  /** Browse all clubs with summary information (admin only) */
  adminBrowseClubs: Array<AdminClubBrowseItem>;
  /** Browse all items of a type as serialized JSON array (admin only) */
  adminBrowseGeneric: Scalars["String"]["output"];
  /** Browse all users with summary information (admin only) */
  adminBrowseUsers: Array<AdminUserBrowseItem>;
  /** Get full club detail as serialized JSON (admin only) */
  adminClubDetail?: Maybe<Scalars["String"]["output"]>;
  /** Get status of all clubs with features and subscription info (admin only) */
  adminClubStatus: Array<ClubStatus>;
  /** Clubs whose contactEmail names an account this node's contact-person index does not grant manager access (admin only). Omit clubId for the registry-wide check */
  adminContactManagerIndexCheck: AdminContactManagerIndexReport;
  /** A debug API repair plan awaiting approval, or null for an unknown id (admin only) */
  adminDebugRepairPlan?: Maybe<AdminDebugRepairPlan>;
  /** Get a single item detail as serialized JSON (admin only) */
  adminDetailGeneric?: Maybe<Scalars["String"]["output"]>;
  /** Which mapped clubs the EasySpeak auto-stage sweep would submit now, and which of the rest are up to date or would fail (admin only) */
  adminEasySpeakAutoStagePreview: AdminAutoStagePreview;
  /** EasySpeak capture configuration, per-instance progress and recent sessions (admin only) */
  adminEasySpeakCapture: AdminCaptureSettings;
  /** EasySpeak people an officer flagged or the migration left disputed, oldest flag first (admin only) */
  adminEasySpeakIdentityReview: Array<AdminEasySpeakIdentityReviewEntry>;
  /** Clubs with unsettled dual-run meetings, settlements changed since an officer chose, or contested mappings (admin only) */
  adminEasySpeakSupport: Array<AdminEasySpeakSupportClub>;
  /** Get paginated outbound email delivery logs with admin filters */
  adminEmailLog: AdminEmailLogPage;
  /** Backlog of post-commit effects the mutation outbox still owes (admin only). All zeros in steady state - a non-zero pending that does not fall across drain ticks, or any failed, means a committed decision's effects are unsettled. Unsettled is not proof that nothing ran: an effect guarded by a durable delivery claim can have happened and then failed to record it, which is what adminReconcileMutationOutboxDelivery resolves */
  adminMutationOutbox: AdminMutationOutbox;
  /** Every club-dashboard nudge rule, highest priority first, disabled rules included (admin only) */
  adminNudges: Array<AdminNudge>;
  /** Relationship co-emission retry backlog (admin only). All zeros in steady state - a non-zero pending that does not clear, or any failed, means the projection is behind the legacy roster */
  adminRelationshipEmissionOutbox: AdminRelationshipEmissionOutbox;
  /** Per-club projection-vs-roster reconciliation drift M1/M4 (+observed M2) (admin only). Pass clubId: the all-clubs form takes minutes and will time out - use the background job instead */
  adminRelationshipReconciliation: Array<AdminRelationshipReconciliationRow>;
  /** The drifting rows behind one club's M1/M4/M3 reconciliation counts, with both sides' values (admin only). Null when the club id is unknown */
  adminRelationshipReconciliationDetail?: Maybe<AdminRelationshipReconciliationDetail>;
  /** Current/last background projection-vs-roster reconciliation job (admin only) */
  adminRelationshipReconciliationJob?: Maybe<AdminRelationshipReconciliationJob>;
  /** Stored reconciliation sweeps, newest first (admin only). What a Phase 1 gate reading cites, and the same rows the relationship-runs debug report lists. Runs no sweep and recomputes nothing. A run stored from #4628's release onwards carries both design section 9.1 conditions; on an older row a condition reads null, which is UNKNOWN and not a pass */
  adminRelationshipReconciliationRuns: Array<AdminRelationshipReconciliationRun>;
  /** Registry-wide projection-vs-roster reconciliation totals (admin only). THE PHASE 1 EXIT IS phase1ConditionAMet AND phase1ConditionBMet (#4628). Condition B is unclassifiedPhase1Drift = 0 AND shapeCapOverflow empty (#4557): a guarded population over its cap leaves the count at 0 while the verdict is false, so do not read that count alone. Neither verdict is totalGateDrift, which also carries Phase 2's M3. Design section 9.1 states the rule and the run evaluates it inside its own snapshot (#3879). Runs inline and will time out on a large registry - use the background job in production */
  adminRelationshipReconciliationSummary: AdminRelationshipReconciliationSummary;
  /** Live thread-pool and database-pool capacity with queue depths, for the process answering this request (admin only). Instantaneous readings - a zero queue means nothing was waiting at that moment */
  adminRuntimeCapacity: AdminRuntimeCapacity;
  /** Speech rows the scheduling reconciler would create, move or cancel to agree with current requests and agendas (admin only). All zeros in steady state - a total that does not clear means the derivation is stuck */
  adminSpeechScheduleDrift: AdminSpeechScheduleDrift;
  /** Get system statistics including memory, properties, and configuration (admin only) */
  adminStats: AdminStats;
  /** Get database table record counts (admin only) */
  adminTableStats: Array<TableStat>;
  /** Get activation analytics for users entering unsubscribed clubs (admin only) */
  adminUsageAnalytics: AdminUsageAnalyticsDashboard;
  /** Get full user detail as serialized JSON (admin only) */
  adminUserDetail?: Maybe<Scalars["String"]["output"]>;
  /** Which pathway credits removing these agenda seats would withdraw — officer or manager access */
  agendaRemovalImpact?: Maybe<AgendaRemovalImpact>;
  /** Get a specific agenda template by ID (club templates require membership) */
  agendaTemplate?: Maybe<AgendaTemplate>;
  /** Get agenda templates for a club (includes global templates and default template ID) */
  agendaTemplates: AgendaTemplatesResponse;
  /** Get dashboard data for an area (public) */
  areaDashboard?: Maybe<AreaDashboardResponse>;
  /** Check if a club short name is available */
  checkShortNameAvailability: ShortNameAvailabilityResult;
  /** Get a club by its short name */
  club?: Maybe<Club>;
  /** Get paginated activity log for a club (requires officer access) */
  clubActivityLog: ActivityLogConnection;
  /** Get dashboard data for a club (public) */
  clubDashboard?: Maybe<ClubDashboardResponse>;
  /** Distinct member and guest addresses of the club that mail is no longer sent to (requires officer access) */
  clubEmailAddressesNotWorking: Scalars["Int"]["output"];
  /** What a club costs to run, how many members that needs, and how long its money lasts. Officers only */
  clubFinanceProjection: ClubFinanceProjection;
  /** The club's finance inputs as it entered them, for the form that edits them. Officers only */
  clubFinanceSettings: ClubFinanceSettings;
  /** Get guestbook configuration (requires officer access) */
  clubGuestbookConfig: GuestbookConfig;
  /** Get guestbook data including guests and found-us options (requires officer access) */
  clubGuestbookData: GuestbookData;
  /** Get clubs organized by district > division > area hierarchy (public) */
  clubHierarchy: Array<ClubHierarchyDistrict>;
  /** Get a club's numeric ID by its short name (public) */
  clubIdByShortName?: Maybe<Scalars["Int"]["output"]>;
  /** Get list of images for a club (requires officer access) */
  clubImages: Array<ClubImageMeta>;
  /** Get comprehensive club info by short name or c{clubNumber} alias (public, with extra data for officers) */
  clubInfo?: Maybe<ClubInfoResponse>;
  /** Get basic club info for guest registration page (public) */
  clubInfoForGuest?: Maybe<ClubGuestInfo>;
  /** Get all links for a club, sorted by display order */
  clubLinks: Array<ClubLink>;
  /** Get complete membership application details (requires club officer access) */
  clubMemberApplicationDetails?: Maybe<NewMemberApplicationDetails>;
  /** Get club member summaries for member selection (requires officer/manager access) */
  clubMemberSummaries: Array<ClubMemberSummary>;
  /** Get all members of a club (requires officer access) */
  clubMembers: Array<ClubMember>;
  /** Get a club's identifiers, location, and timezone by short name (cheaper than clubInfo) */
  clubMetaByShortName?: Maybe<ClubMeta>;
  /** Get pathway progress chart for all club members */
  clubPathwayChart: Array<PathwayChartRow>;
  /** Staged, unverified guestbook signings awaiting confirmation (requires officer access) */
  clubPendingGuestbookSubmissions: Array<PendingSubmission>;
  /** Staged, unverified membership applications awaiting confirmation (requires officer access) */
  clubPendingMembershipApplications: Array<PendingSubmission>;
  /** Get project signup requests for a club (members see own requests, officers see all) */
  clubProjectRequests: Array<ProjectSignupRequest>;
  /** Get the per-relationship history timeline for a (clubId, userId) — officer/manager access or self. */
  clubRelationshipTimeline: ClubRelationshipTimeline;
  /** Get role history chart data for a club (requires officer access) */
  clubRoleHistoryChart?: Maybe<RoleHistoryChartResponse>;
  /** Get subscription details for a club (requires officer access) */
  clubSubscription?: Maybe<ClubSubscription>;
  /** TI's website listing when it differs from the club's effective website (requires officer access) */
  clubTiWebsiteMismatch?: Maybe<TiWebsiteMismatch>;
  /** Get upcoming meeting dates with available speech slots for project scheduling */
  clubUpcomingMeetingDates: Array<MeetingDateInfo>;
  /** Get detailed web configuration for a club (requires officer access) */
  clubWebConfig?: Maybe<WebConfig>;
  /** Get a paginated list of clubs, optionally filtered by search term */
  clubs: ClubConnection;
  /** Get clubs dashboard data for a district grouped by division and area (requires district membership) */
  clubsDashboard?: Maybe<ClubsDashboard>;
  /** Live preview of recipients for a candidate broadcast audience (Phase 1F) */
  cotAudiencePreview: CotAudiencePreview;
  /** Real merge values for the broadcast composer's live preview (issue #2524) */
  cotBroadcastPreviewContext: CotBroadcastPreviewContext;
  /** List historical broadcasts for a COT session, newest first (Phase 1F) */
  cotBroadcasts: Array<CotBroadcast>;
  /** Get detailed completion status for a specific club in a COT round (requires district officer or admin) */
  cotClubDetail?: Maybe<CotClubDetail>;
  /** Get club-level completion summaries for a COT round (requires district officer or admin) */
  cotClubSummaries: Array<CotClubSummary>;
  /** Get a specific COT session with all registrations (requires district officer or admin) */
  cotEvent?: Maybe<CotEventDetail>;
  /** A single COT session scoped for the requesting officer */
  cotEventForOfficer?: Maybe<OfficerCotEventView>;
  /** Name and lock state of the round owning this event (requires district officer, event host, or admin) */
  cotEventRoundMeta?: Maybe<CotRoundMeta>;
  /** Get session summaries for a COT round (requires district officer or admin) */
  cotEvents: Array<CotEventSummary>;
  /** RFC 4180 CSV of external attendees from a given home district who registered for a session (Phase 2E) */
  cotExternalAttendeeCSV: Scalars["String"]["output"];
  /** Distinct home district numbers across non-cancelled external attendee registrations on a session (Phase 2E) */
  cotExternalAttendeeHomeDistricts: Array<Scalars["String"]["output"]>;
  /** The manual role assignment state of the MEMBER an officer record belongs to, with the opaque token naming it (#3571). Null when the round holds no such record. */
  cotMemberAssignmentState?: Maybe<CotMemberAssignmentState>;
  /** Get a specific officer record in a COT round (requires district officer or admin) */
  cotOfficer?: Maybe<CotClubOfficerRecord>;
  /** Whether setCOTOfficerNotOfficerMark would accept this record: false for a record merged into another, and for one the district's officer list names, directly or through a record merged into it. Does not read the round's lock. Null when the round holds no such record (#5709). */
  cotOfficerCanMarkNotOfficer?: Maybe<Scalars["Boolean"]["output"]>;
  /** Get a specific COT round by ID with full officer details (requires district officer or admin) */
  cotRound?: Maybe<CotRound>;
  /** Get all COT rounds for a district (requires district officer or admin) */
  cotRounds: Array<CotRound>;
  /** Get a specific session with attendance records (requires district officer or admin) */
  cotSession?: Maybe<CotSession>;
  /** Get sessions for a COT event (requires district officer or admin) */
  cotSessions: Array<CotSession>;
  /** Get a COT round's headline training figures, each naming the unit it counts (requires district officer or admin) */
  cotTrainingSummary?: Maybe<CotTrainingSummary>;
  /** Get active registrations (not cancelled, waitlisted or pending verification) that the matcher links to no single officer record and that are not marked as not an officer, or with markedNotOfficer the marked ones (requires district officer or admin) */
  cotUnmatchedAttendees: Array<CotUnmatchedAttendee>;
  /** Hierarchical view of all districts, divisions, areas, and clubs (public, cached) */
  dashboardHierarchy?: Maybe<Scalars["JSON"]["output"]>;
  /** Get dashboard overview with all district summaries */
  dashboardOverview?: Maybe<OverviewDashboardData>;
  /** Get DCP (Distinguished Club Program) overview statistics for a district (requires district membership) */
  dcpOverview?: Maybe<DcpOverview>;
  /** Get a district by ID */
  district?: Maybe<District>;
  /** A district's Club Officer Training activity feed (most recent first) */
  districtCotActivity: Array<CotActivityEntry>;
  /** Get full dashboard data for a district (public) */
  districtDashboard?: Maybe<DistrictDashboardResponse>;
  /** Get all active members in the district; identity is masked per the requester's district remit (requires district officer access) */
  districtMembers: Array<DistrictMember>;
  /** Get district officers with full details including user names (requires district membership) */
  districtOfficers: Array<DistrictOfficerDto>;
  /** Get all available districts (requires authentication) */
  districts: Array<District>;
  /** Get dashboard data for a division (public) */
  divisionDashboard?: Maybe<DivisionDashboardResponse>;
  /** EasySpeak instances a club mapping may name, with the name to show a person */
  easySpeakInstances: Array<EasySpeakInstanceOption>;
  /** A club's staged EasySpeak meetings, newest first, with each person's mapping (officers and managers of the club, and site administrators) */
  easySpeakMeetings: Array<EasySpeakMeeting>;
  /** Get the full education series catalog */
  educationSeriesCatalog: Array<EducationSeriesPresentation>;
  /** Get the list of found-us options for guest registration (public) */
  foundUsOptions: Array<FoundUsEntry>;
  /** Get feedback for a specific subject within a feedback session */
  getFeedbackForSubject: Array<Feedback>;
  /** Check if a club has an in-progress meeting and get its details */
  getInProgressMeeting: InProgressMeetingResponse;
  /** Get a single meeting user by identifier */
  getMeetingUser?: Maybe<MeetingUser>;
  /** Get votes for a specific user in a meeting */
  getUserVotes: Array<SimpleVote>;
  /** Get email recipient filter options (requires officer access) */
  guestbookEmailOptions: Array<GuestEmailOption>;
  /** A simple hello world query for testing */
  hello: Scalars["String"]["output"];
  /** The currently authenticated user */
  me?: Maybe<User>;
  /** Get a specific meeting by ID */
  meeting?: Maybe<Meeting>;
  /** Get the officer attendance management list for a meeting */
  meetingAttendanceRecords: Array<MeetingAttendanceMemberRecord>;
  /** Get RSVP and attendance summary counts for a meeting (members only) */
  meetingAttendanceSummary: MeetingAttendanceSummary;
  /** Get consolidated meeting initialization data (replaces multiple REST calls) */
  meetingInitData: MeetingInitData;
  /** Get the list of RSVP responses for a meeting (officers only) */
  meetingRsvpRecords: Array<MeetingRsvpRecord>;
  /** Get a paginated list of meetings for a club */
  meetings: MeetingConnection;
  /** Get detailed activity data for a specific member (requires officer access, feature flag gated) */
  memberActivityDetail?: Maybe<MemberActivityDetail>;
  /** Get member activity tracker data for a club (requires officer access, feature flag gated) */
  memberActivityTracker?: Maybe<MemberActivityTracker>;
  /** Get pathway enrollments for a club member (requires officer access) */
  memberPathwayEnrollments: Array<UserPathwayEnrollment>;
  /** Get aggregated pathway progress (enrollments, completions, project requests) for a club member. Officer access, or the member themselves. */
  memberPathwayProgress: MemberPathwayProgress;
  /** Get payment initialization data for member dues (public, action ID auth) */
  memberPaymentData: MemberPaymentData;
  /** Get membership statistics summary (requires officer access) */
  membersSummary?: Maybe<MembersSummary>;
  /** Get club membership configuration (requires officer access) */
  membershipConfig?: Maybe<MembershipConfig>;
  /** Get preview of membership emails (requires officer access) */
  membershipEmailPreview?: Maybe<MembershipEmailPreview>;
  /** Get membership fees preview (requires officer access) */
  membershipFeesPreview?: Maybe<MembershipFeesPreview>;
  /** The current user's self-asserted COT club roles (#2026) */
  myAssertedClubRoles: Array<CotOfficerClubRole>;
  /** Current user's COT session registrations across all sessions */
  myCOTRegistrations: Array<OfficerCotEventView>;
  /** The current user's club-officer roles derived from their live club positions (#2026) */
  myClubOfficerRoles: Array<CotOfficerClubRole>;
  /** Get the authenticated user's own project signup requests for a club */
  myClubProjectRequests: Array<ProjectSignupRequest>;
  /** Current user's Club Officer Training activity feed (most recent first) */
  myCotActivity: Array<CotActivityEntry>;
  /** Whether the current user has completed Level 2 of a path, which joining the Mentor Program needs */
  myMentorProgramPrerequisite: MentorProgramPrerequisite;
  /** Get current user's meeting participation records */
  myParticipationRecords: Array<MeetingParticipationRecord>;
  /** Get current authenticated user's pathway completion records */
  myPathwayCompletions: Array<PathwayCompletionRecord>;
  /** Get current authenticated user's pathway enrollments */
  myPathwayEnrollments: Array<UserPathwayEnrollment>;
  /** The signed-in member's scheduled speeches in a club, at meetings still to come, that no pending request names */
  myUpcomingSpeechesWithoutRequest: Array<UpcomingSpeech>;
  /** Get new member registration form information (public) */
  newMemberFormInfo: NewMemberFormInfo;
  /** Get a pathway by ID */
  pathway?: Maybe<Pathway>;
  /** Get pathway projects by their ids (scoped prose fetch companion to the structural catalog) */
  pathwayProjects: Array<PathwayProject>;
  /** Get all available Toastmasters pathways */
  pathways: Array<Pathway>;
  /** Get a preview of the periodic email for a club (requires officer access) */
  periodicEmailPreview?: Maybe<PeriodicEmailPreview>;
  /** Preview role management emails before sending (requires club officer or admin) */
  previewRoleEmail: EmailPreviewResponse;
  /** Get role proposals for a visible meeting */
  proposalsForMeeting: Array<RoleProposal>;
  /** Public, unauthenticated lookup of a Published COT session for the registration form */
  publicCOTEventForRegistration?: Maybe<PublicCotEventInfo>;
  /** Anonymous stats displayed on the public landing page */
  publicLandingStats: PublicLandingStats;
  /** Public, unauthenticated list of published COT sessions in a district for the calendar */
  publicPublishedCOTEvents: Array<PublicCotEventView>;
  /** Get completed meeting roles that may be linked to pathway role requirements */
  roleLinkCandidates: Array<RoleLinkCandidate>;
  /** Get active-enrollment pathway role requirements that can receive linked role credit */
  roleRequirementCandidates: Array<RoleRequirementCandidate>;
  /** Role-name spellings the alias map folds, with the key pathway role requirements match each by */
  roleRequirementMatchKeys: Array<RoleRequirementMatchKey>;
  /** Search for members within the requester's district remit by name or email (requires district officer access) */
  searchDistrictMembers: Array<DistrictMember>;
  /** Search members by name or email (requires officer access) */
  searchMembers: Array<ClubMember>;
  /** Search all Toastmasters International clubs by name or number */
  searchTIClubs: Array<TiClubSearchResult>;
  /** Get one speech with its member, meeting, placement and provenance resolved — officer/manager access or self. */
  speech?: Maybe<SpeechCard>;
  /** What re-pointing a speech would do to its credited progress, without committing it — officer/manager access or self. */
  speechEditImpact?: Maybe<SpeechEditImpact>;
  /** Get the speech linked to a pathway completion, if it has one — officer/manager access or self. */
  speechForCompletion?: Maybe<SpeechCard>;
  /** Speeches occupying agenda slots at these meetings, for surfaces that hold a slot rather than a speech or completion id — officer/manager access or self. */
  speechesForMeetings: Array<SpeechSlotRef>;
  /** Get a summary of subscription status for display (requires officer access) */
  subscriptionStatusSummary?: Maybe<SubscriptionStatusSummary>;
  /** Get available template variables for a template type */
  templateVariables: Array<TemplateVariable>;
  /** Get a user by ID (requires admin access or same user) */
  user?: Maybe<User>;
};

/** The root query type */
export type QueryActivePaidMembersArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryAdminBrowseGenericArgs = {
  typeName: Scalars["String"]["input"];
};

/** The root query type */
export type QueryAdminClubDetailArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryAdminContactManagerIndexCheckArgs = {
  clubId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The root query type */
export type QueryAdminDebugRepairPlanArgs = {
  id: Scalars["String"]["input"];
};

/** The root query type */
export type QueryAdminDetailGenericArgs = {
  id: Scalars["Long"]["input"];
  typeName: Scalars["String"]["input"];
};

/** The root query type */
export type QueryAdminEmailLogArgs = {
  clubId?: InputMaybe<Scalars["ID"]["input"]>;
  from?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Long"]["input"]>;
  offset?: InputMaybe<Scalars["Long"]["input"]>;
  recipient?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
  to?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root query type */
export type QueryAdminRelationshipReconciliationArgs = {
  clubId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The root query type */
export type QueryAdminRelationshipReconciliationDetailArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryAdminRelationshipReconciliationRunsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type */
export type QueryAdminUsageAnalyticsArgs = {
  clubId?: InputMaybe<Scalars["ID"]["input"]>;
  converted?: InputMaybe<Scalars["Boolean"]["input"]>;
  featureArea?: InputMaybe<Scalars["String"]["input"]>;
  from?: InputMaybe<Scalars["String"]["input"]>;
  officerOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  to?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root query type */
export type QueryAdminUserDetailArgs = {
  userId: Scalars["Long"]["input"];
};

/** The root query type */
export type QueryAgendaRemovalImpactArgs = {
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  seats: Array<AgendaSeatInput>;
};

/** The root query type */
export type QueryAgendaTemplateArgs = {
  templateId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryAgendaTemplatesArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryAreaDashboardArgs = {
  areaId: Scalars["String"]["input"];
  districtId: Scalars["ID"]["input"];
  divisionId: Scalars["String"]["input"];
};

/** The root query type */
export type QueryCheckShortNameAvailabilityArgs = {
  currentClubId?: InputMaybe<Scalars["Int"]["input"]>;
  shortName: Scalars["String"]["input"];
};

/** The root query type */
export type QueryClubArgs = {
  shortName: Scalars["String"]["input"];
};

/** The root query type */
export type QueryClubActivityLogArgs = {
  clubId: Scalars["ID"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type */
export type QueryClubDashboardArgs = {
  areaId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
  districtId: Scalars["ID"]["input"];
  divisionId: Scalars["String"]["input"];
};

/** The root query type */
export type QueryClubEmailAddressesNotWorkingArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryClubFinanceProjectionArgs = {
  clubId: Scalars["ID"]["input"];
  overrides?: InputMaybe<ClubFinanceOverridesInput>;
};

/** The root query type */
export type QueryClubFinanceSettingsArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryClubGuestbookConfigArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryClubGuestbookDataArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryClubIdByShortNameArgs = {
  shortName: Scalars["String"]["input"];
};

/** The root query type */
export type QueryClubImagesArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryClubInfoArgs = {
  shortName: Scalars["String"]["input"];
};

/** The root query type */
export type QueryClubInfoForGuestArgs = {
  clubShortName: Scalars["String"]["input"];
};

/** The root query type */
export type QueryClubLinksArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryClubMemberApplicationDetailsArgs = {
  actionId: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryClubMemberSummariesArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryClubMembersArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryClubMetaByShortNameArgs = {
  shortName: Scalars["String"]["input"];
};

/** The root query type */
export type QueryClubPathwayChartArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryClubPendingGuestbookSubmissionsArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryClubPendingMembershipApplicationsArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryClubProjectRequestsArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryClubRelationshipTimelineArgs = {
  clubId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryClubRoleHistoryChartArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryClubSubscriptionArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryClubTiWebsiteMismatchArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryClubUpcomingMeetingDatesArgs = {
  clubId: Scalars["ID"]["input"];
  monthsAhead?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type */
export type QueryClubWebConfigArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryClubsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root query type */
export type QueryClubsDashboardArgs = {
  districtId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryCotAudiencePreviewArgs = {
  audience: CotBroadcastAudienceInput;
  eventId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryCotBroadcastPreviewContextArgs = {
  eventId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryCotBroadcastsArgs = {
  eventId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryCotClubDetailArgs = {
  clubId: Scalars["ID"]["input"];
  cotId: Scalars["ID"]["input"];
  districtId: Scalars["String"]["input"];
};

/** The root query type */
export type QueryCotClubSummariesArgs = {
  cotId: Scalars["ID"]["input"];
  districtId: Scalars["String"]["input"];
};

/** The root query type */
export type QueryCotEventArgs = {
  eventId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryCotEventForOfficerArgs = {
  eventId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryCotEventRoundMetaArgs = {
  eventId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryCotEventsArgs = {
  cotId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryCotExternalAttendeeCsvArgs = {
  eventId: Scalars["ID"]["input"];
  homeDistrictNumber: Scalars["String"]["input"];
};

/** The root query type */
export type QueryCotExternalAttendeeHomeDistrictsArgs = {
  eventId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryCotMemberAssignmentStateArgs = {
  cotId: Scalars["ID"]["input"];
  districtId: Scalars["String"]["input"];
  recordId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryCotOfficerArgs = {
  cotId: Scalars["ID"]["input"];
  districtId: Scalars["String"]["input"];
  recordId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryCotOfficerCanMarkNotOfficerArgs = {
  cotId: Scalars["ID"]["input"];
  districtId: Scalars["String"]["input"];
  recordId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryCotRoundArgs = {
  cotId: Scalars["ID"]["input"];
  districtId: Scalars["String"]["input"];
};

/** The root query type */
export type QueryCotRoundsArgs = {
  districtId: Scalars["String"]["input"];
};

/** The root query type */
export type QueryCotSessionArgs = {
  sessionId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryCotSessionsArgs = {
  eventId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryCotTrainingSummaryArgs = {
  cotId: Scalars["ID"]["input"];
  districtId: Scalars["String"]["input"];
};

/** The root query type */
export type QueryCotUnmatchedAttendeesArgs = {
  cotId: Scalars["ID"]["input"];
  markedNotOfficer?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The root query type */
export type QueryDcpOverviewArgs = {
  districtId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryDistrictArgs = {
  districtId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryDistrictCotActivityArgs = {
  cotId?: InputMaybe<Scalars["String"]["input"]>;
  districtId: Scalars["String"]["input"];
  eventTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root query type */
export type QueryDistrictDashboardArgs = {
  districtId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryDistrictMembersArgs = {
  districtId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryDistrictOfficersArgs = {
  districtId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryDivisionDashboardArgs = {
  districtId: Scalars["ID"]["input"];
  divisionId: Scalars["String"]["input"];
};

/** The root query type */
export type QueryEasySpeakMeetingsArgs = {
  clubId: Scalars["ID"]["input"];
  mappingId?: InputMaybe<Scalars["Long"]["input"]>;
};

/** The root query type */
export type QueryGetFeedbackForSubjectArgs = {
  clubId: Scalars["ID"]["input"];
  feedbackSessionId: Scalars["String"]["input"];
  meetingId: Scalars["ID"]["input"];
  subjectId: Scalars["String"]["input"];
};

/** The root query type */
export type QueryGetInProgressMeetingArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryGetMeetingUserArgs = {
  clubId: Scalars["ID"]["input"];
  guestId?: InputMaybe<Scalars["String"]["input"]>;
  meetingId: Scalars["ID"]["input"];
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The root query type */
export type QueryGetUserVotesArgs = {
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  meetingUserIdGuestId?: InputMaybe<Scalars["String"]["input"]>;
  meetingUserIdUserId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The root query type */
export type QueryGuestbookEmailOptionsArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryMeetingArgs = {
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryMeetingAttendanceRecordsArgs = {
  clubId: Scalars["ID"]["input"];
  includeExpiredMembers?: InputMaybe<Scalars["Boolean"]["input"]>;
  meetingId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryMeetingAttendanceSummaryArgs = {
  clubId: Scalars["ID"]["input"];
  includeExpiredMembers?: InputMaybe<Scalars["Boolean"]["input"]>;
  meetingId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryMeetingInitDataArgs = {
  clubId: Scalars["ID"]["input"];
  includeAttendance?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeExpiredMembers?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeManagerAttendanceRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeMembers?: InputMaybe<Scalars["Boolean"]["input"]>;
  meetingId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The root query type */
export type QueryMeetingRsvpRecordsArgs = {
  clubId: Scalars["ID"]["input"];
  includeExpiredMembers?: InputMaybe<Scalars["Boolean"]["input"]>;
  meetingId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryMeetingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  clubId: Scalars["ID"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<MeetingStatus>;
};

/** The root query type */
export type QueryMemberActivityDetailArgs = {
  clubId: Scalars["ID"]["input"];
  memberUserId: Scalars["ID"]["input"];
  months?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type */
export type QueryMemberActivityTrackerArgs = {
  clubId: Scalars["ID"]["input"];
  months?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type */
export type QueryMemberPathwayEnrollmentsArgs = {
  clubId: Scalars["ID"]["input"];
  memberUserId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryMemberPathwayProgressArgs = {
  clubId: Scalars["ID"]["input"];
  memberUserId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryMemberPaymentDataArgs = {
  actionId: Scalars["String"]["input"];
  clubShortName: Scalars["String"]["input"];
};

/** The root query type */
export type QueryMembersSummaryArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryMembershipConfigArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryMembershipEmailPreviewArgs = {
  clubId: Scalars["ID"]["input"];
  draftLongExpiredText?: InputMaybe<Scalars["String"]["input"]>;
  draftNewMemberText?: InputMaybe<Scalars["String"]["input"]>;
  draftRenewalText?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root query type */
export type QueryMembershipFeesPreviewArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryMyClubProjectRequestsArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryMyCotActivityArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type */
export type QueryMyParticipationRecordsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type */
export type QueryMyPathwayCompletionsArgs = {
  pathwayId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type */
export type QueryMyUpcomingSpeechesWithoutRequestArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryNewMemberFormInfoArgs = {
  clubShortName: Scalars["String"]["input"];
};

/** The root query type */
export type QueryPathwayArgs = {
  pathwayId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryPathwayProjectsArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

/** The root query type */
export type QueryPeriodicEmailPreviewArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryPreviewRoleEmailArgs = {
  action: Scalars["String"]["input"];
  clubId: Scalars["ID"]["input"];
  meetingId: Scalars["ID"]["input"];
  personalNote?: InputMaybe<Scalars["String"]["input"]>;
  recipients: Array<EmailRecipientInput>;
  roleId: Scalars["String"]["input"];
};

/** The root query type */
export type QueryProposalsForMeetingArgs = {
  meetingId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryPublicCotEventForRegistrationArgs = {
  eventId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryPublicPublishedCotEventsArgs = {
  districtId: Scalars["String"]["input"];
};

/** The root query type */
export type QueryRoleLinkCandidatesArgs = {
  hideAlreadyLinked?: InputMaybe<Scalars["Boolean"]["input"]>;
  pathwayIds?: InputMaybe<Array<Scalars["Long"]["input"]>>;
  targetUserId: Scalars["Long"]["input"];
};

/** The root query type */
export type QueryRoleRequirementCandidatesArgs = {
  targetUserId: Scalars["Long"]["input"];
};

/** The root query type */
export type QuerySearchDistrictMembersArgs = {
  districtId: Scalars["ID"]["input"];
  query: Scalars["String"]["input"];
};

/** The root query type */
export type QuerySearchMembersArgs = {
  clubId: Scalars["ID"]["input"];
  searchTerm?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root query type */
export type QuerySearchTiClubsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  search: Scalars["String"]["input"];
};

/** The root query type */
export type QuerySpeechArgs = {
  speechId: Scalars["ID"]["input"];
};

/** The root query type */
export type QuerySpeechEditImpactArgs = {
  clearProjectLink?: InputMaybe<Scalars["Boolean"]["input"]>;
  completionId: Scalars["ID"]["input"];
  projectId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root query type */
export type QuerySpeechForCompletionArgs = {
  completionId: Scalars["ID"]["input"];
};

/** The root query type */
export type QuerySpeechesForMeetingsArgs = {
  meetingIds: Array<Scalars["ID"]["input"]>;
};

/** The root query type */
export type QuerySubscriptionStatusSummaryArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root query type */
export type QueryTemplateVariablesArgs = {
  clubId: Scalars["ID"]["input"];
  templateType: Scalars["String"]["input"];
};

/** The root query type */
export type QueryUserArgs = {
  userId: Scalars["ID"]["input"];
};

/** Result of a public guestbook signing */
export type RegisterGuestResult = {
  __typename: "RegisterGuestResult";
  /** Machine-readable failure code, when there is one */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The club meeting running when the guest signed, when there is one */
  meetingInProgress?: Maybe<GuestSigningMeeting>;
  /** Human-readable outcome */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Whether the signing was accepted */
  success: Scalars["Boolean"]["output"];
  /** True when the signing was staged and a verification link emailed; false when it is already official */
  verificationEmailSent: Scalars["Boolean"]["output"];
};

/** How a COT event registration entered the system */
export enum RegistrationSource {
  /** District admin entered the registration on behalf of an officer */
  DistrictEntry = "DISTRICT_ENTRY",
  /** Registration imported from an external CSV / TI export */
  ExternalImport = "EXTERNAL_IMPORT",
  /** Officer registered themselves via the in-app form */
  SelfService = "SELF_SERVICE",
}

/** Discriminator for a RelationshipEvent */
export enum RelationshipEventType {
  AdminCorrection = "ADMIN_CORRECTION",
  ApplicationExpired = "APPLICATION_EXPIRED",
  ApplicationSubmitted = "APPLICATION_SUBMITTED",
  GraceExpired = "GRACE_EXPIRED",
  GuestbookExpired = "GUESTBOOK_EXPIRED",
  GuestbookRemoved = "GUESTBOOK_REMOVED",
  GuestbookSigned = "GUESTBOOK_SIGNED",
  Lapsed = "LAPSED",
  MarkedNotRenewing = "MARKED_NOT_RENEWING",
  MembershipVotePassed = "MEMBERSHIP_VOTE_PASSED",
  MemberReinstated = "MEMBER_REINSTATED",
  MemberSuspended = "MEMBER_SUSPENDED",
  NotRenewingExpired = "NOT_RENEWING_EXPIRED",
  OfficerRoleAssigned = "OFFICER_ROLE_ASSIGNED",
  OfficerRoleElected = "OFFICER_ROLE_ELECTED",
  OfficerRoleVacated = "OFFICER_ROLE_VACATED",
  PaymentRecorded = "PAYMENT_RECORDED",
  PlacedOnWaitingList = "PLACED_ON_WAITING_LIST",
  Renewed = "RENEWED",
  ReApplied = "RE_APPLIED",
  WaitlistCleared = "WAITLIST_CLEARED",
}

/** Lifecycle state of a (User, Club) relationship */
export enum RelationshipState {
  /** Paid-up member */
  Active = "ACTIVE",
  /** Guestbook signed, not a member */
  Guest = "GUEST",
  /** No relationship */
  None = "NONE",
  /** Paid period expired, within grace */
  Overdue = "OVERDUE",
  /** Former member */
  PastMember = "PAST_MEMBER",
  /** Application submitted, awaiting first payment */
  Prospective = "PROSPECTIVE",
  /** Application submitted, awaiting a membership vote (reserved — not yet in use) */
  ProspectiveAwaitingVote = "PROSPECTIVE_AWAITING_VOTE",
  /** Application submitted, on the club waiting list (reserved — not yet in use) */
  ProspectiveOnWaitingList = "PROSPECTIVE_ON_WAITING_LIST",
  /** Officer-suspended; remains on roster but barred from participation */
  Suspended = "SUSPENDED",
}

/** A single event on a (User, Club) relationship */
export type RelationshipTimelineEvent = {
  __typename: "RelationshipTimelineEvent";
  /** When the fact happened (ISO-8601 instant), set only when the event was recorded later in the log than that (metadata.businessOccurredAt, membership-lifecycle-v2 §4.5.6a) */
  businessOccurredAt?: Maybe<Scalars["String"]["output"]>;
  eventType: RelationshipEventType;
  /** State before this event (None for the first state-changing event) */
  fromState?: Maybe<RelationshipState>;
  /** Event row ID */
  id: Scalars["ID"]["output"];
  /** True if this event was reconstructed by the WI-12 backfill (metadata.backfill) */
  isBackfill: Scalars["Boolean"]["output"];
  /** True if this event's date was inferred heuristically rather than from an authoritative source */
  isInferred: Scalars["Boolean"]["output"];
  /** The event's position in the log (ISO-8601 instant). Equals its business time unless businessOccurredAt is set */
  occurredAt: Scalars["String"]["output"];
  /** Paid-until date from payment/renewal events (ISO LocalDate) */
  paidUntil?: Maybe<Scalars["String"]["output"]>;
  /** Reason from metadata (officer-role vacated, admin corrections, etc.) */
  reason?: Maybe<Scalars["String"]["output"]>;
  /** When the row was written to the database (ISO-8601 instant) */
  recordedAt: Scalars["String"]["output"];
  /** Officer role from metadata (only set on officer_role_* events) */
  role?: Maybe<Scalars["String"]["output"]>;
  /** State after this event (None for non-state-changing events like officer roles) */
  toState?: Maybe<RelationshipState>;
  /** UserId of the officer who caused the event; null for system/self-service */
  triggeredByUserId?: Maybe<Scalars["ID"]["output"]>;
};

/** Status of a project signup request */
export enum RequestStatus {
  /** Request has been approved */
  Approved = "APPROVED",
  /** Request is pending approval */
  Pending = "PENDING",
  /** Request has been rejected */
  Rejected = "REJECTED",
}

/** Progress on a requirement type */
export type RequirementProgress = {
  __typename: "RequirementProgress";
  completed: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

/** Breakdown of participation by role type */
export type RoleBreakdownEntry = {
  __typename: "RoleBreakdownEntry";
  count: Scalars["Int"]["output"];
  lastDate: Scalars["String"]["output"];
  roleType: Scalars["String"]["output"];
};

/** Complete role history chart data for a club */
export type RoleHistoryChartResponse = {
  __typename: "RoleHistoryChartResponse";
  /** All role types ever seen in this club's data, regardless of hidden config. Used to drive the column picker UI. */
  allKnownRoleTypes: Array<Scalars["String"]["output"]>;
  /** Canonical role-type names the club has explicitly hidden, even when not currently in `allKnownRoleTypes`. Lets the column picker keep ghost entries so officer preferences stick across data gaps. */
  hiddenRoleHistoryRoleTypes: Array<Scalars["String"]["output"]>;
  /** Total roster members */
  membersTotal: Scalars["Int"]["output"];
  /** Count of members with at least one role */
  membersWithAnyRoles: Scalars["Int"]["output"];
  /** Canonical role type labels in preferred order */
  roleTypes: Array<Scalars["String"]["output"]>;
  /** Data for each member */
  rows: Array<RoleHistoryChartRow>;
};

/** Role history data for a single club member */
export type RoleHistoryChartRow = {
  __typename: "RoleHistoryChartRow";
  /** User ID */
  memberId: Scalars["ID"]["output"];
  /** Display name */
  memberName: Scalars["String"]["output"];
  /** Role statistics as list of entries */
  roleStats: Array<RoleHistoryStatEntry>;
};

/** Aggregated statistics for a single role type */
export type RoleHistoryRoleStat = {
  __typename: "RoleHistoryRoleStat";
  count: Scalars["Int"]["output"];
  lastDate: Scalars["String"]["output"];
  lastMeetingId?: Maybe<Scalars["String"]["output"]>;
};

/** A role type with its statistics */
export type RoleHistoryStatEntry = {
  __typename: "RoleHistoryStatEntry";
  roleType: Scalars["String"]["output"];
  stat: RoleHistoryRoleStat;
};

/** A completed meeting role that may be linked to a pathway role requirement */
export type RoleLinkCandidate = {
  __typename: "RoleLinkCandidate";
  /** Whether this participation is already linked */
  alreadyLinked: Scalars["Boolean"]["output"];
  /** Club ID */
  clubId: Scalars["Long"]["output"];
  /** Club name */
  clubName: Scalars["String"]["output"];
  /** Existing linked completion record, when present */
  linkedTo?: Maybe<PathwayCompletionRecordRef>;
  /** Meeting date in ISO format */
  meetingDate: Scalars["String"]["output"];
  /** Meeting ID */
  meetingId: Scalars["String"]["output"];
  /** Meeting participation record ID */
  participationId: Scalars["Long"]["output"];
  /** Agenda-item display text when distinct from the canonical role */
  roleDescription?: Maybe<Scalars["String"]["output"]>;
  /** Normalized role key */
  roleKey: Scalars["String"]["output"];
  /** Role display name */
  roleName: Scalars["String"]["output"];
};

/** A meeting role proposal from an officer to a member */
export type RoleProposal = {
  __typename: "RoleProposal";
  /** Agenda item identifier */
  agendaItemId: Scalars["ID"]["output"];
  /** Club identifier */
  clubId: Scalars["ID"]["output"];
  /** Creation timestamp as an ISO-8601 instant */
  createdAt: Scalars["String"]["output"];
  /** Expiry timestamp as an ISO-8601 instant */
  expiresAt: Scalars["String"]["output"];
  /** Proposal identifier */
  id: Scalars["ID"]["output"];
  /** Meeting identifier */
  meetingId: Scalars["ID"]["output"];
  /** Display name of the proposing officer */
  proposedByName: Scalars["String"]["output"];
  /** Officer role label used when the proposal was created */
  proposedByRoleLabel: Scalars["String"]["output"];
  /** User ID of the proposing officer */
  proposedByUserId: Scalars["ID"]["output"];
  /** Display name of the proposed member */
  proposedToName: Scalars["String"]["output"];
  /** User ID of the proposed member */
  proposedToUserId: Scalars["ID"]["output"];
  /** Response timestamp as an ISO-8601 instant */
  respondedAt?: Maybe<Scalars["String"]["output"]>;
  /** Zero-based slot index within the agenda item */
  slotIndex: Scalars["Int"]["output"];
  /** Current proposal status */
  status: RoleProposalStatus;
  /** Withdrawal timestamp as an ISO-8601 instant */
  withdrawnAt?: Maybe<Scalars["String"]["output"]>;
};

/** Result of a RoleProposal mutation */
export type RoleProposalResult = {
  __typename: "RoleProposalResult";
  /** The RoleProposal data if successful */
  data?: Maybe<RoleProposal>;
  /** Machine-readable code identifying the failure outcome */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable result message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Whether the mutation succeeded */
  success: Scalars["Boolean"]["output"];
};

/** Status of a meeting role proposal */
export enum RoleProposalStatus {
  /** Proposal was accepted */
  Accepted = "Accepted",
  /** Proposal was declined */
  Declined = "Declined",
  /** Proposal expired before a response */
  Expired = "Expired",
  /** Proposal notification failed to send */
  NotificationFailed = "NotificationFailed",
  /** Proposal has been created and the notification send is pending */
  PendingNotification = "PendingNotification",
  /** Proposal notification was sent and is awaiting a member response */
  PendingResponse = "PendingResponse",
  /** Proposal was withdrawn by an officer */
  Withdrawn = "Withdrawn",
}

/** Status of a role signup request */
export enum RoleRequestStatus {
  /** Request has been approved */
  Approved = "APPROVED",
  /** Request is pending approval */
  Pending = "PENDING",
  /** Request has been rejected */
  Rejected = "REJECTED",
}

/** A pathway role requirement that can accept linked meeting role credit */
export type RoleRequirementCandidate = {
  __typename: "RoleRequirementCandidate";
  /** Already completed count */
  doneCount: Scalars["Int"]["output"];
  /** Pathway level */
  level: Scalars["Int"]["output"];
  /** Member's status on this whole level: COMPLETED, IN_PROGRESS or NOT_STARTED */
  levelStatus: Scalars["String"]["output"];
  /** Pathway ID */
  pathwayId: Scalars["Long"]["output"];
  /** Pathway name */
  pathwayName: Scalars["String"]["output"];
  /** True when this role's quota is currently satisfied (by this role or by sibling roles in the same multi-role quota) */
  quotaSatisfied: Scalars["Boolean"]["output"];
  /** Required minimum count */
  requiredMinimum: Scalars["Int"]["output"];
  /** Requirement source: quota or residual */
  requirementSource: Scalars["String"]["output"];
  /** Normalized role key */
  roleKey: Scalars["String"]["output"];
  /** Role display name */
  roleName: Scalars["String"]["output"];
  /** All accepted role aliases for this row (tooltip source) */
  roleNames: Array<Scalars["String"]["output"]>;
};

/** A role-name spelling the alias map folds, and the key pathway role requirements compare it by */
export type RoleRequirementMatchKey = {
  __typename: "RoleRequirementMatchKey";
  /** The requirement match key. Two role names meet each other when their keys are equal */
  matchKey: Scalars["String"]["output"];
  /** The role name, normalised: lower case, single-spaced, the Table Topic prefix folded */
  spelling: Scalars["String"]["output"];
};

/** A request from a member to be assigned to a meeting role */
export type RoleSignupRequest = {
  __typename: "RoleSignupRequest";
  /** Timestamp when request was approved */
  approvedAt?: Maybe<Scalars["String"]["output"]>;
  /** User who approved the request */
  approvedBy?: Maybe<MeetingUser>;
  /** Request identifier */
  id: Scalars["ID"]["output"];
  /** Reason for rejection */
  rejectionReason?: Maybe<Scalars["String"]["output"]>;
  /** Timestamp when request was made */
  requestedAt: Scalars["String"]["output"];
  /** User who made the request */
  requestedBy: MeetingUser;
  /** Current status of the request */
  status: RoleRequestStatus;
  /** ID of the requesting user */
  userId: Scalars["ID"]["output"];
};

/** RSVP status declared by a member */
export enum RsvpStatus {
  /** Member plans to attend */
  Attending = "ATTENDING",
  /** Member might attend */
  Maybe = "MAYBE",
  /** Member does not plan to attend */
  NotAttending = "NOT_ATTENDING",
}

/** Result of checking short name availability */
export type ShortNameAvailabilityResult = {
  __typename: "ShortNameAvailabilityResult";
  /** Whether the short name is available for use */
  available: Scalars["Boolean"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
};

/** Simple mutation result without data payload */
export type SimpleResult = {
  __typename: "SimpleResult";
  errorCode?: Maybe<Scalars["String"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

/** A vote cast by a user in a voting room */
export type SimpleVote = {
  __typename: "SimpleVote";
  /** Candidate identifier */
  candidateId: Scalars["ID"]["output"];
  /** Vote identifier */
  id: Scalars["ID"]["output"];
  /** When the vote was cast (epoch millis) */
  timestamp: Scalars["Long"]["output"];
  /** Voting room identifier */
  votingRoomId: Scalars["ID"]["output"];
};

/** One speaker slot in a reorder op; list order is the desired order */
export type SpeakerReorderSlotInput = {
  /** Agenda item holding this slot */
  agendaItemId: Scalars["String"]["input"];
  /** Occupant of the slot, if any */
  occupant?: InputMaybe<MeetingUserInput>;
};

/** One speech with its member, meeting, placement and provenance resolved */
export type SpeechCard = {
  __typename: "SpeechCard";
  /** Agenda slot the speech was placed in */
  agendaItemId?: Maybe<Scalars["String"]["output"]>;
  /** Club the speech belongs to */
  clubId: Scalars["ID"]["output"];
  /** When the speech row was created — absent when there is no row */
  createdAt?: Maybe<Scalars["String"]["output"]>;
  /** When the speech was delivered */
  deliveredAt?: Maybe<Scalars["String"]["output"]>;
  /** Every recorded change to this speech, newest first. Empty for a speech whose row was never written. */
  history: Array<SpeechChangeEntry>;
  /** Speech ID — the identifier a speech keeps for its whole life. Absent for a credit whose speech row was never written, which the card renders from the completion instead. */
  id?: Maybe<Scalars["ID"]["output"]>;
  /** True when the speech sits in a slot at a meeting */
  isPlaced: Scalars["Boolean"]["output"];
  /** The meeting the speech was given at. Absent for a credit recorded by hand, and for a meeting deleted since delivery — the speech survives either way. */
  meeting?: Maybe<SpeechMeeting>;
  /** Display name of the member who gave the speech, masked to the viewer's tier */
  memberName?: Maybe<Scalars["String"]["output"]>;
  /** Where the speech is applied. Absent until the speech is credited. */
  placement?: Maybe<SpeechPlacement>;
  /** How the credit came to exist. Absent until the speech is credited. */
  provenance?: Maybe<SpeechProvenance>;
  /** Where the speech has got to */
  status: SpeechStatus;
  /** Speech title as it stands now — the speech's own setting once it has one, otherwise the credit, the request or the agenda slot it is resolved from */
  title?: Maybe<Scalars["String"]["output"]>;
  /** When the speech row last changed — absent when there is no row */
  updatedAt?: Maybe<Scalars["String"]["output"]>;
  /** Member who gave the speech */
  userId: Scalars["ID"]["output"];
};

/** Result of a SpeechCard mutation */
export type SpeechCardResult = {
  __typename: "SpeechCardResult";
  /** The SpeechCard data if successful */
  data?: Maybe<SpeechCard>;
  /** Machine-readable code identifying the failure outcome */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** Human-readable result message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Whether the mutation succeeded */
  success: Scalars["Boolean"]["output"];
};

/** One recorded change to a speech, with who made it and what moved */
export type SpeechChangeEntry = {
  __typename: "SpeechChangeEntry";
  /** Display name of the user who made the change, masked to the viewer's tier. Absent when a system process made it. */
  actorName?: Maybe<Scalars["String"]["output"]>;
  /** The system process that made the change, absent when a user did */
  actorProcess?: Maybe<Scalars["String"]["output"]>;
  /** The user who made the change, absent when a system process did */
  actorUserId?: Maybe<Scalars["ID"]["output"]>;
  /** The fields that moved; a field absent from this list was not touched */
  changes: Array<SpeechFieldChange>;
  /** What kind of change this entry records */
  eventType: SpeechChangeKind;
  /** Durable domain-event id */
  id: Scalars["ID"]["output"];
  /** When the change happened */
  occurredAt: Scalars["String"]["output"];
  /** Whether the change was witnessed or inferred from state afterwards */
  provenance: SpeechChangeProvenance;
  /** What brought the change about, where the writer could determine it */
  reason: SpeechChangeReason;
};

/** What kind of change a speech-history entry records */
export enum SpeechChangeKind {
  /** The speech row came into existence */
  Created = "CREATED",
  /** Someone changed the credit the delivered speech carries */
  CreditCorrected = "CREDIT_CORRECTED",
  /** Someone withdrew the credit, and the speech was cancelled rather than deleted */
  CreditWithdrawn = "CREDIT_WITHDRAWN",
  /** The speech was given and credited */
  Delivered = "DELIVERED",
  /** The record as it stood when the durable log first covered this speech; how it got there was not observed */
  Reconstructed = "RECONSTRUCTED",
  /** The speech was placed, requeued, cancelled, or lost the seat it held */
  ScheduleChanged = "SCHEDULE_CHANGED",
  /** Someone changed the speech's own title or project */
  SettingsChanged = "SETTINGS_CHANGED",
}

/** How the emitter knows the change happened */
export enum SpeechChangeProvenance {
  /** A sweep inferred the change from state afterwards; the before value is what it found */
  Derived = "DERIVED",
  /** The emitter was on the path that made the change */
  Observed = "OBSERVED",
}

/** What brought a speech-history entry's change about */
export enum SpeechChangeReason {
  /** Somebody corrected what an existing credit says was awarded */
  CreditCorrection = "CREDIT_CORRECTION",
  /** A credit was attached to the speech */
  CreditRecorded = "CREDIT_RECORDED",
  /** Somebody took an existing credit away */
  CreditWithdrawal = "CREDIT_WITHDRAWAL",
  /** The fact was carried onto this log from the store that recorded it, rather than observed here */
  HistoricalBackfill = "HISTORICAL_BACKFILL",
  /** Somebody deleted the meeting the speech names; the speech keeps it */
  MeetingDeleted = "MEETING_DELETED",
  /** The member asked for the speech, and this row came from that request */
  MemberRequested = "MEMBER_REQUESTED",
  /** An officer declined every date the member offered */
  RequestDeclined = "REQUEST_DECLINED",
  /** This speech was created when the request was pointed away from another member */
  RetargetedFromOtherMember = "RETARGETED_FROM_OTHER_MEMBER",
  /** The seat was taken over for another member, so this speech stood down */
  RetargetedToOtherMember = "RETARGETED_TO_OTHER_MEMBER",
  /** Somebody edited the speech's own title or project */
  SettingsEdited = "SETTINGS_EDITED",
  /** A sweep derived the change from current request and agenda state; no cause was observable */
  SystemReconciliation = "SYSTEM_RECONCILIATION",
}

/** A credit already standing on a project, named before a correction adds another */
export type SpeechCreditOnProject = {
  __typename: "SpeechCreditOnProject";
  /** When this credit was recorded as completed */
  completedDate: Scalars["String"]["output"];
  /** The pathway completion record carrying this credit */
  completionId: Scalars["ID"]["output"];
  /** The speech's title as credited, where one was recorded */
  creditedTitle?: Maybe<Scalars["String"]["output"]>;
  /** Level the credit is applied at */
  level: Scalars["Int"]["output"];
  /** Meeting the credit came from, absent for a manual or imported entry */
  meetingId?: Maybe<Scalars["ID"]["output"]>;
};

/** A part of a speech's credit that an edit would change */
export enum SpeechEditField {
  /** The credit would change between a speech and an education-series presentation */
  CompletionType = "COMPLETION_TYPE",
  /** The credit would be applied at a different level */
  Level = "LEVEL",
  /** The credit would move to a different pathway */
  Pathway = "PATHWAY",
  /** The credit would satisfy a different project */
  Project = "PROJECT",
}

/** What an edit would do to a speech's credit, before it commits */
export type SpeechEditImpact = {
  __typename: "SpeechEditImpact";
  /** Which parts of the credit would change */
  changedFields: Array<SpeechEditField>;
  /** True when the edit moves the credit — a title-only edit is false */
  changesCreditedProgress: Scalars["Boolean"]["output"];
  /** Opaque token naming the edit this warning describes. Pass it back as updateSpeechCompletion's confirmationToken so the write is refused unless it is about to make this same edit to this same speech. */
  confirmationToken: Scalars["String"]["output"];
  /** Credits this member already holds on the project the edit would move onto, oldest first, excluding this one. The edit adds another and withdraws none of them; an empty list means the project carries no other credit. */
  creditsOnTargetProject: Array<SpeechCreditOnProject>;
  /** Where the credit sits now */
  current: SpeechPlacement;
  /** Where the edit would put it */
  proposed: SpeechPlacement;
};

/** One field of a speech that moved, with the value before and the value after */
export type SpeechFieldChange = {
  __typename: "SpeechFieldChange";
  /** Which field moved — status, meetingId, agendaItemId, projectId, level, ... */
  field: Scalars["String"]["output"];
  /** The value before the change, null where there was none */
  from?: Maybe<Scalars["JSON"]["output"]>;
  /** The value after the change, null where the field was cleared */
  to?: Maybe<Scalars["JSON"]["output"]>;
};

/** A speech given by a member */
export type SpeechHistoryEntry = {
  __typename: "SpeechHistoryEntry";
  /** Pathway completion this speech was credited to, if any — what the speech card is addressed by */
  completionId?: Maybe<Scalars["ID"]["output"]>;
  /** Date of the speech */
  date: Scalars["String"]["output"];
  /** ID of the meeting where speech was given */
  meetingId: Scalars["ID"]["output"];
  /** Title of the speech */
  title?: Maybe<Scalars["String"]["output"]>;
};

/** The meeting a speech was given at, enough to label it and link to it */
export type SpeechMeeting = {
  __typename: "SpeechMeeting";
  /** Club that held the meeting */
  clubId: Scalars["ID"]["output"];
  /** Meeting date and time */
  datetime: Scalars["String"]["output"];
  /** Meeting ID */
  meetingId: Scalars["ID"]["output"];
  /** Meeting status */
  status: MeetingStatus;
  /** Meeting theme */
  theme?: Maybe<Scalars["String"]["output"]>;
  /** Meeting title */
  title: Scalars["String"]["output"];
};

/** Where a delivered speech is applied in the member's education programme */
export type SpeechPlacement = {
  __typename: "SpeechPlacement";
  /** Whether this was credited as a speech or an education-series presentation */
  completionType: CompletionType;
  /** True when the project id names an education-series presentation */
  isEducationSeries: Scalars["Boolean"]["output"];
  /** Level the credit was applied at, which can differ from the project's own level */
  level: Scalars["Int"]["output"];
  /** Pathway the credit landed on */
  pathwayId: Scalars["Int"]["output"];
  /** Pathway name, absent if the catalogue no longer lists it */
  pathwayName?: Maybe<Scalars["String"]["output"]>;
  /** Project ID */
  projectId?: Maybe<Scalars["String"]["output"]>;
  /** Project or education-series name */
  projectName?: Maybe<Scalars["String"]["output"]>;
};

/** How the credit came to exist — what tells an officer whether a surprising placement was a choice, an import, or a mistake */
export type SpeechProvenance = {
  __typename: "SpeechProvenance";
  /** When the speech was credited as completed */
  completedDate: Scalars["String"]["output"];
  /** The pathway completion record carrying this credit */
  completionId: Scalars["ID"]["output"];
  /** How the credit was recorded (AUTO_FROM_MEETING, MANUAL_OFFICER_ENTRY, MIGRATION_IMPORT, ...) */
  creditMethod: Scalars["String"]["output"];
  /** User who recorded the credit */
  creditedBy: Scalars["ID"]["output"];
  /** Display name of the user who recorded the credit, masked to the viewer's tier */
  creditedByName?: Maybe<Scalars["String"]["output"]>;
  /** The speech's title as credited. Differs from the card's own title once a correction has renamed the speech, because a correction records the new title on the speech and leaves the credit standing. */
  creditedTitle?: Maybe<Scalars["String"]["output"]>;
  /** Officer notes on the credit */
  notes?: Maybe<Scalars["String"]["output"]>;
};

/** The speech occupying one agenda slot, enough to open its card */
export type SpeechSlotRef = {
  __typename: "SpeechSlotRef";
  /** Agenda slot the speech was placed in */
  agendaItemId?: Maybe<Scalars["String"]["output"]>;
  /** Club the speech belongs to */
  clubId: Scalars["ID"]["output"];
  /** Pathway completion carrying the credit, once the speech has been credited */
  completionId?: Maybe<Scalars["ID"]["output"]>;
  /** Speech ID — what the card is addressed by */
  id: Scalars["ID"]["output"];
  /** Meeting the slot belongs to */
  meetingId: Scalars["ID"]["output"];
  /** Where the speech has got to */
  status: SpeechStatus;
  /** Member whose speech it is */
  userId: Scalars["ID"]["output"];
};

/** Where a speech has got to, from requested through to credited */
export enum SpeechStatus {
  /** Withdrawn by the member, or the slot was cleared by an officer */
  Cancelled = "CANCELLED",
  /** Given, and credited */
  Delivered = "DELIVERED",
  /** A member has asked for a project — no meeting or slot yet */
  Requested = "REQUESTED",
  /** Placed in a speaker slot at a meeting */
  Scheduled = "SCHEDULED",
}

/** Speech timing limits for a project */
export type SpeechTimings = {
  __typename: "SpeechTimings";
  amberSeconds: Scalars["Int"]["output"];
  greenSeconds: Scalars["Int"]["output"];
  redSeconds: Scalars["Int"]["output"];
};

/** The root subscription type */
export type Subscription = {
  __typename: "Subscription";
  /** Subscribe to real-time chat updates (replaces the SSE stream) */
  chatUpdates: ChatUpdateEvent;
  /** Subscribe to real-time meeting updates across a whole club (replaces the club-wide SSE stream) */
  clubMeetingUpdates: MeetingUpdateEvent;
  /** Subscribe to real-time meeting updates (replaces SSE) */
  meetingUpdates: MeetingUpdateEvent;
};

/** The root subscription type */
export type SubscriptionChatUpdatesArgs = {
  chatId: Scalars["ID"]["input"];
  nickname: Scalars["String"]["input"];
  sessionId: Scalars["String"]["input"];
};

/** The root subscription type */
export type SubscriptionClubMeetingUpdatesArgs = {
  clubId: Scalars["ID"]["input"];
};

/** The root subscription type */
export type SubscriptionMeetingUpdatesArgs = {
  meetingId: Scalars["ID"]["input"];
};

/** Current subscription status */
export enum SubscriptionStatus {
  /** Active paid subscription */
  Active = "ACTIVE",
  /** Subscription cancelled */
  Cancelled = "CANCELLED",
  /** Scheduled for cancellation */
  Cancelling = "CANCELLING",
  /** Payment failed, in grace period */
  GracePeriod = "GRACE_PERIOD",
  /** No subscription */
  NotSubscribed = "NOT_SUBSCRIBED",
  /** In trial period */
  Trial = "TRIAL",
}

/** Summary of subscription status for display */
export type SubscriptionStatusSummary = {
  __typename: "SubscriptionStatusSummary";
  /** Billing frequency */
  billingFrequency: BillingFrequency;
  /** Days remaining in trial or grace period */
  daysRemaining?: Maybe<Scalars["Int"]["output"]>;
  /** Currently enabled features */
  enabledFeatures: Array<ClubFeatureType>;
  /** Grace period end date (ISO format) */
  gracePeriodEndDate?: Maybe<Scalars["String"]["output"]>;
  /** Whether a payment method is attached */
  hasPaymentMethod: Scalars["Boolean"]["output"];
  /** Whether this is a pioneer club */
  isPioneer: Scalars["Boolean"]["output"];
  /** Next billing date (ISO format) */
  nextBillingDate?: Maybe<Scalars["String"]["output"]>;
  /** Current subscription state */
  state: Scalars["String"]["output"];
};

/** ToastHost payment notification status */
export enum ThStatus {
  /** Normal state */
  None = "NONE",
  /** Received payment notification */
  NotifiedAsPaid = "NOTIFIED_AS_PAID",
  /** Member not renewing */
  NotRenewing = "NOT_RENEWING",
}

/** A club from the Toastmasters International directory */
export type TiClubSearchResult = {
  __typename: "TIClubSearchResult";
  area: Scalars["String"]["output"];
  city?: Maybe<Scalars["String"]["output"]>;
  clubName: Scalars["String"]["output"];
  clubNumber: Scalars["Int"]["output"];
  clubShortName?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  district: Scalars["String"]["output"];
  division: Scalars["String"]["output"];
  isOnToastHost: Scalars["Boolean"]["output"];
  /** Club is listed by TI as prospective (being formed, not yet chartered/activated) */
  isProspective: Scalars["Boolean"]["output"];
  meetingDay?: Maybe<Scalars["String"]["output"]>;
};

/** Toastmasters International sync status */
export enum TiStatus {
  /** Present and active in TI */
  Active = "ACTIVE",
  /** Expired in TI records */
  Expired = "EXPIRED",
  /** Not in TI records */
  Missing = "MISSING",
}

/** A disagreement between the club's website in ToastHost and the one listed by Toastmasters International */
export type TiWebsiteMismatch = {
  __typename: "TIWebsiteMismatch";
  /** The website ToastHost shows for the club */
  effectiveUrl: Scalars["String"]["output"];
  /** The website Toastmasters International lists for the club */
  tiUrl: Scalars["String"]["output"];
};

/** Database table statistics */
export type TableStat = {
  __typename: "TableStat";
  count: Scalars["Long"]["output"];
  tableName: Scalars["String"]["output"];
};

export type TemplateVariable = {
  __typename: "TemplateVariable";
  description: Scalars["String"]["output"];
  exampleValue: Scalars["String"]["output"];
  isHtml: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  required: Scalars["Boolean"]["output"];
};

/** A standard Toastmaster role that can be assigned in meetings */
export type ToastmasterRole = {
  __typename: "ToastmasterRole";
  /** Time in seconds when amber signal shows */
  amberMark?: Maybe<Scalars["Int"]["output"]>;
  /** Description of role responsibilities */
  description: Scalars["String"]["output"];
  /** Time in seconds when green signal shows */
  greenMark?: Maybe<Scalars["Int"]["output"]>;
  /** Icon for the role */
  icon?: Maybe<Scalars["String"]["output"]>;
  /** Role ID */
  id: Scalars["ID"]["output"];
  /** Role name (e.g., Toastmaster, Timer) */
  name: Scalars["String"]["output"];
  /** Time in seconds when red signal shows */
  redMark?: Maybe<Scalars["Int"]["output"]>;
  /** Whether each agenda row of this role holds its own person rather than every row sharing one. Decides a role's first row only */
  repeatable: Scalars["Boolean"]["output"];
};

/** A scheduled speech at a meeting still to come, which no pending request names */
export type UpcomingSpeech = {
  __typename: "UpcomingSpeech";
  /** Agenda slot the speech is scheduled in */
  agendaItemId?: Maybe<Scalars["String"]["output"]>;
  /** Club the speech belongs to */
  clubId: Scalars["ID"]["output"];
  /** Speech ID */
  id: Scalars["ID"]["output"];
  /** Meeting the speech is scheduled at */
  meeting: SpeechMeeting;
  /** Pathways project ID */
  projectId?: Maybe<Scalars["String"]["output"]>;
  /** Speech title */
  title?: Maybe<Scalars["String"]["output"]>;
};

/** A ToastHost user */
export type User = {
  __typename: "User";
  /** URL to the user's avatar image */
  avatarUrl?: Maybe<Scalars["String"]["output"]>;
  /** Whether the user is enrolled as a beta tester */
  betaTester: Scalars["Boolean"]["output"];
  /** The user's display name, masked to the viewer's tier for the parent scope */
  displayName: Scalars["String"]["output"];
  /** The user's email address, masked to the viewer's tier for the parent scope */
  email?: Maybe<Scalars["String"]["output"]>;
  /** The user's first name */
  firstName: Scalars["String"]["output"];
  /** Whether the user has access to beta features (admin or betaTester) */
  hasBetaAccess: Scalars["Boolean"]["output"];
  /** The user's unique identifier */
  id?: Maybe<Scalars["ID"]["output"]>;
  /** Whether the user is a system administrator */
  isAdmin: Scalars["Boolean"]["output"];
  /** The user's last name */
  lastName: Scalars["String"]["output"];
  /** Clubs this user is a member of */
  memberOf: Array<Club>;
  /** Clubs this user is an officer of */
  officerOf: Array<Club>;
  /** Whether this user is enrolled in Pathways */
  pathwaysEnrolled: Scalars["Boolean"]["output"];
  /** TI-canonical "First Last", shown to officers/self only when a display-name override is set */
  tiName?: Maybe<Scalars["String"]["output"]>;
};

/** A user's enrollment in a pathway */
export type UserPathwayEnrollment = {
  __typename: "UserPathwayEnrollment";
  /** Date pathway was completed */
  completedDate?: Maybe<Scalars["String"]["output"]>;
  /** Current level reached */
  currentLevel: Scalars["Int"]["output"];
  /** Date enrolled */
  enrolledDate: Scalars["String"]["output"];
  /** The enrolled pathway details */
  pathway?: Maybe<Pathway>;
  /** Enrolled pathway ID */
  pathwayId: Scalars["Int"]["output"];
};

/** A candidate in a voting room */
export type VoteCandidate = {
  __typename: "VoteCandidate";
  /** Stable agenda participant sync key when this candidate was created from agenda sync */
  agendaSyncKey?: Maybe<Scalars["String"]["output"]>;
  /** Candidate identifier */
  id: Scalars["ID"]["output"];
  /** Composite user/guest identifier for agenda-linked candidates */
  meetingUserId?: Maybe<MeetingUserId>;
  /** Candidate name */
  name: Scalars["String"]["output"];
};

/** Vote count for a candidate */
export type VoteCount = {
  __typename: "VoteCount";
  /** Candidate identifier */
  candidateId: Scalars["ID"]["output"];
  /** Number of votes */
  count: Scalars["Int"]["output"];
};

/** A voting room in a meeting */
export type VotingRoom = {
  __typename: "VotingRoom";
  /** Candidates in this voting room */
  candidates: Array<VoteCandidate>;
  /**
   * Stable category slug for built-in voting rooms (e.g. 'best_speaker'); custom rooms fall back to displayName.
   * @deprecated Use standardKey + displayName instead
   */
  category: Scalars["String"]["output"];
  /** Display name for this voting room */
  displayName: Scalars["String"]["output"];
  /** Voting room identifier */
  id: Scalars["ID"]["output"];
  /** Whether voting is currently open */
  isOpen: Scalars["Boolean"]["output"];
  /** Stable key for built-in voting categories; custom rooms have no standard key */
  standardKey?: Maybe<Scalars["String"]["output"]>;
  /** Vote counts per candidate (officers can see live counts; members see counts only when room is closed) */
  voteCounts: Array<VoteCount>;
};

/** Club website configuration with all settings */
export type WebConfig = {
  __typename: "WebConfig";
  /** Background image filename */
  backgroundImage?: Maybe<Scalars["String"]["output"]>;
  /** External club URL (if externally hosted) */
  clubUrl?: Maybe<Scalars["String"]["output"]>;
  /** Custom domain name */
  domainName?: Maybe<Scalars["String"]["output"]>;
  /** Whether the website is enabled */
  enabled: Scalars["Boolean"]["output"];
  /** Eventbrite page link */
  eventbriteLink?: Maybe<Scalars["String"]["output"]>;
  /** Facebook page link */
  facebookLink?: Maybe<Scalars["String"]["output"]>;
  /** Website hosting option */
  hostingOption: HostingOption;
  /** Website images */
  images: Array<ClubImageMeta>;
  /** Instagram profile link */
  instagramLink?: Maybe<Scalars["String"]["output"]>;
  /** Introduction text for the website */
  introductionText: Scalars["String"]["output"];
  /** LinkedIn page link */
  linkedInLink?: Maybe<Scalars["String"]["output"]>;
  /** Short location description */
  locationShortDesc?: Maybe<Scalars["String"]["output"]>;
  /** Logo image filename */
  logoImage?: Maybe<Scalars["String"]["output"]>;
  /** Link to map/directions */
  mapLink?: Maybe<Scalars["String"]["output"]>;
  /** Meeting times description */
  meetingTimes?: Maybe<Scalars["String"]["output"]>;
  /** Meetup group link */
  meetupLink?: Maybe<Scalars["String"]["output"]>;
  /** Meta description for SEO */
  metaDesc?: Maybe<Scalars["String"]["output"]>;
  /** Club tagline */
  tagLine: Scalars["String"]["output"];
  /** Twitter profile link */
  twitterLink?: Maybe<Scalars["String"]["output"]>;
  /** YouTube channel link */
  youtubeLink?: Maybe<Scalars["String"]["output"]>;
};

/** Result of a WebConfig mutation */
export type WebConfigResult = {
  __typename: "WebConfigResult";
  /** The WebConfig data if successful */
  data?: Maybe<WebConfig>;
  /** Human-readable result message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Whether the hosting refresh failed after saving */
  refreshFailed: Scalars["Boolean"]["output"];
  /** Whether the mutation succeeded */
  success: Scalars["Boolean"]["output"];
};
